// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client'
import { client } from './client.gen'
import {
    deleteInterviewsIdInterviewRoundInterviewRoundIdResponseTransformer,
    getAdminCompaniesIdCreditsLedgerResponseTransformer,
    getAdminCompaniesIdResponseTransformer,
    getAdminCompaniesResponseTransformer,
    getAuthMyCompaniesResponseTransformer,
    getCompanyCompanySlugDepartmentsResponseTransformer,
    getInterviewsIdResponseTransformer,
    getInterviewsResponseTransformer,
    getJobApproversResponseTransformer,
    getOffersApproveResponseTransformer,
    getOffersResponseTransformer,
    getSettingsCommunicationTemplatesIdResponseTransformer,
    getTemporalIntegrationsResponseTransformer,
    getTemporalScreeningCallResponseTransformer,
    patchAdminCompaniesIdArchiveResponseTransformer,
    patchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryResponseTransformer,
    postAdminOrganizationsResponseTransformer,
    postCompanyConfigResponseTransformer,
    postInterviewsIdInterviewRoundResponseTransformer,
    postJobApplicationsIdResponseTransformer,
    postJobApproversResponseTransformer,
    postSettingsCommunicationTemplatesResponseTransformer,
    putAdminCompaniesIdResponseTransformer,
    putCompanyConfigResponseTransformer,
    putInterviewsIdInterviewRoundResponseTransformer,
    putInterviewsIdResponseTransformer,
    putJobAppForBackendIdResponseTransformer,
    putOffersDocumentsResponseTransformer,
    putOffersResponseTransformer,
    putSettingsCommunicationTemplatesIdResponseTransformer,
    putTemporalScreeningCallResponseTransformer,
} from './transformers.gen'
import type {
    DeleteAdminBillingCreditCostsIdData,
    DeleteAdminBillingCreditCostsIdErrors,
    DeleteAdminBillingCreditCostsIdResponses,
    DeleteAdminBillingPlansIdData,
    DeleteAdminBillingPlansIdErrors,
    DeleteAdminBillingPlansIdResponses,
    DeleteAssessmentParamsIdData,
    DeleteAssessmentParamsIdErrors,
    DeleteAssessmentParamsIdResponses,
    DeleteAssessmentTemplatesIdData,
    DeleteAssessmentTemplatesIdErrors,
    DeleteAssessmentTemplatesIdResponses,
    DeleteCandidatesIdData,
    DeleteCandidatesIdErrors,
    DeleteCompanyCompanySlugApprovalFlowRuleIdData,
    DeleteCompanyCompanySlugApprovalFlowRuleIdErrors,
    DeleteCompanyCompanySlugApprovalFlowRuleIdResponses,
    DeleteCompanyCompanySlugCandidateStatusesConfigStatusIdData,
    DeleteCompanyCompanySlugCandidateStatusesConfigStatusIdErrors,
    DeleteCompanyCompanySlugCandidateStatusesConfigStatusIdResponses,
    DeleteCompanyCompanySlugDepartmentsData,
    DeleteCompanyCompanySlugDepartmentsErrors,
    DeleteCompanyCompanySlugDepartmentsResponses,
    DeleteCustomAnalyticsDashboardData,
    DeleteCustomAnalyticsDashboardErrors,
    DeleteCustomAnalyticsIdData,
    DeleteCustomAnalyticsIdErrors,
    DeleteCustomAnalyticsIdResponses,
    DeleteHiringManagersIdData,
    DeleteHiringManagersIdErrors,
    DeleteInterviewsIdData,
    DeleteInterviewsIdErrors,
    DeleteInterviewsIdInterviewRoundInterviewRoundIdData,
    DeleteInterviewsIdInterviewRoundInterviewRoundIdErrors,
    DeleteInterviewsIdInterviewRoundInterviewRoundIdPanellistData,
    DeleteInterviewsIdInterviewRoundInterviewRoundIdPanellistErrors,
    DeleteInterviewsIdInterviewRoundInterviewRoundIdResponses,
    DeleteInterviewsIdResponses,
    DeleteInterviewsScreeningCallData,
    DeleteInterviewsScreeningCallErrors,
    DeleteInterviewsScreeningInterviewClientTokenIdData,
    DeleteInterviewsScreeningInterviewClientTokenIdErrors,
    DeleteInterviewsScreeningInterviewClientTokenIdResponses,
    DeleteInterviewsScreeningInterviewIdentityCheckIdData,
    DeleteInterviewsScreeningInterviewIdentityCheckIdErrors,
    DeleteInterviewsScreeningInterviewSpeechTokenIdData,
    DeleteInterviewsScreeningInterviewSpeechTokenIdErrors,
    DeleteInterviewsScreeningInterviewSpeechTokenIdResponses,
    DeleteJdIdData,
    DeleteJdIdErrors,
    DeleteJdIdResponses,
    DeleteJobApplicationsIdData,
    DeleteJobApplicationsIdErrors,
    DeleteJobApplicationsIdResponses,
    DeleteJobsChatbotData,
    DeleteJobsChatbotErrors,
    DeleteJobsChatbotResponses,
    DeleteJobsIdData,
    DeleteJobsIdErrors,
    DeleteJobsIdResponses,
    DeleteMarleeSessionSessionIdData,
    DeleteMarleeSessionSessionIdErrors,
    DeleteMarleeSessionSessionIdResponses,
    DeleteNotesIdData,
    DeleteNotesIdErrors,
    DeleteNotificationsIdData,
    DeleteNotificationsIdErrors,
    DeleteNotificationsIdResponses,
    DeleteSettingsCommunicationTemplatesIdData,
    DeleteSettingsCommunicationTemplatesIdErrors,
    DeleteSettingsCommunicationTemplatesIdResponses,
    GetAdminBillingCreditCostsData,
    GetAdminBillingCreditCostsErrors,
    GetAdminBillingCreditCostsExportData,
    GetAdminBillingCreditCostsExportErrors,
    GetAdminBillingCreditCostsExportResponses,
    GetAdminBillingCreditCostsIdData,
    GetAdminBillingCreditCostsIdErrors,
    GetAdminBillingCreditCostsIdResponses,
    GetAdminBillingCreditCostsResponses,
    GetAdminBillingPlansData,
    GetAdminBillingPlansErrors,
    GetAdminBillingPlansExportData,
    GetAdminBillingPlansExportErrors,
    GetAdminBillingPlansExportResponses,
    GetAdminBillingPlansIdData,
    GetAdminBillingPlansIdErrors,
    GetAdminBillingPlansIdResponses,
    GetAdminBillingPlansResponses,
    GetAdminBillingSignupDraftsData,
    GetAdminBillingSignupDraftsErrors,
    GetAdminBillingSignupDraftsResponses,
    GetAdminCompaniesData,
    GetAdminCompaniesErrors,
    GetAdminCompaniesIdAccessControlData,
    GetAdminCompaniesIdAccessControlErrors,
    GetAdminCompaniesIdAccessControlResponses,
    GetAdminCompaniesIdCreditsData,
    GetAdminCompaniesIdCreditsErrors,
    GetAdminCompaniesIdCreditsLedgerData,
    GetAdminCompaniesIdCreditsLedgerErrors,
    GetAdminCompaniesIdCreditsLedgerResponses,
    GetAdminCompaniesIdCreditsResponses,
    GetAdminCompaniesIdData,
    GetAdminCompaniesIdErrors,
    GetAdminCompaniesIdIntegrationsData,
    GetAdminCompaniesIdIntegrationsErrors,
    GetAdminCompaniesIdIntegrationsResponses,
    GetAdminCompaniesIdResponses,
    GetAdminCompaniesResponses,
    GetAdminIntalentUsersData,
    GetAdminIntalentUsersErrors,
    GetAdminIntalentUsersResponses,
    GetApplicationsSearchData,
    GetApplicationsSearchErrors,
    GetApplicationsSearchResponses,
    GetAssessmentParamsData,
    GetAssessmentParamsErrors,
    GetAssessmentParamsIdData,
    GetAssessmentParamsIdErrors,
    GetAssessmentParamsIdResponses,
    GetAssessmentParamsResponses,
    GetAssessmentTemplatesData,
    GetAssessmentTemplatesErrors,
    GetAssessmentTemplatesIdData,
    GetAssessmentTemplatesIdErrors,
    GetAssessmentTemplatesIdResponses,
    GetAssessmentTemplatesResponses,
    GetAuthLogoutCallbackData,
    GetAuthLogoutCallbackErrors,
    GetAuthMyCompaniesData,
    GetAuthMyCompaniesErrors,
    GetAuthMyCompaniesResponses,
    GetAuthProfileData,
    GetAuthProfileErrors,
    GetAuthProfileResponses,
    GetAuthSwitchCompanyData,
    GetAuthSwitchCompanyErrors,
    GetBillingPlansData,
    GetBillingPlansErrors,
    GetBillingPlansResponses,
    GetBillingSubscriptionData,
    GetBillingSubscriptionErrors,
    GetBillingSubscriptionResponses,
    GetBillingUsageData,
    GetBillingUsageErrors,
    GetBillingUsageResponses,
    GetCandidatesData,
    GetCandidatesErrors,
    GetCandidateSharingSharingSlugData,
    GetCandidateSharingSharingSlugErrors,
    GetCandidatesIdData,
    GetCandidatesIdErrors,
    GetCandidatesResponses,
    GetChatbotConfigData,
    GetChatbotConfigErrors,
    GetChatbotConfigResponses,
    GetCommunicationStatusEmailClientIdData,
    GetCommunicationStatusEmailClientIdErrors,
    GetCompanyCompanySlugAccessControlConfigData,
    GetCompanyCompanySlugAccessControlConfigErrors,
    GetCompanyCompanySlugAccessControlConfigResponses,
    GetCompanyCompanySlugApprovalFlowData,
    GetCompanyCompanySlugApprovalFlowErrors,
    GetCompanyCompanySlugApprovalFlowResponses,
    GetCompanyCompanySlugCandidateStatusesConfigData,
    GetCompanyCompanySlugCandidateStatusesConfigErrors,
    GetCompanyCompanySlugCandidateStatusesConfigResponses,
    GetCompanyCompanySlugDepartmentsData,
    GetCompanyCompanySlugDepartmentsErrors,
    GetCompanyCompanySlugDepartmentsResponses,
    GetCompanyCompanySlugIntegrationsData,
    GetCompanyCompanySlugIntegrationsErrors,
    GetCompanyCompanySlugIntegrationsResponses,
    GetCompanyCompanySlugJdTemplateData,
    GetCompanyCompanySlugJdTemplateErrors,
    GetCompanyCompanySlugJdTemplateResponses,
    GetCompanyCompanySlugJobPostingConfigData,
    GetCompanyCompanySlugJobPostingConfigErrors,
    GetCompanyCompanySlugJobPostingConfigResponses,
    GetCompanyCompanySlugPanellistsData,
    GetCompanyCompanySlugPanellistsErrors,
    GetCompanyCompanySlugScreeningWebrtcConfigData,
    GetCompanyCompanySlugScreeningWebrtcConfigErrors,
    GetCompanyCompanySlugScreeningWebrtcConfigResponses,
    GetCompanyCompanySlugUsersData,
    GetCompanyCompanySlugUsersErrors,
    GetCompanyCompanySlugUsersResponses,
    GetCompanyConfigData,
    GetCompanyConfigErrors,
    GetCompanyData,
    GetCompanyDepartmentsData,
    GetCompanyDepartmentsErrors,
    GetCompanyEmploymentTypesData,
    GetCompanyEmploymentTypesErrors,
    GetCompanyErrors,
    GetCompanySlugJobsJobPostingIdTalentPoolInvitesData,
    GetCompanySlugJobsJobPostingIdTalentPoolInvitesErrors,
    GetCompanySlugPublicCareerDepartmentsData,
    GetCompanySlugPublicCareerDepartmentsErrors,
    GetCompanySlugPublicCareerDepartmentsResponses,
    GetCompanySlugPublicCareerJobsData,
    GetCompanySlugPublicCareerJobsErrors,
    GetCompanySlugPublicCareerJobsIdData,
    GetCompanySlugPublicCareerJobsIdErrors,
    GetCompanySlugPublicCareerJobsIdResponses,
    GetCompanySlugPublicCareerJobsResponses,
    GetCronAiInterviewRemindersData,
    GetCronAiInterviewRemindersErrors,
    GetCronFeedbackRemindersData,
    GetCronFeedbackRemindersErrors,
    GetCronRenewCalendarSubscriptionsData,
    GetCronRenewCalendarSubscriptionsErrors,
    GetCronScreeningWebrtcLifecycleSweeperData,
    GetCronScreeningWebrtcLifecycleSweeperErrors,
    GetCustomAnalyticsData,
    GetCustomAnalyticsErrors,
    GetEmbeddingsData,
    GetEmbeddingsErrors,
    GetEmbeddingsResponses,
    GetHiringManagersData,
    GetHiringManagersErrors,
    GetIntegrationsGoogleAuthorizeData,
    GetIntegrationsGoogleAuthorizeErrors,
    GetIntegrationsGoogleCallbackData,
    GetIntegrationsGoogleCallbackErrors,
    GetIntegrationsMicrosoftAuthorizeData,
    GetIntegrationsMicrosoftAuthorizeErrors,
    GetIntegrationsMicrosoftCallbackData,
    GetIntegrationsMicrosoftCallbackErrors,
    GetInternalSttTokenData,
    GetInternalSttTokenErrors,
    GetInternalSttTokenResponses,
    GetInterviewsData,
    GetInterviewsErrors,
    GetInterviewsFeedbackData,
    GetInterviewsFeedbackErrors,
    GetInterviewsFeedbackTranscriptData,
    GetInterviewsFeedbackTranscriptErrors,
    GetInterviewsIdData,
    GetInterviewsIdErrors,
    GetInterviewsIdResponses,
    GetInterviewsResponses,
    GetInterviewsScreeningCallIdRecordingData,
    GetInterviewsScreeningCallIdRecordingErrors,
    GetInterviewsScreeningCallIdRecordingResponses,
    GetInterviewsScreeningInterviewCandidateData,
    GetInterviewsScreeningInterviewCandidateErrors,
    GetInterviewsScreeningInterviewClientTokenData,
    GetInterviewsScreeningInterviewClientTokenErrors,
    GetInterviewsScreeningInterviewClientTokenResponses,
    GetInterviewsScreeningInterviewData,
    GetInterviewsScreeningInterviewErrors,
    GetInterviewsScreeningInterviewIceServersData,
    GetInterviewsScreeningInterviewIceServersErrors,
    GetInterviewsScreeningInterviewIceServersResponses,
    GetInterviewsScreeningInterviewIdentityCheckIdData,
    GetInterviewsScreeningInterviewIdentityCheckIdErrors,
    GetInterviewsScreeningInterviewProctoringData,
    GetInterviewsScreeningInterviewProctoringErrors,
    GetInterviewsScreeningInterviewProctoringResponses,
    GetInterviewsScreeningInterviewRemindData,
    GetInterviewsScreeningInterviewRemindErrors,
    GetInterviewsScreeningInterviewRemindResponses,
    GetInterviewsScreeningInterviewSpeechTokenData,
    GetInterviewsScreeningInterviewSpeechTokenErrors,
    GetInterviewsScreeningInterviewSpeechTokenResponses,
    GetInterviewsScreeningWebrtcBootstrapData,
    GetInterviewsScreeningWebrtcBootstrapErrors,
    GetInterviewsScreeningWebrtcBootstrapResponses,
    GetInterviewsScreeningWebrtcNetworkProbeData,
    GetInterviewsScreeningWebrtcNetworkProbeErrors,
    GetInterviewsScreeningWebrtcOutputData,
    GetInterviewsScreeningWebrtcOutputErrors,
    GetInterviewsScreeningWebrtcOutputResponses,
    GetJdAgentConversationData,
    GetJdAgentConversationErrors,
    GetJdAgentConversationResponses,
    GetJdAgentSpeechTokenData,
    GetJdAgentSpeechTokenErrors,
    GetJdAgentSpeechTokenResponses,
    GetJdData,
    GetJdErrors,
    GetJdExtractTextData,
    GetJdExtractTextErrors,
    GetJdExtractTextResponses,
    GetJdIdData,
    GetJdIdErrors,
    GetJdIdResponses,
    GetJdResponses,
    GetJobApplicationsData,
    GetJobApplicationsErrors,
    GetJobApplicationsIdApplicantHistoryData,
    GetJobApplicationsIdApplicantHistoryErrors,
    GetJobApplicationsIdApplicantHistoryResponses,
    GetJobApplicationsIdData,
    GetJobApplicationsIdErrors,
    GetJobApplicationsIdResponses,
    GetJobApplicationsProcessingData,
    GetJobApplicationsProcessingErrors,
    GetJobApplicationsProcessingResponses,
    GetJobApplicationsResponses,
    GetJobApplicationsStatusData,
    GetJobApplicationsStatusErrors,
    GetJobApplicationsStatusResponses,
    GetJobApproversApproveData,
    GetJobApproversApproveErrors,
    GetJobApproversApproveResponses,
    GetJobApproversData,
    GetJobApproversErrors,
    GetJobApproversResponses,
    GetJobsChatbotData,
    GetJobsChatbotErrors,
    GetJobsChatbotResponses,
    GetJobsData,
    GetJobsErrors,
    GetJobsIdCandidateMatchingData,
    GetJobsIdCandidateMatchingErrors,
    GetJobsIdCandidateMatchingResponses,
    GetJobsIdData,
    GetJobsIdErrors,
    GetJobsIdLocationsData,
    GetJobsIdLocationsErrors,
    GetJobsIdLocationsResponses,
    GetJobsResponses,
    GetJobsSearchData,
    GetJobsSearchErrors,
    GetJobsSearchResponses,
    GetMetricsData,
    GetMetricsErrors,
    GetMetricsResponses,
    GetMetricsStatusChangeData,
    GetMetricsStatusChangeErrors,
    GetNotesByEmailData,
    GetNotesByEmailErrors,
    GetNotesData,
    GetNotesErrors,
    GetNotificationsData,
    GetNotificationsErrors,
    GetNotificationsResponses,
    GetOffersApproveData,
    GetOffersApproveErrors,
    GetOffersApproveResponses,
    GetOffersData,
    GetOffersErrors,
    GetOffersResponses,
    GetOffersUploadDocumentsIdData,
    GetOffersUploadDocumentsIdErrors,
    GetOffersUploadDocumentsIdResponses,
    GetOgApplyData,
    GetOgApplyErrors,
    GetOgCompanyData,
    GetOgCompanyErrors,
    GetOgDefaultData,
    GetOgDefaultErrors,
    GetOnboardingPlansData,
    GetOnboardingPlansErrors,
    GetOnboardingPlansResponses,
    GetOnboardingStatusData,
    GetOnboardingStatusErrors,
    GetOnboardingStatusResponses,
    GetOnboardingVerifyStatusData,
    GetOnboardingVerifyStatusErrors,
    GetOnboardingVerifyStatusResponses,
    GetRecordingsRecordingIdData,
    GetRecordingsRecordingIdErrors,
    GetRekognitionGetResultsSessionIdData,
    GetRekognitionGetResultsSessionIdErrors,
    GetReportsConfigCompanyIdData,
    GetReportsConfigCompanyIdErrors,
    GetReportsConfigCompanyIdResponses,
    GetReportsTaTrackerData,
    GetReportsTaTrackerErrors,
    GetSettingsCommunicationTemplatesData,
    GetSettingsCommunicationTemplatesErrors,
    GetSettingsCommunicationTemplatesIdData,
    GetSettingsCommunicationTemplatesIdErrors,
    GetSettingsCommunicationTemplatesIdResponses,
    GetSettingsCommunicationTemplatesResponses,
    GetSseTestData,
    GetSseTestErrors,
    GetSseTestResponses,
    GetSseV2Data,
    GetSseV2Errors,
    GetStorageAccessData,
    GetStorageAccessErrors,
    GetStorageAccessResponses,
    GetStorageUploadData,
    GetStorageUploadErrors,
    GetStorageUploadResponses,
    GetTemporalCheatDetectionConfigData,
    GetTemporalCheatDetectionConfigErrors,
    GetTemporalHiQuestionsData,
    GetTemporalHiQuestionsErrors,
    GetTemporalHiQuestionsResponses,
    GetTemporalIntegrationsData,
    GetTemporalIntegrationsErrors,
    GetTemporalIntegrationsResponses,
    GetTemporalJobApplicationsIdData,
    GetTemporalJobApplicationsIdErrors,
    GetTemporalJobApplicationsIdResponses,
    GetTemporalJobApplicationsStatusData,
    GetTemporalJobApplicationsStatusErrors,
    GetTemporalJobApplicationsStatusResponses,
    GetTemporalJobsIdData,
    GetTemporalJobsIdErrors,
    GetTemporalJobsIdResponses,
    GetTemporalScreeningCallData,
    GetTemporalScreeningCallErrors,
    GetTemporalScreeningCallResponses,
    GetTemporalScreeningInterviewData,
    GetTemporalScreeningInterviewErrors,
    GetTemporalScreeningInterviewResponses,
    GetUserDataData,
    GetUserDataErrors,
    GetWebhooksAzureEmailData,
    GetWebhooksAzureEmailErrors,
    GetWebhooksGraphData,
    GetWebhooksGraphErrors,
    GetWebhooksGraphResponses,
    GetWebhooksGraphTranscriptData,
    GetWebhooksGraphTranscriptErrors,
    GetWebhooksGraphTranscriptResponses,
    GetWebhooksPlivoVoiceData,
    GetWebhooksPlivoVoiceErrors,
    GetWebhooksPlivoVoiceResponses,
    GetWebhooksPlivoWhatsappData,
    GetWebhooksPlivoWhatsappErrors,
    GetWebhooksTwilioWhatsappData,
    GetWebhooksTwilioWhatsappErrors,
    GetWellKnownScreeningJwksData,
    GetWellKnownScreeningJwksErrors,
    GetWellKnownScreeningJwksResponses,
    GetWhatsappCompanySlugData,
    GetWhatsappCompanySlugErrors,
    GetWhatsappCompanySlugResponses,
    GetWhatsappData,
    GetWhatsappErrors,
    GetWhatsappResponses,
    HeadInterviewsScreeningWebrtcNetworkProbeData,
    HeadInterviewsScreeningWebrtcNetworkProbeErrors,
    PatchAdminBillingPlansIdData,
    PatchAdminBillingPlansIdErrors,
    PatchAdminBillingPlansIdResponses,
    PatchAdminCompaniesIdArchiveData,
    PatchAdminCompaniesIdArchiveErrors,
    PatchAdminCompaniesIdArchiveResponses,
    PatchAdminCompaniesIdBillingData,
    PatchAdminCompaniesIdBillingErrors,
    PatchAdminCompaniesIdBillingResponses,
    PatchAdminCompaniesIdFeatureFlagsData,
    PatchAdminCompaniesIdFeatureFlagsErrors,
    PatchAdminCompaniesIdFeatureFlagsResponses,
    PatchAdminCompaniesIdIntegrationsData,
    PatchAdminCompaniesIdIntegrationsErrors,
    PatchAdminCompaniesIdIntegrationsResponses,
    PatchAdminCompaniesIdOrgConfigData,
    PatchAdminCompaniesIdOrgConfigErrors,
    PatchAdminCompaniesIdOrgConfigResponses,
    PatchCalendarGenerateTranscriptData,
    PatchCalendarGenerateTranscriptErrors,
    PatchCompanyCompanySlugApprovalFlowData,
    PatchCompanyCompanySlugApprovalFlowErrors,
    PatchCompanyCompanySlugApprovalFlowResponses,
    PatchCompanyCompanySlugApprovalFlowRuleIdData,
    PatchCompanyCompanySlugApprovalFlowRuleIdErrors,
    PatchCompanyCompanySlugApprovalFlowRuleIdResponses,
    PatchCompanyCompanySlugCandidateStatusesConfigStatusIdData,
    PatchCompanyCompanySlugCandidateStatusesConfigStatusIdErrors,
    PatchCompanyCompanySlugCandidateStatusesConfigStatusIdResponses,
    PatchCompanyCompanySlugDepartmentsData,
    PatchCompanyCompanySlugDepartmentsErrors,
    PatchCompanyCompanySlugDepartmentsResponses,
    PatchCompanyCompanySlugIntegrationsData,
    PatchCompanyCompanySlugIntegrationsErrors,
    PatchCompanyCompanySlugIntegrationsResponses,
    PatchCompanyCompanySlugScreeningWebrtcConfigData,
    PatchCompanyCompanySlugScreeningWebrtcConfigErrors,
    PatchCompanyCompanySlugScreeningWebrtcConfigResponses,
    PatchCompanyCompanySlugUsersUserIdData,
    PatchCompanyCompanySlugUsersUserIdErrors,
    PatchCompanyCompanySlugUsersUserIdResponses,
    PatchCronCandidatesData,
    PatchCronCandidatesErrors,
    PatchCustomAnalyticsDashboardData,
    PatchCustomAnalyticsDashboardErrors,
    PatchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryData,
    PatchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryErrors,
    PatchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryResponses,
    PatchJdIdData,
    PatchJdIdErrors,
    PatchJdIdResponses,
    PatchJobApplicationsData,
    PatchJobApplicationsErrors,
    PatchJobApplicationsResponses,
    PatchJobApplicationsStatusData,
    PatchJobApplicationsStatusErrors,
    PatchJobApplicationsStatusResponses,
    PatchJobOpeningsIdData,
    PatchJobOpeningsIdErrors,
    PatchJobsIdStatusData,
    PatchJobsIdStatusErrors,
    PatchJobsIdStatusResponses,
    PatchOnboardingOrgData,
    PatchOnboardingOrgErrors,
    PatchOnboardingOrgResponses,
    PostAdminBillingCreditCostsData,
    PostAdminBillingCreditCostsErrors,
    PostAdminBillingCreditCostsImportData,
    PostAdminBillingCreditCostsImportErrors,
    PostAdminBillingCreditCostsImportResponses,
    PostAdminBillingCreditCostsResponses,
    PostAdminBillingPlansData,
    PostAdminBillingPlansErrors,
    PostAdminBillingPlansIdSyncData,
    PostAdminBillingPlansIdSyncErrors,
    PostAdminBillingPlansIdSyncResponses,
    PostAdminBillingPlansImportData,
    PostAdminBillingPlansImportErrors,
    PostAdminBillingPlansImportResponses,
    PostAdminBillingPlansResponses,
    PostAdminCompaniesData,
    PostAdminCompaniesErrors,
    PostAdminCompaniesIdCreditsData,
    PostAdminCompaniesIdCreditsErrors,
    PostAdminCompaniesIdCreditsResponses,
    PostAdminCompaniesIdIntegrationsData,
    PostAdminCompaniesIdIntegrationsErrors,
    PostAdminCompaniesIdIntegrationsIntegrationIdReencryptData,
    PostAdminCompaniesIdIntegrationsIntegrationIdReencryptErrors,
    PostAdminCompaniesIdIntegrationsIntegrationIdReencryptResponses,
    PostAdminCompaniesIdIntegrationsResponses,
    PostAdminCompaniesIdLinkIntalentUserData,
    PostAdminCompaniesIdLinkIntalentUserErrors,
    PostAdminCompaniesIdLinkIntalentUserResponses,
    PostAdminCompaniesResponses,
    PostAdminOrganizationsData,
    PostAdminOrganizationsErrors,
    PostAdminOrganizationsResponses,
    PostAdminOrganizationsUploadLogoData,
    PostAdminOrganizationsUploadLogoErrors,
    PostAdminOrganizationsUploadLogoResponses,
    PostAnalyticsAgentData,
    PostAnalyticsAgentErrors,
    PostAnalyticsAgentResponses,
    PostAnalyticsAgentStreamData,
    PostAnalyticsAgentStreamErrors,
    PostAnalyticsAgentStreamResponses,
    PostAssessmentParamsData,
    PostAssessmentParamsErrors,
    PostAssessmentParamsIdCopyData,
    PostAssessmentParamsIdCopyErrors,
    PostAssessmentParamsIdCopyResponses,
    PostAssessmentParamsResponses,
    PostAssessmentTemplatesData,
    PostAssessmentTemplatesErrors,
    PostAssessmentTemplatesResponses,
    PostAuthSetCompanyData,
    PostAuthSetCompanyErrors,
    PostAuthSetCompanyResponses,
    PostBillingChangePlanData,
    PostBillingChangePlanErrors,
    PostBillingChangePlanResponses,
    PostBillingCompleteCheckoutData,
    PostBillingCompleteCheckoutErrors,
    PostBillingCompleteCheckoutResponses,
    PostBillingCreditPacksData,
    PostBillingCreditPacksErrors,
    PostBillingPortalData,
    PostBillingPortalErrors,
    PostBillingPortalResponses,
    PostCalendarAvailabilityData,
    PostCalendarAvailabilityErrors,
    PostCalendarData,
    PostCalendarErrors,
    PostCalendarGenerateTranscriptData,
    PostCalendarGenerateTranscriptErrors,
    PostCalendarPanelistSlotsCommentsData,
    PostCalendarPanelistSlotsCommentsErrors,
    PostCalendarPanelistSlotsData,
    PostCalendarPanelistSlotsErrors,
    PostCalendarPanelistSlotsGenerateData,
    PostCalendarPanelistSlotsGenerateErrors,
    PostCalendarSchedulingSlotsData,
    PostCalendarSchedulingSlotsErrors,
    PostCandidatesBulkDeleteData,
    PostCandidatesBulkDeleteErrors,
    PostCandidatesBulkDeleteResponses,
    PostCandidatesData,
    PostCandidatesErrors,
    PostCandidatesParseQueryData,
    PostCandidatesParseQueryErrors,
    PostCandidatesParseQueryResponses,
    PostCandidatesResponses,
    PostCommunicationStatusCreateData,
    PostCommunicationStatusCreateErrors,
    PostCompanyCompanySlugApprovalFlowData,
    PostCompanyCompanySlugApprovalFlowErrors,
    PostCompanyCompanySlugApprovalFlowResponses,
    PostCompanyCompanySlugCandidateStatusesConfigData,
    PostCompanyCompanySlugCandidateStatusesConfigErrors,
    PostCompanyCompanySlugCandidateStatusesConfigResponses,
    PostCompanyCompanySlugDepartmentsData,
    PostCompanyCompanySlugDepartmentsErrors,
    PostCompanyCompanySlugDepartmentsResponses,
    PostCompanyCompanySlugIntegrationsDisconnectData,
    PostCompanyCompanySlugIntegrationsDisconnectErrors,
    PostCompanyCompanySlugIntegrationsDisconnectResponses,
    PostCompanyCompanySlugIntegrationsLinkedinVerifyData,
    PostCompanyCompanySlugIntegrationsLinkedinVerifyErrors,
    PostCompanyCompanySlugIntegrationsLinkedinVerifyResponses,
    PostCompanyCompanySlugIntegrationsTestData,
    PostCompanyCompanySlugIntegrationsTestErrors,
    PostCompanyCompanySlugIntegrationsTestResponses,
    PostCompanyCompanySlugLogoData,
    PostCompanyCompanySlugLogoErrors,
    PostCompanyCompanySlugLogoResponses,
    PostCompanyCompanySlugUsersData,
    PostCompanyCompanySlugUsersDisableData,
    PostCompanyCompanySlugUsersDisableErrors,
    PostCompanyCompanySlugUsersDisableResponses,
    PostCompanyCompanySlugUsersEnableData,
    PostCompanyCompanySlugUsersEnableErrors,
    PostCompanyCompanySlugUsersEnableResponses,
    PostCompanyCompanySlugUsersErrors,
    PostCompanyCompanySlugUsersResponses,
    PostCompanyCompanySlugUsersUserIdResetPasswordData,
    PostCompanyCompanySlugUsersUserIdResetPasswordErrors,
    PostCompanyCompanySlugUsersUserIdResetPasswordResponses,
    PostCompanyConfigData,
    PostCompanyConfigErrors,
    PostCompanyConfigResponses,
    PostCompanyGradeData,
    PostCompanyGradeErrors,
    PostCompanyGradeResponses,
    PostCompanySlugCandidateSharingCreateData,
    PostCompanySlugCandidateSharingCreateErrors,
    PostCompanySlugJobsJobPostingIdTalentPoolInvitesData,
    PostCompanySlugJobsJobPostingIdTalentPoolInvitesErrors,
    PostCompanyTitleGradeData,
    PostCompanyTitleGradeErrors,
    PostCompanyTitleGradeResponses,
    PostCronAiInterviewRemindersData,
    PostCronAiInterviewRemindersErrors,
    PostCronAnalyticsRefreshData,
    PostCronAnalyticsRefreshErrors,
    PostCronBillingCapacityRebillData,
    PostCronBillingCapacityRebillErrors,
    PostCronFeedbackRemindersData,
    PostCronFeedbackRemindersErrors,
    PostCronJobApplicationProcessingData,
    PostCronJobApplicationProcessingErrors,
    PostCronJobApplicationProcessingResponses,
    PostCronRenewCalendarSubscriptionsData,
    PostCronRenewCalendarSubscriptionsErrors,
    PostCronScreeningWebrtcLifecycleSweeperData,
    PostCronScreeningWebrtcLifecycleSweeperErrors,
    PostCustomAnalyticsAssignDashboardData,
    PostCustomAnalyticsAssignDashboardErrors,
    PostCustomAnalyticsDashboardData,
    PostCustomAnalyticsDashboardErrors,
    PostCustomAnalyticsData,
    PostCustomAnalyticsErrors,
    PostCustomAnalyticsOrderData,
    PostCustomAnalyticsOrderErrors,
    PostCustomAnalyticsPaginateData,
    PostCustomAnalyticsPaginateErrors,
    PostCustomAnalyticsPreviewData,
    PostCustomAnalyticsPreviewErrors,
    PostCustomAnalyticsRemoveDashboardData,
    PostCustomAnalyticsRemoveDashboardErrors,
    PostEmbeddingsData,
    PostEmbeddingsErrors,
    PostEmbeddingsResponses,
    PostGenerateQuestionsData,
    PostGenerateQuestionsErrors,
    PostHiringManagersData,
    PostHiringManagersErrors,
    PostInsightsBenettonApplicantsReportData,
    PostInsightsBenettonApplicantsReportErrors,
    PostInsightsCandidatesByRolesReportData,
    PostInsightsCandidatesByRolesReportErrors,
    PostInsightsCandidatesByStatusReportData,
    PostInsightsCandidatesByStatusReportErrors,
    PostInsightsCustomChartsData,
    PostInsightsCustomChartsErrors,
    PostInsightsMonthlyDashboardData,
    PostInsightsMonthlyDashboardErrors,
    PostInsightsOfferJoinedReportData,
    PostInsightsOfferJoinedReportErrors,
    PostInsightsOpenPositionsReportData,
    PostInsightsOpenPositionsReportErrors,
    PostInsightsPositionsClosedReportData,
    PostInsightsPositionsClosedReportErrors,
    PostInsightsPositionsCreatedReportData,
    PostInsightsPositionsCreatedReportErrors,
    PostInsightsPredefinedGraphsData,
    PostInsightsPredefinedGraphsErrors,
    PostInsightsPredefinedGraphsSaveData,
    PostInsightsPredefinedGraphsSaveErrors,
    PostInternalAnalyticsQueryData,
    PostInternalAnalyticsQueryErrors,
    PostInternalAnalyticsQueryResponses,
    PostInternalSttData,
    PostInternalSttErrors,
    PostInternalSttResponses,
    PostInterviewsData,
    PostInterviewsErrors,
    PostInterviewsFeedbackGenerateData,
    PostInterviewsFeedbackGenerateErrors,
    PostInterviewsHumanInterviewQuestionsData,
    PostInterviewsHumanInterviewQuestionsErrors,
    PostInterviewsHumanInterviewQuestionsTriggerData,
    PostInterviewsHumanInterviewQuestionsTriggerErrors,
    PostInterviewsIdInterviewRoundData,
    PostInterviewsIdInterviewRoundErrors,
    PostInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryData,
    PostInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryErrors,
    PostInterviewsIdInterviewRoundInterviewRoundIdRatingsData,
    PostInterviewsIdInterviewRoundInterviewRoundIdRatingsErrors,
    PostInterviewsIdInterviewRoundResponses,
    PostInterviewsResponses,
    PostInterviewsScreeningCallBulkData,
    PostInterviewsScreeningCallBulkErrors,
    PostInterviewsScreeningCallData,
    PostInterviewsScreeningCallEndInterviewData,
    PostInterviewsScreeningCallEndInterviewErrors,
    PostInterviewsScreeningCallEndInterviewResponses,
    PostInterviewsScreeningCallErrors,
    PostInterviewsScreeningCallIdRecordingFetchData,
    PostInterviewsScreeningCallIdRecordingFetchErrors,
    PostInterviewsScreeningCallIdRecordingFetchResponses,
    PostInterviewsScreeningCallLifecycleData,
    PostInterviewsScreeningCallLifecycleErrors,
    PostInterviewsScreeningCallLifecycleResponses,
    PostInterviewsScreeningInterviewClientTokenData,
    PostInterviewsScreeningInterviewClientTokenErrors,
    PostInterviewsScreeningInterviewClientTokenResponses,
    PostInterviewsScreeningInterviewDailyRecordingData,
    PostInterviewsScreeningInterviewDailyRecordingErrors,
    PostInterviewsScreeningInterviewData,
    PostInterviewsScreeningInterviewEndInterviewData,
    PostInterviewsScreeningInterviewEndInterviewErrors,
    PostInterviewsScreeningInterviewEndInterviewResponses,
    PostInterviewsScreeningInterviewErrors,
    PostInterviewsScreeningInterviewEventsData,
    PostInterviewsScreeningInterviewEventsErrors,
    PostInterviewsScreeningInterviewEventsResponses,
    PostInterviewsScreeningInterviewFastrtcRecordingData,
    PostInterviewsScreeningInterviewFastrtcRecordingErrors,
    PostInterviewsScreeningInterviewFetchDailyRecordingData,
    PostInterviewsScreeningInterviewFetchDailyRecordingErrors,
    PostInterviewsScreeningInterviewFixLivenessStatusData,
    PostInterviewsScreeningInterviewFixLivenessStatusErrors,
    PostInterviewsScreeningInterviewProctoringData,
    PostInterviewsScreeningInterviewProctoringErrors,
    PostInterviewsScreeningInterviewProctoringResponses,
    PostInterviewsScreeningInterviewStartData,
    PostInterviewsScreeningInterviewStartErrors,
    PostInterviewsScreeningInterviewTransitionToStartedData,
    PostInterviewsScreeningInterviewTransitionToStartedErrors,
    PostInterviewsScreeningInterviewTransitionToStartedResponses,
    PostInterviewsScreeningInterviewTtsEnsureData,
    PostInterviewsScreeningInterviewTtsEnsureErrors,
    PostInterviewsScreeningWebrtcAbandonData,
    PostInterviewsScreeningWebrtcAbandonErrors,
    PostInterviewsScreeningWebrtcAbandonResponses,
    PostInterviewsScreeningWebrtcLifecycleData,
    PostInterviewsScreeningWebrtcLifecycleErrors,
    PostInterviewsScreeningWebrtcLifecycleResponses,
    PostInterviewsScreeningWebrtcOfferData,
    PostInterviewsScreeningWebrtcOfferErrors,
    PostInterviewsScreeningWebrtcOfferResponses,
    PostInterviewsScreeningWebrtcRecordingChunkData,
    PostInterviewsScreeningWebrtcRecordingChunkErrors,
    PostInterviewsScreeningWebrtcRecordingChunkResponses,
    PostInterviewsScreeningWebrtcRecordingFinalizeData,
    PostInterviewsScreeningWebrtcRecordingFinalizeErrors,
    PostInterviewsScreeningWebrtcRecordingFinalizeResponses,
    PostInterviewsScreeningWebrtcRecordingInitData,
    PostInterviewsScreeningWebrtcRecordingInitErrors,
    PostInterviewsScreeningWebrtcRecordingInitResponses,
    PostInterviewsScreeningWebrtcRecordingPartUrlData,
    PostInterviewsScreeningWebrtcRecordingPartUrlErrors,
    PostInterviewsScreeningWebrtcRecordingPartUrlResponses,
    PostInterviewsScreeningWebrtcScoringData,
    PostInterviewsScreeningWebrtcScoringErrors,
    PostInterviewsScreeningWebrtcScoringResponses,
    PostInterviewsScreeningWebrtcSessionData,
    PostInterviewsScreeningWebrtcSessionErrors,
    PostInterviewsScreeningWebrtcSessionLogAppendData,
    PostInterviewsScreeningWebrtcSessionLogAppendErrors,
    PostInterviewsScreeningWebrtcSessionLogAppendResponses,
    PostInterviewsScreeningWebrtcSessionLogFinalizeData,
    PostInterviewsScreeningWebrtcSessionLogFinalizeErrors,
    PostInterviewsScreeningWebrtcSessionLogFinalizeResponses,
    PostInterviewsScreeningWebrtcSessionResponses,
    PostInterviewsScreeningWebrtcSessionSessionIdConnectData,
    PostInterviewsScreeningWebrtcSessionSessionIdConnectErrors,
    PostInterviewsScreeningWebrtcSessionSessionIdConnectResponses,
    PostInterviewsScreeningWebrtcTokenData,
    PostInterviewsScreeningWebrtcTokenErrors,
    PostInterviewsScreeningWebrtcTokenResponses,
    PostJdAgentBackendData,
    PostJdAgentBackendErrors,
    PostJdAgentBackendResponses,
    PostJdAgentBackendStreamData,
    PostJdAgentBackendStreamErrors,
    PostJdAgentBackendStreamResponses,
    PostJdAgentConversationSyncData,
    PostJdAgentConversationSyncErrors,
    PostJdAgentConversationSyncResponses,
    PostJdData,
    PostJdErrors,
    PostJdExtractTextData,
    PostJdExtractTextErrors,
    PostJdExtractTextResponses,
    PostJdResponses,
    PostJobApplicationsBulkDeleteData,
    PostJobApplicationsBulkDeleteErrors,
    PostJobApplicationsBulkDeleteResponses,
    PostJobApplicationsBulkReprocessData,
    PostJobApplicationsBulkReprocessErrors,
    PostJobApplicationsBulkReprocessResponses,
    PostJobApplicationsData,
    PostJobApplicationsErrors,
    PostJobApplicationsIdData,
    PostJobApplicationsIdErrors,
    PostJobApplicationsIdReprocessData,
    PostJobApplicationsIdReprocessErrors,
    PostJobApplicationsIdReprocessResponses,
    PostJobApplicationsIdResponses,
    PostJobApplicationsResponses,
    PostJobApproversBypassIdData,
    PostJobApproversBypassIdErrors,
    PostJobApproversData,
    PostJobApproversErrors,
    PostJobApproversReminderIdData,
    PostJobApproversReminderIdErrors,
    PostJobApproversReminderIdResponses,
    PostJobApproversResponses,
    PostJobsBulkDeleteData,
    PostJobsBulkDeleteErrors,
    PostJobsBulkDeleteResponses,
    PostJobsChatbotData,
    PostJobsChatbotErrors,
    PostJobsChatbotResponses,
    PostJobsData,
    PostJobsErrors,
    PostJobsResponses,
    PostMailboxMonitoringData,
    PostMailboxMonitoringErrors,
    PostMailboxMonitoringProcessData,
    PostMailboxMonitoringProcessErrors,
    PostMarleeCommandData,
    PostMarleeCommandErrors,
    PostMarleeCommandResponses,
    PostMarleeSessionData,
    PostMarleeSessionErrors,
    PostMarleeSessionResponses,
    PostNaukriJobData,
    PostNaukriJobErrors,
    PostNaukriJobResponses,
    PostNotesData,
    PostNotesErrors,
    PostOffersData,
    PostOffersErrors,
    PostOffersRemindData,
    PostOffersRemindErrors,
    PostOffersRemindResponses,
    PostOffersRequestDocumentsData,
    PostOffersRequestDocumentsErrors,
    PostOffersRequestDocumentsResponses,
    PostOffersResponses,
    PostOffersSendData,
    PostOffersSendErrors,
    PostOffersSendForApprovalData,
    PostOffersSendForApprovalErrors,
    PostOffersSendForApprovalResponses,
    PostOffersSendResponses,
    PostOffersUploadDocumentsIdData,
    PostOffersUploadDocumentsIdErrors,
    PostOffersUploadDocumentsIdResponses,
    PostOnboardingCompleteCheckoutData,
    PostOnboardingCompleteCheckoutErrors,
    PostOnboardingCompleteCheckoutResponses,
    PostOnboardingCompleteSignupData,
    PostOnboardingCompleteSignupErrors,
    PostOnboardingCompleteSignupResponses,
    PostOnboardingSelectPlanData,
    PostOnboardingSelectPlanErrors,
    PostOnboardingSelectPlanResponses,
    PostOnboardingSignupData,
    PostOnboardingSignupErrors,
    PostOnboardingSignupResponses,
    PostOnboardingUploadLogoData,
    PostOnboardingUploadLogoErrors,
    PostOnboardingUploadLogoResponses,
    PostOnboardingVerifyCodeData,
    PostOnboardingVerifyCodeErrors,
    PostOnboardingVerifyCodeResponses,
    PostOnboardingVerifyStatusData,
    PostOnboardingVerifyStatusErrors,
    PostOnboardingVerifyStatusResponses,
    PostPermissionsData,
    PostPermissionsErrors,
    PostPermissionsResponses,
    PostReachOutData,
    PostReachOutErrors,
    PostReachOutSlotBookingData,
    PostReachOutSlotBookingErrors,
    PostRekognitionCreateSessionData,
    PostRekognitionCreateSessionErrors,
    PostReportsConfigCompanyIdData,
    PostReportsConfigCompanyIdErrors,
    PostReportsConfigCompanyIdResponses,
    PostReportsExecuteData,
    PostReportsExecuteErrors,
    PostReportsExecuteResponses,
    PostScreeningReportPdfData,
    PostScreeningReportPdfErrors,
    PostScreeningReportPdfResponses,
    PostSendEmailData,
    PostSendEmailErrors,
    PostSettingsCommunicationTemplatesActivateDefaultData,
    PostSettingsCommunicationTemplatesActivateDefaultErrors,
    PostSettingsCommunicationTemplatesActivateDefaultResponses,
    PostSettingsCommunicationTemplatesData,
    PostSettingsCommunicationTemplatesErrors,
    PostSettingsCommunicationTemplatesPreviewData,
    PostSettingsCommunicationTemplatesPreviewErrors,
    PostSettingsCommunicationTemplatesPreviewResponses,
    PostSettingsCommunicationTemplatesResponses,
    PostTemporalCandidateData,
    PostTemporalCandidateErrors,
    PostTemporalCommunicationStatusData,
    PostTemporalCommunicationStatusErrors,
    PostTemporalScreeningCallObjectiveEvaluationsData,
    PostTemporalScreeningCallObjectiveEvaluationsErrors,
    PostTemporalScreeningCallObjectiveEvaluationsResponses,
    PostTemporalWorkshortsData,
    PostTemporalWorkshortsErrors,
    PostTemporalWorkshortsResponses,
    PostWebhooksAzureEmailData,
    PostWebhooksAzureEmailErrors,
    PostWebhooksDailyData,
    PostWebhooksDailyErrors,
    PostWebhooksGraphData,
    PostWebhooksGraphErrors,
    PostWebhooksGraphResponses,
    PostWebhooksGraphTranscriptData,
    PostWebhooksGraphTranscriptErrors,
    PostWebhooksGraphTranscriptResponses,
    PostWebhooksPlivoRecordingData,
    PostWebhooksPlivoRecordingErrors,
    PostWebhooksPlivoRecordingResponses,
    PostWebhooksPlivoVoiceData,
    PostWebhooksPlivoVoiceErrors,
    PostWebhooksPlivoVoiceResponses,
    PostWebhooksPlivoWhatsappData,
    PostWebhooksPlivoWhatsappErrors,
    PostWebhooksResendEmailData,
    PostWebhooksResendEmailErrors,
    PostWebhooksStripeData,
    PostWebhooksStripeErrors,
    PostWebhooksStripeResponses,
    PostWebhooksTwilioRecordingData,
    PostWebhooksTwilioRecordingErrors,
    PostWebhooksTwilioRecordingResponses,
    PostWebhooksTwilioVoiceData,
    PostWebhooksTwilioVoiceErrors,
    PostWebhooksTwilioVoiceResponses,
    PostWebhooksTwilioWhatsappData,
    PostWebhooksTwilioWhatsappErrors,
    PostWhatsappCompanySlugData,
    PostWhatsappCompanySlugErrors,
    PostWhatsappData,
    PostWhatsappErrors,
    PutAdminBillingCreditCostsIdData,
    PutAdminBillingCreditCostsIdErrors,
    PutAdminBillingCreditCostsIdResponses,
    PutAdminCompaniesIdAccessControlData,
    PutAdminCompaniesIdAccessControlErrors,
    PutAdminCompaniesIdAccessControlResponses,
    PutAdminCompaniesIdData,
    PutAdminCompaniesIdErrors,
    PutAdminCompaniesIdResponses,
    PutAssessmentParamsIdData,
    PutAssessmentParamsIdErrors,
    PutAssessmentParamsIdResponses,
    PutAssessmentTemplatesIdData,
    PutAssessmentTemplatesIdErrors,
    PutAssessmentTemplatesIdResponses,
    PutAuthProfileData,
    PutAuthProfileErrors,
    PutAuthProfileResponses,
    PutCalendarData,
    PutCalendarErrors,
    PutCandidateSharingSharingSlugFeedbackData,
    PutCandidateSharingSharingSlugFeedbackErrors,
    PutCandidatesIdData,
    PutCandidatesIdErrors,
    PutCompanyCompanySlugAccessControlConfigData,
    PutCompanyCompanySlugAccessControlConfigErrors,
    PutCompanyCompanySlugAccessControlConfigResponses,
    PutCompanyCompanySlugCandidateStatusesConfigData,
    PutCompanyCompanySlugCandidateStatusesConfigErrors,
    PutCompanyCompanySlugCandidateStatusesConfigResponses,
    PutCompanyCompanySlugJdTemplateData,
    PutCompanyCompanySlugJdTemplateErrors,
    PutCompanyCompanySlugJdTemplateResponses,
    PutCompanyCompanySlugJobPostingConfigData,
    PutCompanyCompanySlugJobPostingConfigErrors,
    PutCompanyCompanySlugJobPostingConfigResponses,
    PutCompanyConfigData,
    PutCompanyConfigErrors,
    PutCompanyConfigResponses,
    PutGenerateQuestionsIdData,
    PutGenerateQuestionsIdErrors,
    PutHiringManagersIdData,
    PutHiringManagersIdErrors,
    PutInterviewsFeedbackData,
    PutInterviewsFeedbackErrors,
    PutInterviewsIdData,
    PutInterviewsIdErrors,
    PutInterviewsIdInterviewRoundData,
    PutInterviewsIdInterviewRoundErrors,
    PutInterviewsIdInterviewRoundInterviewRoundIdData,
    PutInterviewsIdInterviewRoundInterviewRoundIdErrors,
    PutInterviewsIdInterviewRoundResponses,
    PutInterviewsIdResponses,
    PutInterviewsScreeningCallData,
    PutInterviewsScreeningCallErrors,
    PutInterviewsScreeningInterviewData,
    PutInterviewsScreeningInterviewErrors,
    PutInterviewsScreeningWebrtcNetworkProbeData,
    PutInterviewsScreeningWebrtcNetworkProbeErrors,
    PutJobAppForBackendIdData,
    PutJobAppForBackendIdErrors,
    PutJobAppForBackendIdResponses,
    PutJobApplicationsApproveData,
    PutJobApplicationsApproveErrors,
    PutJobApplicationsApproveResponses,
    PutJobApplicationsIdData,
    PutJobApplicationsIdErrors,
    PutJobApplicationsIdResponses,
    PutJobApproversApproveData,
    PutJobApproversApproveErrors,
    PutJobApproversApproveResponses,
    PutJobsIdData,
    PutJobsIdErrors,
    PutJobsIdResponses,
    PutNotesIdData,
    PutNotesIdErrors,
    PutNotificationsData,
    PutNotificationsErrors,
    PutNotificationsResponses,
    PutOffersAcceptData,
    PutOffersAcceptErrors,
    PutOffersAcceptResponses,
    PutOffersApproveData,
    PutOffersApproveErrors,
    PutOffersApproveResponses,
    PutOffersData,
    PutOffersDocumentsData,
    PutOffersDocumentsErrors,
    PutOffersDocumentsResponses,
    PutOffersErrors,
    PutOffersResponses,
    PutOffersUploadDocumentsIdData,
    PutOffersUploadDocumentsIdErrors,
    PutOffersUploadDocumentsIdResponses,
    PutSettingsCommunicationTemplatesIdData,
    PutSettingsCommunicationTemplatesIdErrors,
    PutSettingsCommunicationTemplatesIdResponses,
    PutTemporalJobApplicationsIdData,
    PutTemporalJobApplicationsIdErrors,
    PutTemporalJobApplicationsIdResponses,
    PutTemporalScreeningCallData,
    PutTemporalScreeningCallErrors,
    PutTemporalScreeningCallResponses,
} from './types.gen'

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<
    TData,
    ThrowOnError,
    TResponse
> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta
}

export const postCompanySlugCandidateSharingCreate = <ThrowOnError extends boolean = false>(
    options: Options<PostCompanySlugCandidateSharingCreateData, ThrowOnError>
): RequestResult<unknown, PostCompanySlugCandidateSharingCreateErrors, ThrowOnError> =>
    (options.client ?? client).post<unknown, PostCompanySlugCandidateSharingCreateErrors, ThrowOnError>({
        url: '/{companySlug}/candidate-sharing/create',
        ...options,
    })

export const getCompanySlugJobsJobPostingIdTalentPoolInvites = <ThrowOnError extends boolean = false>(
    options: Options<GetCompanySlugJobsJobPostingIdTalentPoolInvitesData, ThrowOnError>
): RequestResult<unknown, GetCompanySlugJobsJobPostingIdTalentPoolInvitesErrors, ThrowOnError> =>
    (options.client ?? client).get<unknown, GetCompanySlugJobsJobPostingIdTalentPoolInvitesErrors, ThrowOnError>({
        url: '/{companySlug}/jobs/{jobPostingId}/talent-pool-invites',
        ...options,
    })

export const postCompanySlugJobsJobPostingIdTalentPoolInvites = <ThrowOnError extends boolean = false>(
    options: Options<PostCompanySlugJobsJobPostingIdTalentPoolInvitesData, ThrowOnError>
): RequestResult<unknown, PostCompanySlugJobsJobPostingIdTalentPoolInvitesErrors, ThrowOnError> =>
    (options.client ?? client).post<unknown, PostCompanySlugJobsJobPostingIdTalentPoolInvitesErrors, ThrowOnError>({
        url: '/{companySlug}/jobs/{jobPostingId}/talent-pool-invites',
        ...options,
    })

/**
 * GET handler for admin companies endpoint
 */
export const getAdminCompanies = <ThrowOnError extends boolean = false>(
    options?: Options<GetAdminCompaniesData, ThrowOnError>
): RequestResult<GetAdminCompaniesResponses, GetAdminCompaniesErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetAdminCompaniesResponses, GetAdminCompaniesErrors, ThrowOnError>({
        responseTransformer: getAdminCompaniesResponseTransformer,
        responseType: 'json',
        url: '/admin/companies',
        ...options,
    })

export const postAdminCompanies = <ThrowOnError extends boolean = false>(
    options?: Options<PostAdminCompaniesData, ThrowOnError>
): RequestResult<PostAdminCompaniesResponses, PostAdminCompaniesErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostAdminCompaniesResponses, PostAdminCompaniesErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/companies',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

/**
 * SuperAdmin only. Lists distinct @intalent.ai users with real Auth0 IDs (from Users table).
 */
export const getAdminIntalentUsers = <ThrowOnError extends boolean = false>(
    options?: Options<GetAdminIntalentUsersData, ThrowOnError>
): RequestResult<GetAdminIntalentUsersResponses, GetAdminIntalentUsersErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetAdminIntalentUsersResponses, GetAdminIntalentUsersErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/intalent-users',
        ...options,
    })

/**
 * POST /api/admin/organizations
 */
export const postAdminOrganizations = <ThrowOnError extends boolean = false>(
    options?: Options<PostAdminOrganizationsData, ThrowOnError>
): RequestResult<PostAdminOrganizationsResponses, PostAdminOrganizationsErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostAdminOrganizationsResponses, PostAdminOrganizationsErrors, ThrowOnError>({
        responseTransformer: postAdminOrganizationsResponseTransformer,
        responseType: 'json',
        url: '/admin/organizations',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

/**
 * GET handler for company full details (super admin only).
 */
export const getAdminCompaniesId = <ThrowOnError extends boolean = false>(
    options: Options<GetAdminCompaniesIdData, ThrowOnError>
): RequestResult<GetAdminCompaniesIdResponses, GetAdminCompaniesIdErrors, ThrowOnError> =>
    (options.client ?? client).get<GetAdminCompaniesIdResponses, GetAdminCompaniesIdErrors, ThrowOnError>({
        responseTransformer: getAdminCompaniesIdResponseTransformer,
        responseType: 'json',
        url: '/admin/companies/{id}',
        ...options,
    })

/**
 * PUT handler for updating company details
 */
export const putAdminCompaniesId = <ThrowOnError extends boolean = false>(
    options: Options<PutAdminCompaniesIdData, ThrowOnError>
): RequestResult<PutAdminCompaniesIdResponses, PutAdminCompaniesIdErrors, ThrowOnError> =>
    (options.client ?? client).put<PutAdminCompaniesIdResponses, PutAdminCompaniesIdErrors, ThrowOnError>({
        responseTransformer: putAdminCompaniesIdResponseTransformer,
        responseType: 'json',
        url: '/admin/companies/{id}',
        ...options,
    })

/**
 * POST /api/admin/organizations/upload-logo
 */
export const postAdminOrganizationsUploadLogo = <ThrowOnError extends boolean = false>(
    options?: Options<PostAdminOrganizationsUploadLogoData, ThrowOnError>
): RequestResult<PostAdminOrganizationsUploadLogoResponses, PostAdminOrganizationsUploadLogoErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostAdminOrganizationsUploadLogoResponses, PostAdminOrganizationsUploadLogoErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/organizations/upload-logo',
        ...options,
    })

/**
 * GET /api/admin/companies/[id]/access-control
 */
export const getAdminCompaniesIdAccessControl = <ThrowOnError extends boolean = false>(
    options: Options<GetAdminCompaniesIdAccessControlData, ThrowOnError>
): RequestResult<GetAdminCompaniesIdAccessControlResponses, GetAdminCompaniesIdAccessControlErrors, ThrowOnError> =>
    (options.client ?? client).get<GetAdminCompaniesIdAccessControlResponses, GetAdminCompaniesIdAccessControlErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/companies/{id}/access-control',
        ...options,
    })

/**
 * PUT /api/admin/companies/[id]/access-control
 */
export const putAdminCompaniesIdAccessControl = <ThrowOnError extends boolean = false>(
    options: Options<PutAdminCompaniesIdAccessControlData, ThrowOnError>
): RequestResult<PutAdminCompaniesIdAccessControlResponses, PutAdminCompaniesIdAccessControlErrors, ThrowOnError> =>
    (options.client ?? client).put<PutAdminCompaniesIdAccessControlResponses, PutAdminCompaniesIdAccessControlErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/companies/{id}/access-control',
        ...options,
    })

/**
 * PATCH /api/admin/companies/[id]/archive
 */
export const patchAdminCompaniesIdArchive = <ThrowOnError extends boolean = false>(
    options: Options<PatchAdminCompaniesIdArchiveData, ThrowOnError>
): RequestResult<PatchAdminCompaniesIdArchiveResponses, PatchAdminCompaniesIdArchiveErrors, ThrowOnError> =>
    (options.client ?? client).patch<PatchAdminCompaniesIdArchiveResponses, PatchAdminCompaniesIdArchiveErrors, ThrowOnError>({
        responseTransformer: patchAdminCompaniesIdArchiveResponseTransformer,
        responseType: 'json',
        url: '/admin/companies/{id}/archive',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

/**
 * PATCH /api/admin/companies/[id]/feature-flags
 */
export const patchAdminCompaniesIdFeatureFlags = <ThrowOnError extends boolean = false>(
    options: Options<PatchAdminCompaniesIdFeatureFlagsData, ThrowOnError>
): RequestResult<PatchAdminCompaniesIdFeatureFlagsResponses, PatchAdminCompaniesIdFeatureFlagsErrors, ThrowOnError> =>
    (options.client ?? client).patch<PatchAdminCompaniesIdFeatureFlagsResponses, PatchAdminCompaniesIdFeatureFlagsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/companies/{id}/feature-flags',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

export const getAdminCompaniesIdIntegrations = <ThrowOnError extends boolean = false>(
    options: Options<GetAdminCompaniesIdIntegrationsData, ThrowOnError>
): RequestResult<GetAdminCompaniesIdIntegrationsResponses, GetAdminCompaniesIdIntegrationsErrors, ThrowOnError> =>
    (options.client ?? client).get<GetAdminCompaniesIdIntegrationsResponses, GetAdminCompaniesIdIntegrationsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/companies/{id}/integrations',
        ...options,
    })

export const patchAdminCompaniesIdIntegrations = <ThrowOnError extends boolean = false>(
    options: Options<PatchAdminCompaniesIdIntegrationsData, ThrowOnError>
): RequestResult<PatchAdminCompaniesIdIntegrationsResponses, PatchAdminCompaniesIdIntegrationsErrors, ThrowOnError> =>
    (options.client ?? client).patch<PatchAdminCompaniesIdIntegrationsResponses, PatchAdminCompaniesIdIntegrationsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/companies/{id}/integrations',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

export const postAdminCompaniesIdIntegrations = <ThrowOnError extends boolean = false>(
    options: Options<PostAdminCompaniesIdIntegrationsData, ThrowOnError>
): RequestResult<PostAdminCompaniesIdIntegrationsResponses, PostAdminCompaniesIdIntegrationsErrors, ThrowOnError> =>
    (options.client ?? client).post<PostAdminCompaniesIdIntegrationsResponses, PostAdminCompaniesIdIntegrationsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/companies/{id}/integrations',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

/**
 * SuperAdmin only. Links an existing @intalent.ai user (from directory + Auth0) to a company:
 */
export const postAdminCompaniesIdLinkIntalentUser = <ThrowOnError extends boolean = false>(
    options: Options<PostAdminCompaniesIdLinkIntalentUserData, ThrowOnError>
): RequestResult<PostAdminCompaniesIdLinkIntalentUserResponses, PostAdminCompaniesIdLinkIntalentUserErrors, ThrowOnError> =>
    (options.client ?? client).post<PostAdminCompaniesIdLinkIntalentUserResponses, PostAdminCompaniesIdLinkIntalentUserErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/companies/{id}/link-intalent-user',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

/**
 * SuperAdmin only. Updates the company display name and CompanyConfig fields shown on the org Overview "Configuration" section. Does not modify Graph credentials.
 */
export const patchAdminCompaniesIdOrgConfig = <ThrowOnError extends boolean = false>(
    options: Options<PatchAdminCompaniesIdOrgConfigData, ThrowOnError>
): RequestResult<PatchAdminCompaniesIdOrgConfigResponses, PatchAdminCompaniesIdOrgConfigErrors, ThrowOnError> =>
    (options.client ?? client).patch<PatchAdminCompaniesIdOrgConfigResponses, PatchAdminCompaniesIdOrgConfigErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/companies/{id}/org-config',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

/**
 * GET /api/admin/billing/credit-costs
 *
 * List named credit cost catalogs assignable to plans and companies.
 */
export const getAdminBillingCreditCosts = <ThrowOnError extends boolean = false>(
    options?: Options<GetAdminBillingCreditCostsData, ThrowOnError>
): RequestResult<GetAdminBillingCreditCostsResponses, GetAdminBillingCreditCostsErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetAdminBillingCreditCostsResponses, GetAdminBillingCreditCostsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/billing/credit-costs',
        ...options,
    })

/**
 * POST /api/admin/billing/credit-costs
 *
 * Create a named credit cost catalog.
 */
export const postAdminBillingCreditCosts = <ThrowOnError extends boolean = false>(
    options?: Options<PostAdminBillingCreditCostsData, ThrowOnError>
): RequestResult<PostAdminBillingCreditCostsResponses, PostAdminBillingCreditCostsErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostAdminBillingCreditCostsResponses, PostAdminBillingCreditCostsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/billing/credit-costs',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

/**
 * GET /api/admin/billing/plans — list all plans (SuperAdmin).
 *
 * List all billing plans ordered by freemium, price, then name.
 */
export const getAdminBillingPlans = <ThrowOnError extends boolean = false>(
    options?: Options<GetAdminBillingPlansData, ThrowOnError>
): RequestResult<GetAdminBillingPlansResponses, GetAdminBillingPlansErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetAdminBillingPlansResponses, GetAdminBillingPlansErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/billing/plans',
        ...options,
    })

/**
 * POST /api/admin/billing/plans — create plan; sync non-freemium to Stripe.
 *
 * Create a billing plan. Paid plans sync Product + Price to Stripe.
 */
export const postAdminBillingPlans = <ThrowOnError extends boolean = false>(
    options?: Options<PostAdminBillingPlansData, ThrowOnError>
): RequestResult<PostAdminBillingPlansResponses, PostAdminBillingPlansErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostAdminBillingPlansResponses, PostAdminBillingPlansErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/billing/plans',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

/**
 * GET /api/admin/billing/signup-drafts — incomplete signup drafts (SuperAdmin).
 *
 * List incomplete signup drafts for SuperAdmin review.
 */
export const getAdminBillingSignupDrafts = <ThrowOnError extends boolean = false>(
    options?: Options<GetAdminBillingSignupDraftsData, ThrowOnError>
): RequestResult<GetAdminBillingSignupDraftsResponses, GetAdminBillingSignupDraftsErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetAdminBillingSignupDraftsResponses, GetAdminBillingSignupDraftsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/billing/signup-drafts',
        ...options,
    })

/**
 * DELETE /api/admin/billing/credit-costs/[id]
 *
 * Delete a credit cost set. Blocked if default or referenced by plans/companies.
 */
export const deleteAdminBillingCreditCostsId = <ThrowOnError extends boolean = false>(
    options: Options<DeleteAdminBillingCreditCostsIdData, ThrowOnError>
): RequestResult<DeleteAdminBillingCreditCostsIdResponses, DeleteAdminBillingCreditCostsIdErrors, ThrowOnError> =>
    (options.client ?? client).delete<DeleteAdminBillingCreditCostsIdResponses, DeleteAdminBillingCreditCostsIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/billing/credit-costs/{id}',
        ...options,
    })

/**
 * GET /api/admin/billing/credit-costs/[id]
 *
 * Fetch a single credit cost set by id (SuperAdmin).
 */
export const getAdminBillingCreditCostsId = <ThrowOnError extends boolean = false>(
    options: Options<GetAdminBillingCreditCostsIdData, ThrowOnError>
): RequestResult<GetAdminBillingCreditCostsIdResponses, GetAdminBillingCreditCostsIdErrors, ThrowOnError> =>
    (options.client ?? client).get<GetAdminBillingCreditCostsIdResponses, GetAdminBillingCreditCostsIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/billing/credit-costs/{id}',
        ...options,
    })

/**
 * PUT /api/admin/billing/credit-costs/[id]
 *
 * Update a credit cost set name/costs/default flag (SuperAdmin).
 */
export const putAdminBillingCreditCostsId = <ThrowOnError extends boolean = false>(
    options: Options<PutAdminBillingCreditCostsIdData, ThrowOnError>
): RequestResult<PutAdminBillingCreditCostsIdResponses, PutAdminBillingCreditCostsIdErrors, ThrowOnError> =>
    (options.client ?? client).put<PutAdminBillingCreditCostsIdResponses, PutAdminBillingCreditCostsIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/billing/credit-costs/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

/**
 * GET /api/admin/billing/credit-costs/export — portable JSON of all credit cost sets.
 *
 * Export named credit cost catalogs for cross-environment import.
 */
export const getAdminBillingCreditCostsExport = <ThrowOnError extends boolean = false>(
    options?: Options<GetAdminBillingCreditCostsExportData, ThrowOnError>
): RequestResult<GetAdminBillingCreditCostsExportResponses, GetAdminBillingCreditCostsExportErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetAdminBillingCreditCostsExportResponses, GetAdminBillingCreditCostsExportErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/billing/credit-costs/export',
        ...options,
    })

/**
 * POST /api/admin/billing/credit-costs/import — upsert credit cost sets from a portable export.
 *
 * Import named credit cost catalogs (v2) or a single catalog onto the default set (v1).
 */
export const postAdminBillingCreditCostsImport = <ThrowOnError extends boolean = false>(
    options?: Options<PostAdminBillingCreditCostsImportData, ThrowOnError>
): RequestResult<PostAdminBillingCreditCostsImportResponses, PostAdminBillingCreditCostsImportErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostAdminBillingCreditCostsImportResponses, PostAdminBillingCreditCostsImportErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/billing/credit-costs/import',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

/**
 * DELETE /api/admin/billing/plans/[id]
 *
 * Soft-deactivate a billing plan (isActive=false, isPublic=false).
 */
export const deleteAdminBillingPlansId = <ThrowOnError extends boolean = false>(
    options: Options<DeleteAdminBillingPlansIdData, ThrowOnError>
): RequestResult<DeleteAdminBillingPlansIdResponses, DeleteAdminBillingPlansIdErrors, ThrowOnError> =>
    (options.client ?? client).delete<DeleteAdminBillingPlansIdResponses, DeleteAdminBillingPlansIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/billing/plans/{id}',
        ...options,
    })

/**
 * GET /api/admin/billing/plans/[id]
 *
 * Fetch a single billing plan by id (SuperAdmin).
 */
export const getAdminBillingPlansId = <ThrowOnError extends boolean = false>(
    options: Options<GetAdminBillingPlansIdData, ThrowOnError>
): RequestResult<GetAdminBillingPlansIdResponses, GetAdminBillingPlansIdErrors, ThrowOnError> =>
    (options.client ?? client).get<GetAdminBillingPlansIdResponses, GetAdminBillingPlansIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/billing/plans/{id}',
        ...options,
    })

/**
 * PATCH /api/admin/billing/plans/[id]
 *
 * Update a billing plan; sync non-freemium plans to Stripe.
 */
export const patchAdminBillingPlansId = <ThrowOnError extends boolean = false>(
    options: Options<PatchAdminBillingPlansIdData, ThrowOnError>
): RequestResult<PatchAdminBillingPlansIdResponses, PatchAdminBillingPlansIdErrors, ThrowOnError> =>
    (options.client ?? client).patch<PatchAdminBillingPlansIdResponses, PatchAdminBillingPlansIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/billing/plans/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

/**
 * GET /api/admin/billing/plans/export — portable JSON of all plans (no Stripe/env ids).
 *
 * Export all billing plans as a portable JSON payload for cross-environment import.
 */
export const getAdminBillingPlansExport = <ThrowOnError extends boolean = false>(
    options?: Options<GetAdminBillingPlansExportData, ThrowOnError>
): RequestResult<GetAdminBillingPlansExportResponses, GetAdminBillingPlansExportErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetAdminBillingPlansExportResponses, GetAdminBillingPlansExportErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/billing/plans/export',
        ...options,
    })

/**
 * POST /api/admin/billing/plans/import — upsert plans by code from a portable export.
 *
 * Import portable billing plans by code; paid plans sync to this environment's Stripe.
 */
export const postAdminBillingPlansImport = <ThrowOnError extends boolean = false>(
    options?: Options<PostAdminBillingPlansImportData, ThrowOnError>
): RequestResult<PostAdminBillingPlansImportResponses, PostAdminBillingPlansImportErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostAdminBillingPlansImportResponses, PostAdminBillingPlansImportErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/billing/plans/import',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

/**
 * PATCH /api/admin/companies/[id]/billing — assign/update company billing plan (SuperAdmin).
 *
 * Assign or update the billing plan for a company. Stripe subscription cancel/price update only when syncStripeSubscription is true; pause_collection only when syncStripePause is true.
 */
export const patchAdminCompaniesIdBilling = <ThrowOnError extends boolean = false>(
    options: Options<PatchAdminCompaniesIdBillingData, ThrowOnError>
): RequestResult<PatchAdminCompaniesIdBillingResponses, PatchAdminCompaniesIdBillingErrors, ThrowOnError> =>
    (options.client ?? client).patch<PatchAdminCompaniesIdBillingResponses, PatchAdminCompaniesIdBillingErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/companies/{id}/billing',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

/**
 * GET /api/admin/companies/[id]/credits — current credit wallet balance (SuperAdmin).
 *
 * Fetch included, pack, and available credits for a company.
 */
export const getAdminCompaniesIdCredits = <ThrowOnError extends boolean = false>(
    options: Options<GetAdminCompaniesIdCreditsData, ThrowOnError>
): RequestResult<GetAdminCompaniesIdCreditsResponses, GetAdminCompaniesIdCreditsErrors, ThrowOnError> =>
    (options.client ?? client).get<GetAdminCompaniesIdCreditsResponses, GetAdminCompaniesIdCreditsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/companies/{id}/credits',
        ...options,
    })

/**
 * POST /api/admin/companies/[id]/credits — grant credits to a company wallet (SuperAdmin).
 *
 * Grant included or pack credits to a company. Blocked for expired plans.
 */
export const postAdminCompaniesIdCredits = <ThrowOnError extends boolean = false>(
    options: Options<PostAdminCompaniesIdCreditsData, ThrowOnError>
): RequestResult<PostAdminCompaniesIdCreditsResponses, PostAdminCompaniesIdCreditsErrors, ThrowOnError> =>
    (options.client ?? client).post<PostAdminCompaniesIdCreditsResponses, PostAdminCompaniesIdCreditsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/companies/{id}/credits',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

/**
 * POST /api/admin/billing/plans/[id]/sync — push plan Product + Price to Stripe.
 *
 * Sync a paid billing plan's Product and Price to Stripe.
 */
export const postAdminBillingPlansIdSync = <ThrowOnError extends boolean = false>(
    options: Options<PostAdminBillingPlansIdSyncData, ThrowOnError>
): RequestResult<PostAdminBillingPlansIdSyncResponses, PostAdminBillingPlansIdSyncErrors, ThrowOnError> =>
    (options.client ?? client).post<PostAdminBillingPlansIdSyncResponses, PostAdminBillingPlansIdSyncErrors, ThrowOnError>({
        responseType: 'json',
        url: '/admin/billing/plans/{id}/sync',
        ...options,
    })

/**
 * GET /api/admin/companies/[id]/credits/ledger — credit wallet ledger history (SuperAdmin).
 *
 * Paginated credit ledger entries (additions and deductions) for a company. Excludes internal hold/hold_release rows.
 */
export const getAdminCompaniesIdCreditsLedger = <ThrowOnError extends boolean = false>(
    options: Options<GetAdminCompaniesIdCreditsLedgerData, ThrowOnError>
): RequestResult<GetAdminCompaniesIdCreditsLedgerResponses, GetAdminCompaniesIdCreditsLedgerErrors, ThrowOnError> =>
    (options.client ?? client).get<GetAdminCompaniesIdCreditsLedgerResponses, GetAdminCompaniesIdCreditsLedgerErrors, ThrowOnError>({
        responseTransformer: getAdminCompaniesIdCreditsLedgerResponseTransformer,
        responseType: 'json',
        url: '/admin/companies/{id}/credits/ledger',
        ...options,
    })

/**
 * POST /api/admin/companies/[id]/integrations/[integrationId]/reencrypt — move a legacy-encrypted integration secret to Cloud KMS (SuperAdmin).
 *
 * Decrypts the secret with the legacy master key, re-encrypts it with Cloud KMS and verifies the round trip before saving. KMS rows are returned unchanged. The secret is never returned.
 */
export const postAdminCompaniesIdIntegrationsIntegrationIdReencrypt = <ThrowOnError extends boolean = false>(
    options: Options<PostAdminCompaniesIdIntegrationsIntegrationIdReencryptData, ThrowOnError>
): RequestResult<PostAdminCompaniesIdIntegrationsIntegrationIdReencryptResponses, PostAdminCompaniesIdIntegrationsIntegrationIdReencryptErrors, ThrowOnError> =>
    (options.client ?? client).post<
        PostAdminCompaniesIdIntegrationsIntegrationIdReencryptResponses,
        PostAdminCompaniesIdIntegrationsIntegrationIdReencryptErrors,
        ThrowOnError
    >({
        responseType: 'json',
        url: '/admin/companies/{id}/integrations/{integrationId}/reencrypt',
        ...options,
    })

export const postAnalyticsAgent = <ThrowOnError extends boolean = false>(
    options?: Options<PostAnalyticsAgentData, ThrowOnError>
): RequestResult<PostAnalyticsAgentResponses, PostAnalyticsAgentErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostAnalyticsAgentResponses, PostAnalyticsAgentErrors, ThrowOnError>({
        responseType: 'json',
        url: '/analytics-agent',
        ...options,
    })

export const postAnalyticsAgentStream = <ThrowOnError extends boolean = false>(
    options?: Options<PostAnalyticsAgentStreamData, ThrowOnError>
): RequestResult<PostAnalyticsAgentStreamResponses, PostAnalyticsAgentStreamErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostAnalyticsAgentStreamResponses, PostAnalyticsAgentStreamErrors, ThrowOnError>({
        responseType: 'json',
        url: '/analytics-agent/stream',
        ...options,
    })

export const getApplicationsSearch = <ThrowOnError extends boolean = false>(
    options?: Options<GetApplicationsSearchData, ThrowOnError>
): RequestResult<GetApplicationsSearchResponses, GetApplicationsSearchErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetApplicationsSearchResponses, GetApplicationsSearchErrors, ThrowOnError>({
        responseType: 'json',
        url: '/applications/search',
        ...options,
    })

/**
 * GET /api/assessment/params
 *
 * List assessment parameters (competencies) for a company
 */
export const getAssessmentParams = <ThrowOnError extends boolean = false>(
    options: Options<GetAssessmentParamsData, ThrowOnError>
): RequestResult<GetAssessmentParamsResponses, GetAssessmentParamsErrors, ThrowOnError> =>
    (options.client ?? client).get<GetAssessmentParamsResponses, GetAssessmentParamsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/assessment/params',
        ...options,
    })

/**
 * POST /api/assessment/params
 *
 * Create an assessment parameter (competency) with optional per-channel questions (template-save rules apply)
 */
export const postAssessmentParams = <ThrowOnError extends boolean = false>(
    options?: Options<PostAssessmentParamsData, ThrowOnError>
): RequestResult<PostAssessmentParamsResponses, PostAssessmentParamsErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostAssessmentParamsResponses, PostAssessmentParamsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/assessment/params',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

/**
 * GET /api/assessment/templates
 *
 * List assessment templates for a company
 */
export const getAssessmentTemplates = <ThrowOnError extends boolean = false>(
    options: Options<GetAssessmentTemplatesData, ThrowOnError>
): RequestResult<GetAssessmentTemplatesResponses, GetAssessmentTemplatesErrors, ThrowOnError> =>
    (options.client ?? client).get<GetAssessmentTemplatesResponses, GetAssessmentTemplatesErrors, ThrowOnError>({
        responseType: 'json',
        url: '/assessment/templates',
        ...options,
    })

/**
 * POST /api/assessment/templates
 *
 * Create a new assessment template for a company
 */
export const postAssessmentTemplates = <ThrowOnError extends boolean = false>(
    options?: Options<PostAssessmentTemplatesData, ThrowOnError>
): RequestResult<PostAssessmentTemplatesResponses, PostAssessmentTemplatesErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostAssessmentTemplatesResponses, PostAssessmentTemplatesErrors, ThrowOnError>({
        responseType: 'json',
        url: '/assessment/templates',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

/**
 * DELETE /api/assessment/params/{id}
 *
 * Delete an assessment parameter (409 when linked to an assessment template)
 */
export const deleteAssessmentParamsId = <ThrowOnError extends boolean = false>(
    options: Options<DeleteAssessmentParamsIdData, ThrowOnError>
): RequestResult<DeleteAssessmentParamsIdResponses, DeleteAssessmentParamsIdErrors, ThrowOnError> =>
    (options.client ?? client).delete<DeleteAssessmentParamsIdResponses, DeleteAssessmentParamsIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/assessment/params/{id}',
        ...options,
    })

/**
 * GET /api/assessment/params/{id}
 *
 * Fetch a single assessment parameter (competency) with its linked template/job usage
 */
export const getAssessmentParamsId = <ThrowOnError extends boolean = false>(
    options: Options<GetAssessmentParamsIdData, ThrowOnError>
): RequestResult<GetAssessmentParamsIdResponses, GetAssessmentParamsIdErrors, ThrowOnError> =>
    (options.client ?? client).get<GetAssessmentParamsIdResponses, GetAssessmentParamsIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/assessment/params/{id}',
        ...options,
    })

/**
 * PUT /api/assessment/params/{id}
 *
 * Update an assessment parameter (competency). Scoped to the company in the body — cross-company ids return 404. Per-channel Q&A follows the template-save rules (400 on a missing or too-short question).
 */
export const putAssessmentParamsId = <ThrowOnError extends boolean = false>(
    options: Options<PutAssessmentParamsIdData, ThrowOnError>
): RequestResult<PutAssessmentParamsIdResponses, PutAssessmentParamsIdErrors, ThrowOnError> =>
    (options.client ?? client).put<PutAssessmentParamsIdResponses, PutAssessmentParamsIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/assessment/params/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

/**
 * DELETE /api/assessment/templates/{id}
 *
 * Delete an assessment template (409 when linked to job postings)
 */
export const deleteAssessmentTemplatesId = <ThrowOnError extends boolean = false>(
    options: Options<DeleteAssessmentTemplatesIdData, ThrowOnError>
): RequestResult<DeleteAssessmentTemplatesIdResponses, DeleteAssessmentTemplatesIdErrors, ThrowOnError> =>
    (options.client ?? client).delete<DeleteAssessmentTemplatesIdResponses, DeleteAssessmentTemplatesIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/assessment/templates/{id}',
        ...options,
    })

/**
 * GET /api/assessment/templates/{id}
 *
 * Fetch a single assessment template including linked job count
 */
export const getAssessmentTemplatesId = <ThrowOnError extends boolean = false>(
    options: Options<GetAssessmentTemplatesIdData, ThrowOnError>
): RequestResult<GetAssessmentTemplatesIdResponses, GetAssessmentTemplatesIdErrors, ThrowOnError> =>
    (options.client ?? client).get<GetAssessmentTemplatesIdResponses, GetAssessmentTemplatesIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/assessment/templates/{id}',
        ...options,
    })

/**
 * PUT /api/assessment/templates/{id}
 *
 * Update an assessment template. When `AssessmentParameters` is omitted, every existing link is removed — the frontend always sends the full list.
 */
export const putAssessmentTemplatesId = <ThrowOnError extends boolean = false>(
    options: Options<PutAssessmentTemplatesIdData, ThrowOnError>
): RequestResult<PutAssessmentTemplatesIdResponses, PutAssessmentTemplatesIdErrors, ThrowOnError> =>
    (options.client ?? client).put<PutAssessmentTemplatesIdResponses, PutAssessmentTemplatesIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/assessment/templates/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

/**
 * POST /api/assessment/params/{id}/copy
 *
 * Copy a competency under a new name — its definition, every channel's Q&A and question sources (template links are not copied). 409 when the name is taken.
 */
export const postAssessmentParamsIdCopy = <ThrowOnError extends boolean = false>(
    options: Options<PostAssessmentParamsIdCopyData, ThrowOnError>
): RequestResult<PostAssessmentParamsIdCopyResponses, PostAssessmentParamsIdCopyErrors, ThrowOnError> =>
    (options.client ?? client).post<PostAssessmentParamsIdCopyResponses, PostAssessmentParamsIdCopyErrors, ThrowOnError>({
        responseType: 'json',
        url: '/assessment/params/{id}/copy',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

/**
 * Public logout callback endpoint.
 */
export const getAuthLogoutCallback = <ThrowOnError extends boolean = false>(
    options?: Options<GetAuthLogoutCallbackData, ThrowOnError>
): RequestResult<unknown, GetAuthLogoutCallbackErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetAuthLogoutCallbackErrors, ThrowOnError>({ url: '/auth/logout-callback', ...options })

/**
 * GET /api/auth/my-companies — organizations the signed-in user belongs to.
 *
 * Lists the user's active memberships on non-archived companies, for the company picker.
 */
export const getAuthMyCompanies = <ThrowOnError extends boolean = false>(
    options?: Options<GetAuthMyCompaniesData, ThrowOnError>
): RequestResult<GetAuthMyCompaniesResponses, GetAuthMyCompaniesErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetAuthMyCompaniesResponses, GetAuthMyCompaniesErrors, ThrowOnError>({
        responseTransformer: getAuthMyCompaniesResponseTransformer,
        responseType: 'json',
        url: '/auth/my-companies',
        ...options,
    })

/**
 * GET /api/auth/profile?companySlug=… — current user name, email, picture (session + Auth0).
 */
export const getAuthProfile = <ThrowOnError extends boolean = false>(
    options: Options<GetAuthProfileData, ThrowOnError>
): RequestResult<GetAuthProfileResponses, GetAuthProfileErrors, ThrowOnError> =>
    (options.client ?? client).get<GetAuthProfileResponses, GetAuthProfileErrors, ThrowOnError>({
        responseType: 'json',
        url: '/auth/profile',
        ...options,
    })

/**
 * PUT /api/auth/profile?companySlug=… — multipart: optional `name`, optional `avatar` file.
 */
export const putAuthProfile = <ThrowOnError extends boolean = false>(
    options: Options<PutAuthProfileData, ThrowOnError>
): RequestResult<PutAuthProfileResponses, PutAuthProfileErrors, ThrowOnError> =>
    (options.client ?? client).put<PutAuthProfileResponses, PutAuthProfileErrors, ThrowOnError>({
        ...formDataBodySerializer,
        responseType: 'json',
        url: '/auth/profile',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers,
        },
    })

/**
 * POST /api/auth/set-company — set the active company on the user's session.
 *
 * Verifies the user belongs to the company, then injects companyId and roles into the Auth0 session cookie.
 */
export const postAuthSetCompany = <ThrowOnError extends boolean = false>(
    options?: Options<PostAuthSetCompanyData, ThrowOnError>
): RequestResult<PostAuthSetCompanyResponses, PostAuthSetCompanyErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostAuthSetCompanyResponses, PostAuthSetCompanyErrors, ThrowOnError>({
        responseType: 'json',
        url: '/auth/set-company',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

export const getAuthSwitchCompany = <ThrowOnError extends boolean = false>(
    options?: Options<GetAuthSwitchCompanyData, ThrowOnError>
): RequestResult<unknown, GetAuthSwitchCompanyErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetAuthSwitchCompanyErrors, ThrowOnError>({ url: '/auth/switch-company', ...options })

/**
 * POST /api/billing/change-plan
 *
 * Upgrade the company plan via Checkout (freemium) or subscription update (paid).
 */
export const postBillingChangePlan = <ThrowOnError extends boolean = false>(
    options?: Options<PostBillingChangePlanData, ThrowOnError>
): RequestResult<PostBillingChangePlanResponses, PostBillingChangePlanErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostBillingChangePlanResponses, PostBillingChangePlanErrors, ThrowOnError>({
        responseType: 'json',
        url: '/billing/change-plan',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

/**
 * POST /api/billing/complete-checkout
 *
 * Apply upgrade or credit-pack Checkout session to the company billing state.
 */
export const postBillingCompleteCheckout = <ThrowOnError extends boolean = false>(
    options?: Options<PostBillingCompleteCheckoutData, ThrowOnError>
): RequestResult<PostBillingCompleteCheckoutResponses, PostBillingCompleteCheckoutErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostBillingCompleteCheckoutResponses, PostBillingCompleteCheckoutErrors, ThrowOnError>({
        responseType: 'json',
        url: '/billing/complete-checkout',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

/**
 * POST /api/billing/credit-packs
 */
export const postBillingCreditPacks = <ThrowOnError extends boolean = false>(
    options?: Options<PostBillingCreditPacksData, ThrowOnError>
): RequestResult<unknown, PostBillingCreditPacksErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostBillingCreditPacksErrors, ThrowOnError>({ url: '/billing/credit-packs', ...options })

/**
 * GET /api/billing/plans?companySlug=…
 *
 * List public billing plans relative to the company's current plan.
 */
export const getBillingPlans = <ThrowOnError extends boolean = false>(
    options?: Options<GetBillingPlansData, ThrowOnError>
): RequestResult<GetBillingPlansResponses, GetBillingPlansErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetBillingPlansResponses, GetBillingPlansErrors, ThrowOnError>({
        responseType: 'json',
        url: '/billing/plans',
        ...options,
    })

/**
 * POST /api/billing/portal
 *
 * Create a Stripe Billing Portal session for the company.
 */
export const postBillingPortal = <ThrowOnError extends boolean = false>(
    options?: Options<PostBillingPortalData, ThrowOnError>
): RequestResult<PostBillingPortalResponses, PostBillingPortalErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostBillingPortalResponses, PostBillingPortalErrors, ThrowOnError>({
        responseType: 'json',
        url: '/billing/portal',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

/**
 * GET /api/billing/subscription?companySlug=…
 *
 * Fetch the current company's billing subscription and plan summary.
 */
export const getBillingSubscription = <ThrowOnError extends boolean = false>(
    options?: Options<GetBillingSubscriptionData, ThrowOnError>
): RequestResult<GetBillingSubscriptionResponses, GetBillingSubscriptionErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetBillingSubscriptionResponses, GetBillingSubscriptionErrors, ThrowOnError>({
        responseType: 'json',
        url: '/billing/subscription',
        ...options,
    })

/**
 * GET /api/billing/usage?companySlug=…
 *
 * Fetch current plan limits and usage counters for the company.
 */
export const getBillingUsage = <ThrowOnError extends boolean = false>(
    options?: Options<GetBillingUsageData, ThrowOnError>
): RequestResult<GetBillingUsageResponses, GetBillingUsageErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetBillingUsageResponses, GetBillingUsageErrors, ThrowOnError>({
        responseType: 'json',
        url: '/billing/usage',
        ...options,
    })

export const postCalendar = <ThrowOnError extends boolean = false>(
    options?: Options<PostCalendarData, ThrowOnError>
): RequestResult<unknown, PostCalendarErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostCalendarErrors, ThrowOnError>({ url: '/calendar', ...options })

export const putCalendar = <ThrowOnError extends boolean = false>(
    options?: Options<PutCalendarData, ThrowOnError>
): RequestResult<unknown, PutCalendarErrors, ThrowOnError> =>
    (options?.client ?? client).put<unknown, PutCalendarErrors, ThrowOnError>({ url: '/calendar', ...options })

export const postCalendarAvailability = <ThrowOnError extends boolean = false>(
    options?: Options<PostCalendarAvailabilityData, ThrowOnError>
): RequestResult<unknown, PostCalendarAvailabilityErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostCalendarAvailabilityErrors, ThrowOnError>({ url: '/calendar/availability', ...options })

export const patchCalendarGenerateTranscript = <ThrowOnError extends boolean = false>(
    options?: Options<PatchCalendarGenerateTranscriptData, ThrowOnError>
): RequestResult<unknown, PatchCalendarGenerateTranscriptErrors, ThrowOnError> =>
    (options?.client ?? client).patch<unknown, PatchCalendarGenerateTranscriptErrors, ThrowOnError>({ url: '/calendar/generate-transcript', ...options })

export const postCalendarGenerateTranscript = <ThrowOnError extends boolean = false>(
    options?: Options<PostCalendarGenerateTranscriptData, ThrowOnError>
): RequestResult<unknown, PostCalendarGenerateTranscriptErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostCalendarGenerateTranscriptErrors, ThrowOnError>({ url: '/calendar/generate-transcript', ...options })

export const postCalendarPanelistSlots = <ThrowOnError extends boolean = false>(
    options?: Options<PostCalendarPanelistSlotsData, ThrowOnError>
): RequestResult<unknown, PostCalendarPanelistSlotsErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostCalendarPanelistSlotsErrors, ThrowOnError>({ url: '/calendar/panelist-slots', ...options })

export const postCalendarSchedulingSlots = <ThrowOnError extends boolean = false>(
    options?: Options<PostCalendarSchedulingSlotsData, ThrowOnError>
): RequestResult<unknown, PostCalendarSchedulingSlotsErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostCalendarSchedulingSlotsErrors, ThrowOnError>({ url: '/calendar/scheduling-slots', ...options })

export const postCalendarPanelistSlotsComments = <ThrowOnError extends boolean = false>(
    options?: Options<PostCalendarPanelistSlotsCommentsData, ThrowOnError>
): RequestResult<unknown, PostCalendarPanelistSlotsCommentsErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostCalendarPanelistSlotsCommentsErrors, ThrowOnError>({ url: '/calendar/panelist-slots/comments', ...options })

export const postCalendarPanelistSlotsGenerate = <ThrowOnError extends boolean = false>(
    options?: Options<PostCalendarPanelistSlotsGenerateData, ThrowOnError>
): RequestResult<unknown, PostCalendarPanelistSlotsGenerateErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostCalendarPanelistSlotsGenerateErrors, ThrowOnError>({ url: '/calendar/panelist-slots/generate', ...options })

export const getCandidateSharingSharingSlug = <ThrowOnError extends boolean = false>(
    options: Options<GetCandidateSharingSharingSlugData, ThrowOnError>
): RequestResult<unknown, GetCandidateSharingSharingSlugErrors, ThrowOnError> =>
    (options.client ?? client).get<unknown, GetCandidateSharingSharingSlugErrors, ThrowOnError>({ url: '/candidate-sharing/{sharingSlug}', ...options })

export const putCandidateSharingSharingSlugFeedback = <ThrowOnError extends boolean = false>(
    options: Options<PutCandidateSharingSharingSlugFeedbackData, ThrowOnError>
): RequestResult<unknown, PutCandidateSharingSharingSlugFeedbackErrors, ThrowOnError> =>
    (options.client ?? client).put<unknown, PutCandidateSharingSharingSlugFeedbackErrors, ThrowOnError>({
        url: '/candidate-sharing/{sharingSlug}/feedback',
        ...options,
    })

/**
 * GET /api/candidates
 *
 * List candidates for the session company (talent pool). Free text goes in `filterModel.quickFilterValues`; the legacy vector search is the default unless `useLegacySearch=false` selects the new search.
 */
export const getCandidates = <ThrowOnError extends boolean = false>(
    options?: Options<GetCandidatesData, ThrowOnError>
): RequestResult<GetCandidatesResponses, GetCandidatesErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetCandidatesResponses, GetCandidatesErrors, ThrowOnError>({
        responseType: 'json',
        url: '/candidates',
        ...options,
    })

/**
 * TODO: Make it generic so other integrations can also use it.
 */
export const postCandidates = <ThrowOnError extends boolean = false>(
    options?: Options<PostCandidatesData, ThrowOnError>
): RequestResult<PostCandidatesResponses, PostCandidatesErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostCandidatesResponses, PostCandidatesErrors, ThrowOnError>({
        responseType: 'json',
        url: '/candidates',
        ...options,
    })

/**
 * Deletes a candidate and their associated job application candidate details.
 */
export const deleteCandidatesId = <ThrowOnError extends boolean = false>(
    options: Options<DeleteCandidatesIdData, ThrowOnError>
): RequestResult<unknown, DeleteCandidatesIdErrors, ThrowOnError> =>
    (options.client ?? client).delete<unknown, DeleteCandidatesIdErrors, ThrowOnError>({ url: '/candidates/{id}', ...options })

/**
 * GET API for fetching Candidates by id
 */
export const getCandidatesId = <ThrowOnError extends boolean = false>(
    options: Options<GetCandidatesIdData, ThrowOnError>
): RequestResult<unknown, GetCandidatesIdErrors, ThrowOnError> =>
    (options.client ?? client).get<unknown, GetCandidatesIdErrors, ThrowOnError>({ url: '/candidates/{id}', ...options })

export const putCandidatesId = <ThrowOnError extends boolean = false>(
    options: Options<PutCandidatesIdData, ThrowOnError>
): RequestResult<unknown, PutCandidatesIdErrors, ThrowOnError> =>
    (options.client ?? client).put<unknown, PutCandidatesIdErrors, ThrowOnError>({ url: '/candidates/{id}', ...options })

export const postCandidatesBulkDelete = <ThrowOnError extends boolean = false>(
    options?: Options<PostCandidatesBulkDeleteData, ThrowOnError>
): RequestResult<PostCandidatesBulkDeleteResponses, PostCandidatesBulkDeleteErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostCandidatesBulkDeleteResponses, PostCandidatesBulkDeleteErrors, ThrowOnError>({
        responseType: 'json',
        url: '/candidates/bulk-delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

export const postCandidatesParseQuery = <ThrowOnError extends boolean = false>(
    options?: Options<PostCandidatesParseQueryData, ThrowOnError>
): RequestResult<PostCandidatesParseQueryResponses, PostCandidatesParseQueryErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostCandidatesParseQueryResponses, PostCandidatesParseQueryErrors, ThrowOnError>({
        responseType: 'json',
        url: '/candidates/parse-query',
        ...options,
    })

export const getChatbotConfig = <ThrowOnError extends boolean = false>(
    options?: Options<GetChatbotConfigData, ThrowOnError>
): RequestResult<GetChatbotConfigResponses, GetChatbotConfigErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetChatbotConfigResponses, GetChatbotConfigErrors, ThrowOnError>({
        responseType: 'json',
        url: '/chatbot/config',
        ...options,
    })

export const postCommunicationStatusCreate = <ThrowOnError extends boolean = false>(
    options?: Options<PostCommunicationStatusCreateData, ThrowOnError>
): RequestResult<unknown, PostCommunicationStatusCreateErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostCommunicationStatusCreateErrors, ThrowOnError>({ url: '/communication-status/create', ...options })

/**
 * GET /api/communication-status/email/[clientId]?clientType=screening_interview
 */
export const getCommunicationStatusEmailClientId = <ThrowOnError extends boolean = false>(
    options: Options<GetCommunicationStatusEmailClientIdData, ThrowOnError>
): RequestResult<unknown, GetCommunicationStatusEmailClientIdErrors, ThrowOnError> =>
    (options.client ?? client).get<unknown, GetCommunicationStatusEmailClientIdErrors, ThrowOnError>({
        url: '/communication-status/email/{clientId}',
        ...options,
    })

export const getCompany = <ThrowOnError extends boolean = false>(
    options?: Options<GetCompanyData, ThrowOnError>
): RequestResult<unknown, GetCompanyErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetCompanyErrors, ThrowOnError>({ url: '/company', ...options })

/**
 * GET /api/company/config — fetch a company's full config row. SuperAdmin only (returns sensitive fields like twilioDetails).
 */
export const getCompanyConfig = <ThrowOnError extends boolean = false>(
    options?: Options<GetCompanyConfigData, ThrowOnError>
): RequestResult<unknown, GetCompanyConfigErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetCompanyConfigErrors, ThrowOnError>({ url: '/company/config', ...options })

/**
 * POST /api/company/config — create a CompanyConfig with autoApprove + default approvers. SuperAdmin only.
 */
export const postCompanyConfig = <ThrowOnError extends boolean = false>(
    options?: Options<PostCompanyConfigData, ThrowOnError>
): RequestResult<PostCompanyConfigResponses, PostCompanyConfigErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostCompanyConfigResponses, PostCompanyConfigErrors, ThrowOnError>({
        responseTransformer: postCompanyConfigResponseTransformer,
        responseType: 'json',
        url: '/company/config',
        ...options,
    })

/**
 * PUT /api/company/config — update autoApprove/default approvers, or store Twilio subaccount details. SuperAdmin only.
 */
export const putCompanyConfig = <ThrowOnError extends boolean = false>(
    options?: Options<PutCompanyConfigData, ThrowOnError>
): RequestResult<PutCompanyConfigResponses, PutCompanyConfigErrors, ThrowOnError> =>
    (options?.client ?? client).put<PutCompanyConfigResponses, PutCompanyConfigErrors, ThrowOnError>({
        responseTransformer: putCompanyConfigResponseTransformer,
        responseType: 'json',
        url: '/company/config',
        ...options,
    })

export const getCompanyDepartments = <ThrowOnError extends boolean = false>(
    options?: Options<GetCompanyDepartmentsData, ThrowOnError>
): RequestResult<unknown, GetCompanyDepartmentsErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetCompanyDepartmentsErrors, ThrowOnError>({ url: '/company/departments', ...options })

export const getCompanyEmploymentTypes = <ThrowOnError extends boolean = false>(
    options?: Options<GetCompanyEmploymentTypesData, ThrowOnError>
): RequestResult<unknown, GetCompanyEmploymentTypesErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetCompanyEmploymentTypesErrors, ThrowOnError>({ url: '/company/employment-types', ...options })

/**
 * POST /api/company/grade - Add new grade to company config
 */
export const postCompanyGrade = <ThrowOnError extends boolean = false>(
    options?: Options<PostCompanyGradeData, ThrowOnError>
): RequestResult<PostCompanyGradeResponses, PostCompanyGradeErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostCompanyGradeResponses, PostCompanyGradeErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/grade',
        ...options,
    })

/**
 * POST /api/company/title-grade - Add new title and grades to company config
 */
export const postCompanyTitleGrade = <ThrowOnError extends boolean = false>(
    options?: Options<PostCompanyTitleGradeData, ThrowOnError>
): RequestResult<PostCompanyTitleGradeResponses, PostCompanyTitleGradeErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostCompanyTitleGradeResponses, PostCompanyTitleGradeErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/title-grade',
        ...options,
    })

export const getCompanyCompanySlugAccessControlConfig = <ThrowOnError extends boolean = false>(
    options: Options<GetCompanyCompanySlugAccessControlConfigData, ThrowOnError>
): RequestResult<GetCompanyCompanySlugAccessControlConfigResponses, GetCompanyCompanySlugAccessControlConfigErrors, ThrowOnError> =>
    (options.client ?? client).get<GetCompanyCompanySlugAccessControlConfigResponses, GetCompanyCompanySlugAccessControlConfigErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/{companySlug}/access-control-config',
        ...options,
    })

export const putCompanyCompanySlugAccessControlConfig = <ThrowOnError extends boolean = false>(
    options: Options<PutCompanyCompanySlugAccessControlConfigData, ThrowOnError>
): RequestResult<PutCompanyCompanySlugAccessControlConfigResponses, PutCompanyCompanySlugAccessControlConfigErrors, ThrowOnError> =>
    (options.client ?? client).put<PutCompanyCompanySlugAccessControlConfigResponses, PutCompanyCompanySlugAccessControlConfigErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/{companySlug}/access-control-config',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

export const getCompanyCompanySlugApprovalFlow = <ThrowOnError extends boolean = false>(
    options: Options<GetCompanyCompanySlugApprovalFlowData, ThrowOnError>
): RequestResult<GetCompanyCompanySlugApprovalFlowResponses, GetCompanyCompanySlugApprovalFlowErrors, ThrowOnError> =>
    (options.client ?? client).get<GetCompanyCompanySlugApprovalFlowResponses, GetCompanyCompanySlugApprovalFlowErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/{companySlug}/approval-flow',
        ...options,
    })

export const patchCompanyCompanySlugApprovalFlow = <ThrowOnError extends boolean = false>(
    options: Options<PatchCompanyCompanySlugApprovalFlowData, ThrowOnError>
): RequestResult<PatchCompanyCompanySlugApprovalFlowResponses, PatchCompanyCompanySlugApprovalFlowErrors, ThrowOnError> =>
    (options.client ?? client).patch<PatchCompanyCompanySlugApprovalFlowResponses, PatchCompanyCompanySlugApprovalFlowErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/{companySlug}/approval-flow',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

export const postCompanyCompanySlugApprovalFlow = <ThrowOnError extends boolean = false>(
    options: Options<PostCompanyCompanySlugApprovalFlowData, ThrowOnError>
): RequestResult<PostCompanyCompanySlugApprovalFlowResponses, PostCompanyCompanySlugApprovalFlowErrors, ThrowOnError> =>
    (options.client ?? client).post<PostCompanyCompanySlugApprovalFlowResponses, PostCompanyCompanySlugApprovalFlowErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/{companySlug}/approval-flow',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

/**
 * GET: Read candidate statuses configuration (CRUD: Read)
 */
export const getCompanyCompanySlugCandidateStatusesConfig = <ThrowOnError extends boolean = false>(
    options: Options<GetCompanyCompanySlugCandidateStatusesConfigData, ThrowOnError>
): RequestResult<GetCompanyCompanySlugCandidateStatusesConfigResponses, GetCompanyCompanySlugCandidateStatusesConfigErrors, ThrowOnError> =>
    (options.client ?? client).get<GetCompanyCompanySlugCandidateStatusesConfigResponses, GetCompanyCompanySlugCandidateStatusesConfigErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/{companySlug}/candidate-statuses-config',
        ...options,
    })

/**
 * POST: Create a new custom status (CRUD: Create)
 */
export const postCompanyCompanySlugCandidateStatusesConfig = <ThrowOnError extends boolean = false>(
    options: Options<PostCompanyCompanySlugCandidateStatusesConfigData, ThrowOnError>
): RequestResult<PostCompanyCompanySlugCandidateStatusesConfigResponses, PostCompanyCompanySlugCandidateStatusesConfigErrors, ThrowOnError> =>
    (options.client ?? client).post<PostCompanyCompanySlugCandidateStatusesConfigResponses, PostCompanyCompanySlugCandidateStatusesConfigErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/{companySlug}/candidate-statuses-config',
        ...options,
    })

/**
 * PUT: Bulk Update / Reorder status configuration (CRUD: Bulk Update)
 */
export const putCompanyCompanySlugCandidateStatusesConfig = <ThrowOnError extends boolean = false>(
    options: Options<PutCompanyCompanySlugCandidateStatusesConfigData, ThrowOnError>
): RequestResult<PutCompanyCompanySlugCandidateStatusesConfigResponses, PutCompanyCompanySlugCandidateStatusesConfigErrors, ThrowOnError> =>
    (options.client ?? client).put<PutCompanyCompanySlugCandidateStatusesConfigResponses, PutCompanyCompanySlugCandidateStatusesConfigErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/{companySlug}/candidate-statuses-config',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

/**
 * Delete a department when it has no blocking relations. Admin or SuperAdmin only.
 */
export const deleteCompanyCompanySlugDepartments = <ThrowOnError extends boolean = false>(
    options: Options<DeleteCompanyCompanySlugDepartmentsData, ThrowOnError>
): RequestResult<DeleteCompanyCompanySlugDepartmentsResponses, DeleteCompanyCompanySlugDepartmentsErrors, ThrowOnError> =>
    (options.client ?? client).delete<DeleteCompanyCompanySlugDepartmentsResponses, DeleteCompanyCompanySlugDepartmentsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/{companySlug}/departments',
        ...options,
    })

export const getCompanyCompanySlugDepartments = <ThrowOnError extends boolean = false>(
    options: Options<GetCompanyCompanySlugDepartmentsData, ThrowOnError>
): RequestResult<GetCompanyCompanySlugDepartmentsResponses, GetCompanyCompanySlugDepartmentsErrors, ThrowOnError> =>
    (options.client ?? client).get<GetCompanyCompanySlugDepartmentsResponses, GetCompanyCompanySlugDepartmentsErrors, ThrowOnError>({
        responseTransformer: getCompanyCompanySlugDepartmentsResponseTransformer,
        responseType: 'json',
        url: '/company/{companySlug}/departments',
        ...options,
    })

/**
 * Update a department name. Admin or SuperAdmin only.
 */
export const patchCompanyCompanySlugDepartments = <ThrowOnError extends boolean = false>(
    options: Options<PatchCompanyCompanySlugDepartmentsData, ThrowOnError>
): RequestResult<PatchCompanyCompanySlugDepartmentsResponses, PatchCompanyCompanySlugDepartmentsErrors, ThrowOnError> =>
    (options.client ?? client).patch<PatchCompanyCompanySlugDepartmentsResponses, PatchCompanyCompanySlugDepartmentsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/{companySlug}/departments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

/**
 * Create a department. Admin or SuperAdmin only.
 */
export const postCompanyCompanySlugDepartments = <ThrowOnError extends boolean = false>(
    options: Options<PostCompanyCompanySlugDepartmentsData, ThrowOnError>
): RequestResult<PostCompanyCompanySlugDepartmentsResponses, PostCompanyCompanySlugDepartmentsErrors, ThrowOnError> =>
    (options.client ?? client).post<PostCompanyCompanySlugDepartmentsResponses, PostCompanyCompanySlugDepartmentsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/{companySlug}/departments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

/**
 * GET /api/company/[companySlug]/integrations
 */
export const getCompanyCompanySlugIntegrations = <ThrowOnError extends boolean = false>(
    options: Options<GetCompanyCompanySlugIntegrationsData, ThrowOnError>
): RequestResult<GetCompanyCompanySlugIntegrationsResponses, GetCompanyCompanySlugIntegrationsErrors, ThrowOnError> =>
    (options.client ?? client).get<GetCompanyCompanySlugIntegrationsResponses, GetCompanyCompanySlugIntegrationsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/{companySlug}/integrations',
        ...options,
    })

/**
 * PATCH /api/company/[companySlug]/integrations
 */
export const patchCompanyCompanySlugIntegrations = <ThrowOnError extends boolean = false>(
    options: Options<PatchCompanyCompanySlugIntegrationsData, ThrowOnError>
): RequestResult<PatchCompanyCompanySlugIntegrationsResponses, PatchCompanyCompanySlugIntegrationsErrors, ThrowOnError> =>
    (options.client ?? client).patch<PatchCompanyCompanySlugIntegrationsResponses, PatchCompanyCompanySlugIntegrationsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/{companySlug}/integrations',
        ...options,
    })

export const getCompanyCompanySlugJdTemplate = <ThrowOnError extends boolean = false>(
    options: Options<GetCompanyCompanySlugJdTemplateData, ThrowOnError>
): RequestResult<GetCompanyCompanySlugJdTemplateResponses, GetCompanyCompanySlugJdTemplateErrors, ThrowOnError> =>
    (options.client ?? client).get<GetCompanyCompanySlugJdTemplateResponses, GetCompanyCompanySlugJdTemplateErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/{companySlug}/jd-template',
        ...options,
    })

export const putCompanyCompanySlugJdTemplate = <ThrowOnError extends boolean = false>(
    options: Options<PutCompanyCompanySlugJdTemplateData, ThrowOnError>
): RequestResult<PutCompanyCompanySlugJdTemplateResponses, PutCompanyCompanySlugJdTemplateErrors, ThrowOnError> =>
    (options.client ?? client).put<PutCompanyCompanySlugJdTemplateResponses, PutCompanyCompanySlugJdTemplateErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/{companySlug}/jd-template',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

export const getCompanyCompanySlugJobPostingConfig = <ThrowOnError extends boolean = false>(
    options: Options<GetCompanyCompanySlugJobPostingConfigData, ThrowOnError>
): RequestResult<GetCompanyCompanySlugJobPostingConfigResponses, GetCompanyCompanySlugJobPostingConfigErrors, ThrowOnError> =>
    (options.client ?? client).get<GetCompanyCompanySlugJobPostingConfigResponses, GetCompanyCompanySlugJobPostingConfigErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/{companySlug}/job-posting-config',
        ...options,
    })

export const putCompanyCompanySlugJobPostingConfig = <ThrowOnError extends boolean = false>(
    options: Options<PutCompanyCompanySlugJobPostingConfigData, ThrowOnError>
): RequestResult<PutCompanyCompanySlugJobPostingConfigResponses, PutCompanyCompanySlugJobPostingConfigErrors, ThrowOnError> =>
    (options.client ?? client).put<PutCompanyCompanySlugJobPostingConfigResponses, PutCompanyCompanySlugJobPostingConfigErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/{companySlug}/job-posting-config',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

/**
 * POST /api/company/[companySlug]/logo
 */
export const postCompanyCompanySlugLogo = <ThrowOnError extends boolean = false>(
    options: Options<PostCompanyCompanySlugLogoData, ThrowOnError>
): RequestResult<PostCompanyCompanySlugLogoResponses, PostCompanyCompanySlugLogoErrors, ThrowOnError> =>
    (options.client ?? client).post<PostCompanyCompanySlugLogoResponses, PostCompanyCompanySlugLogoErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/{companySlug}/logo',
        ...options,
    })

export const getCompanyCompanySlugPanellists = <ThrowOnError extends boolean = false>(
    options: Options<GetCompanyCompanySlugPanellistsData, ThrowOnError>
): RequestResult<unknown, GetCompanyCompanySlugPanellistsErrors, ThrowOnError> =>
    (options.client ?? client).get<unknown, GetCompanyCompanySlugPanellistsErrors, ThrowOnError>({ url: '/company/{companySlug}/panellists', ...options })

export const getCompanyCompanySlugScreeningWebrtcConfig = <ThrowOnError extends boolean = false>(
    options: Options<GetCompanyCompanySlugScreeningWebrtcConfigData, ThrowOnError>
): RequestResult<GetCompanyCompanySlugScreeningWebrtcConfigResponses, GetCompanyCompanySlugScreeningWebrtcConfigErrors, ThrowOnError> =>
    (options.client ?? client).get<GetCompanyCompanySlugScreeningWebrtcConfigResponses, GetCompanyCompanySlugScreeningWebrtcConfigErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/{companySlug}/screening-webrtc-config',
        ...options,
    })

export const patchCompanyCompanySlugScreeningWebrtcConfig = <ThrowOnError extends boolean = false>(
    options: Options<PatchCompanyCompanySlugScreeningWebrtcConfigData, ThrowOnError>
): RequestResult<PatchCompanyCompanySlugScreeningWebrtcConfigResponses, PatchCompanyCompanySlugScreeningWebrtcConfigErrors, ThrowOnError> =>
    (options.client ?? client).patch<PatchCompanyCompanySlugScreeningWebrtcConfigResponses, PatchCompanyCompanySlugScreeningWebrtcConfigErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/{companySlug}/screening-webrtc-config',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

/**
 * Get list of users under a company
 *
 * Fetches list of users under a company
 */
export const getCompanyCompanySlugUsers = <ThrowOnError extends boolean = false>(
    options: Options<GetCompanyCompanySlugUsersData, ThrowOnError>
): RequestResult<GetCompanyCompanySlugUsersResponses, GetCompanyCompanySlugUsersErrors, ThrowOnError> =>
    (options.client ?? client).get<GetCompanyCompanySlugUsersResponses, GetCompanyCompanySlugUsersErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/{companySlug}/users',
        ...options,
    })

/**
 * Add a user to the company. Caller must be Admin or SuperAdmin.
 */
export const postCompanyCompanySlugUsers = <ThrowOnError extends boolean = false>(
    options: Options<PostCompanyCompanySlugUsersData, ThrowOnError>
): RequestResult<PostCompanyCompanySlugUsersResponses, PostCompanyCompanySlugUsersErrors, ThrowOnError> =>
    (options.client ?? client).post<PostCompanyCompanySlugUsersResponses, PostCompanyCompanySlugUsersErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/{companySlug}/users',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

export const deleteCompanyCompanySlugApprovalFlowRuleId = <ThrowOnError extends boolean = false>(
    options: Options<DeleteCompanyCompanySlugApprovalFlowRuleIdData, ThrowOnError>
): RequestResult<DeleteCompanyCompanySlugApprovalFlowRuleIdResponses, DeleteCompanyCompanySlugApprovalFlowRuleIdErrors, ThrowOnError> =>
    (options.client ?? client).delete<DeleteCompanyCompanySlugApprovalFlowRuleIdResponses, DeleteCompanyCompanySlugApprovalFlowRuleIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/{companySlug}/approval-flow/{ruleId}',
        ...options,
    })

export const patchCompanyCompanySlugApprovalFlowRuleId = <ThrowOnError extends boolean = false>(
    options: Options<PatchCompanyCompanySlugApprovalFlowRuleIdData, ThrowOnError>
): RequestResult<PatchCompanyCompanySlugApprovalFlowRuleIdResponses, PatchCompanyCompanySlugApprovalFlowRuleIdErrors, ThrowOnError> =>
    (options.client ?? client).patch<PatchCompanyCompanySlugApprovalFlowRuleIdResponses, PatchCompanyCompanySlugApprovalFlowRuleIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/{companySlug}/approval-flow/{ruleId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

/**
 * DELETE: Delete a custom status by statusId (CRUD: Delete Single Item)
 */
export const deleteCompanyCompanySlugCandidateStatusesConfigStatusId = <ThrowOnError extends boolean = false>(
    options: Options<DeleteCompanyCompanySlugCandidateStatusesConfigStatusIdData, ThrowOnError>
): RequestResult<
    DeleteCompanyCompanySlugCandidateStatusesConfigStatusIdResponses,
    DeleteCompanyCompanySlugCandidateStatusesConfigStatusIdErrors,
    ThrowOnError
> =>
    (options.client ?? client).delete<
        DeleteCompanyCompanySlugCandidateStatusesConfigStatusIdResponses,
        DeleteCompanyCompanySlugCandidateStatusesConfigStatusIdErrors,
        ThrowOnError
    >({
        responseType: 'json',
        url: '/company/{companySlug}/candidate-statuses-config/{statusId}',
        ...options,
    })

/**
 * PATCH: Update an individual status definition by statusId (CRUD: Update Single Item)
 */
export const patchCompanyCompanySlugCandidateStatusesConfigStatusId = <ThrowOnError extends boolean = false>(
    options: Options<PatchCompanyCompanySlugCandidateStatusesConfigStatusIdData, ThrowOnError>
): RequestResult<PatchCompanyCompanySlugCandidateStatusesConfigStatusIdResponses, PatchCompanyCompanySlugCandidateStatusesConfigStatusIdErrors, ThrowOnError> =>
    (options.client ?? client).patch<
        PatchCompanyCompanySlugCandidateStatusesConfigStatusIdResponses,
        PatchCompanyCompanySlugCandidateStatusesConfigStatusIdErrors,
        ThrowOnError
    >({
        responseType: 'json',
        url: '/company/{companySlug}/candidate-statuses-config/{statusId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

/**
 * POST /api/company/[companySlug]/integrations/disconnect
 */
export const postCompanyCompanySlugIntegrationsDisconnect = <ThrowOnError extends boolean = false>(
    options: Options<PostCompanyCompanySlugIntegrationsDisconnectData, ThrowOnError>
): RequestResult<PostCompanyCompanySlugIntegrationsDisconnectResponses, PostCompanyCompanySlugIntegrationsDisconnectErrors, ThrowOnError> =>
    (options.client ?? client).post<PostCompanyCompanySlugIntegrationsDisconnectResponses, PostCompanyCompanySlugIntegrationsDisconnectErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/{companySlug}/integrations/disconnect',
        ...options,
    })

/**
 * POST /api/company/[companySlug]/integrations/test
 */
export const postCompanyCompanySlugIntegrationsTest = <ThrowOnError extends boolean = false>(
    options: Options<PostCompanyCompanySlugIntegrationsTestData, ThrowOnError>
): RequestResult<PostCompanyCompanySlugIntegrationsTestResponses, PostCompanyCompanySlugIntegrationsTestErrors, ThrowOnError> =>
    (options.client ?? client).post<PostCompanyCompanySlugIntegrationsTestResponses, PostCompanyCompanySlugIntegrationsTestErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/{companySlug}/integrations/test',
        ...options,
    })

/**
 * PATCH /api/company/[companySlug]/users/[userId]
 */
export const patchCompanyCompanySlugUsersUserId = <ThrowOnError extends boolean = false>(
    options: Options<PatchCompanyCompanySlugUsersUserIdData, ThrowOnError>
): RequestResult<PatchCompanyCompanySlugUsersUserIdResponses, PatchCompanyCompanySlugUsersUserIdErrors, ThrowOnError> =>
    (options.client ?? client).patch<PatchCompanyCompanySlugUsersUserIdResponses, PatchCompanyCompanySlugUsersUserIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/{companySlug}/users/{userId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

/**
 * Disable one or more users. Blocks them in Auth0 and sets disabled=true in DB.
 */
export const postCompanyCompanySlugUsersDisable = <ThrowOnError extends boolean = false>(
    options: Options<PostCompanyCompanySlugUsersDisableData, ThrowOnError>
): RequestResult<PostCompanyCompanySlugUsersDisableResponses, PostCompanyCompanySlugUsersDisableErrors, ThrowOnError> =>
    (options.client ?? client).post<PostCompanyCompanySlugUsersDisableResponses, PostCompanyCompanySlugUsersDisableErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/{companySlug}/users/disable',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

/**
 * Enable (unblock) one or more users. Unblocks them in Auth0 and sets disabled=false in DB.
 */
export const postCompanyCompanySlugUsersEnable = <ThrowOnError extends boolean = false>(
    options: Options<PostCompanyCompanySlugUsersEnableData, ThrowOnError>
): RequestResult<PostCompanyCompanySlugUsersEnableResponses, PostCompanyCompanySlugUsersEnableErrors, ThrowOnError> =>
    (options.client ?? client).post<PostCompanyCompanySlugUsersEnableResponses, PostCompanyCompanySlugUsersEnableErrors, ThrowOnError>({
        responseType: 'json',
        url: '/company/{companySlug}/users/enable',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

/**
 * POST /api/company/[companySlug]/integrations/linkedin/verify
 */
export const postCompanyCompanySlugIntegrationsLinkedinVerify = <ThrowOnError extends boolean = false>(
    options: Options<PostCompanyCompanySlugIntegrationsLinkedinVerifyData, ThrowOnError>
): RequestResult<PostCompanyCompanySlugIntegrationsLinkedinVerifyResponses, PostCompanyCompanySlugIntegrationsLinkedinVerifyErrors, ThrowOnError> =>
    (options.client ?? client).post<
        PostCompanyCompanySlugIntegrationsLinkedinVerifyResponses,
        PostCompanyCompanySlugIntegrationsLinkedinVerifyErrors,
        ThrowOnError
    >({
        responseType: 'json',
        url: '/company/{companySlug}/integrations/linkedin/verify',
        ...options,
    })

/**
 * POST /api/company/[companySlug]/users/[userId]/reset-password
 */
export const postCompanyCompanySlugUsersUserIdResetPassword = <ThrowOnError extends boolean = false>(
    options: Options<PostCompanyCompanySlugUsersUserIdResetPasswordData, ThrowOnError>
): RequestResult<PostCompanyCompanySlugUsersUserIdResetPasswordResponses, PostCompanyCompanySlugUsersUserIdResetPasswordErrors, ThrowOnError> =>
    (options.client ?? client).post<
        PostCompanyCompanySlugUsersUserIdResetPasswordResponses,
        PostCompanyCompanySlugUsersUserIdResetPasswordErrors,
        ThrowOnError
    >({
        responseType: 'json',
        url: '/company/{companySlug}/users/{userId}/reset-password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

/**
 * GET API for checking pending AI interviews (for monitoring)
 */
export const getCronAiInterviewReminders = <ThrowOnError extends boolean = false>(
    options?: Options<GetCronAiInterviewRemindersData, ThrowOnError>
): RequestResult<unknown, GetCronAiInterviewRemindersErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetCronAiInterviewRemindersErrors, ThrowOnError>({ url: '/cron/ai-interview-reminders', ...options })

/**
 * POST API for sending AI interview reminder emails
 */
export const postCronAiInterviewReminders = <ThrowOnError extends boolean = false>(
    options?: Options<PostCronAiInterviewRemindersData, ThrowOnError>
): RequestResult<unknown, PostCronAiInterviewRemindersErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostCronAiInterviewRemindersErrors, ThrowOnError>({ url: '/cron/ai-interview-reminders', ...options })

/**
 * POST /api/cron/analytics-refresh
 */
export const postCronAnalyticsRefresh = <ThrowOnError extends boolean = false>(
    options?: Options<PostCronAnalyticsRefreshData, ThrowOnError>
): RequestResult<unknown, PostCronAnalyticsRefreshErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostCronAnalyticsRefreshErrors, ThrowOnError>({ url: '/cron/analytics-refresh', ...options })

/**
 * POST /api/cron/billing-capacity-rebill
 */
export const postCronBillingCapacityRebill = <ThrowOnError extends boolean = false>(
    options?: Options<PostCronBillingCapacityRebillData, ThrowOnError>
): RequestResult<unknown, PostCronBillingCapacityRebillErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostCronBillingCapacityRebillErrors, ThrowOnError>({ url: '/cron/billing-capacity-rebill', ...options })

/**
 * This is a Next.js API route that runs a cron job to update Candidates in the database.
 */
export const patchCronCandidates = <ThrowOnError extends boolean = false>(
    options?: Options<PatchCronCandidatesData, ThrowOnError>
): RequestResult<unknown, PatchCronCandidatesErrors, ThrowOnError> =>
    (options?.client ?? client).patch<unknown, PatchCronCandidatesErrors, ThrowOnError>({ url: '/cron/candidates', ...options })

/**
 * GET API for checking pending feedbacks (for monitoring)
 */
export const getCronFeedbackReminders = <ThrowOnError extends boolean = false>(
    options?: Options<GetCronFeedbackRemindersData, ThrowOnError>
): RequestResult<unknown, GetCronFeedbackRemindersErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetCronFeedbackRemindersErrors, ThrowOnError>({ url: '/cron/feedback-reminders', ...options })

/**
 * POST API for sending feedback reminder emails
 */
export const postCronFeedbackReminders = <ThrowOnError extends boolean = false>(
    options?: Options<PostCronFeedbackRemindersData, ThrowOnError>
): RequestResult<unknown, PostCronFeedbackRemindersErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostCronFeedbackRemindersErrors, ThrowOnError>({ url: '/cron/feedback-reminders', ...options })

/**
 * POST /api/cron/job-application-processing
 */
export const postCronJobApplicationProcessing = <ThrowOnError extends boolean = false>(
    options?: Options<PostCronJobApplicationProcessingData, ThrowOnError>
): RequestResult<PostCronJobApplicationProcessingResponses, PostCronJobApplicationProcessingErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostCronJobApplicationProcessingResponses, PostCronJobApplicationProcessingErrors, ThrowOnError>({
        responseType: 'json',
        url: '/cron/job-application-processing',
        ...options,
    })

/**
 * GET API for checking calendar subscription status (for monitoring)
 */
export const getCronRenewCalendarSubscriptions = <ThrowOnError extends boolean = false>(
    options?: Options<GetCronRenewCalendarSubscriptionsData, ThrowOnError>
): RequestResult<unknown, GetCronRenewCalendarSubscriptionsErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetCronRenewCalendarSubscriptionsErrors, ThrowOnError>({ url: '/cron/renew-calendar-subscriptions', ...options })

/**
 * POST API for renewing calendar subscriptions
 */
export const postCronRenewCalendarSubscriptions = <ThrowOnError extends boolean = false>(
    options?: Options<PostCronRenewCalendarSubscriptionsData, ThrowOnError>
): RequestResult<unknown, PostCronRenewCalendarSubscriptionsErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostCronRenewCalendarSubscriptionsErrors, ThrowOnError>({ url: '/cron/renew-calendar-subscriptions', ...options })

export const getCronScreeningWebrtcLifecycleSweeper = <ThrowOnError extends boolean = false>(
    options?: Options<GetCronScreeningWebrtcLifecycleSweeperData, ThrowOnError>
): RequestResult<unknown, GetCronScreeningWebrtcLifecycleSweeperErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetCronScreeningWebrtcLifecycleSweeperErrors, ThrowOnError>({
        url: '/cron/screening-webrtc-lifecycle-sweeper',
        ...options,
    })

/**
 * POST /api/cron/screening-webrtc-lifecycle-sweeper
 */
export const postCronScreeningWebrtcLifecycleSweeper = <ThrowOnError extends boolean = false>(
    options?: Options<PostCronScreeningWebrtcLifecycleSweeperData, ThrowOnError>
): RequestResult<unknown, PostCronScreeningWebrtcLifecycleSweeperErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostCronScreeningWebrtcLifecycleSweeperErrors, ThrowOnError>({
        url: '/cron/screening-webrtc-lifecycle-sweeper',
        ...options,
    })

/**
 * GET endpoint for getting available schema information
 */
export const getCustomAnalytics = <ThrowOnError extends boolean = false>(
    options?: Options<GetCustomAnalyticsData, ThrowOnError>
): RequestResult<unknown, GetCustomAnalyticsErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetCustomAnalyticsErrors, ThrowOnError>({ url: '/custom-analytics', ...options })

/**
 * Main API endpoint
 */
export const postCustomAnalytics = <ThrowOnError extends boolean = false>(
    options?: Options<PostCustomAnalyticsData, ThrowOnError>
): RequestResult<unknown, PostCustomAnalyticsErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostCustomAnalyticsErrors, ThrowOnError>({ url: '/custom-analytics', ...options })

/**
 * DELETE endpoint for deleting a custom chart by id
 */
export const deleteCustomAnalyticsId = <ThrowOnError extends boolean = false>(
    options: Options<DeleteCustomAnalyticsIdData, ThrowOnError>
): RequestResult<DeleteCustomAnalyticsIdResponses, DeleteCustomAnalyticsIdErrors, ThrowOnError> =>
    (options.client ?? client).delete<DeleteCustomAnalyticsIdResponses, DeleteCustomAnalyticsIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/custom-analytics/{id}',
        ...options,
    })

export const postCustomAnalyticsAssignDashboard = <ThrowOnError extends boolean = false>(
    options?: Options<PostCustomAnalyticsAssignDashboardData, ThrowOnError>
): RequestResult<unknown, PostCustomAnalyticsAssignDashboardErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostCustomAnalyticsAssignDashboardErrors, ThrowOnError>({ url: '/custom-analytics/assign-dashboard', ...options })

export const deleteCustomAnalyticsDashboard = <ThrowOnError extends boolean = false>(
    options?: Options<DeleteCustomAnalyticsDashboardData, ThrowOnError>
): RequestResult<unknown, DeleteCustomAnalyticsDashboardErrors, ThrowOnError> =>
    (options?.client ?? client).delete<unknown, DeleteCustomAnalyticsDashboardErrors, ThrowOnError>({ url: '/custom-analytics/dashboard', ...options })

export const patchCustomAnalyticsDashboard = <ThrowOnError extends boolean = false>(
    options?: Options<PatchCustomAnalyticsDashboardData, ThrowOnError>
): RequestResult<unknown, PatchCustomAnalyticsDashboardErrors, ThrowOnError> =>
    (options?.client ?? client).patch<unknown, PatchCustomAnalyticsDashboardErrors, ThrowOnError>({ url: '/custom-analytics/dashboard', ...options })

export const postCustomAnalyticsDashboard = <ThrowOnError extends boolean = false>(
    options?: Options<PostCustomAnalyticsDashboardData, ThrowOnError>
): RequestResult<unknown, PostCustomAnalyticsDashboardErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostCustomAnalyticsDashboardErrors, ThrowOnError>({ url: '/custom-analytics/dashboard', ...options })

export const postCustomAnalyticsOrder = <ThrowOnError extends boolean = false>(
    options?: Options<PostCustomAnalyticsOrderData, ThrowOnError>
): RequestResult<unknown, PostCustomAnalyticsOrderErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostCustomAnalyticsOrderErrors, ThrowOnError>({ url: '/custom-analytics/order', ...options })

export const postCustomAnalyticsPaginate = <ThrowOnError extends boolean = false>(
    options?: Options<PostCustomAnalyticsPaginateData, ThrowOnError>
): RequestResult<unknown, PostCustomAnalyticsPaginateErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostCustomAnalyticsPaginateErrors, ThrowOnError>({ url: '/custom-analytics/paginate', ...options })

/**
 * Main API endpoint
 */
export const postCustomAnalyticsPreview = <ThrowOnError extends boolean = false>(
    options?: Options<PostCustomAnalyticsPreviewData, ThrowOnError>
): RequestResult<unknown, PostCustomAnalyticsPreviewErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostCustomAnalyticsPreviewErrors, ThrowOnError>({ url: '/custom-analytics/preview', ...options })

export const postCustomAnalyticsRemoveDashboard = <ThrowOnError extends boolean = false>(
    options?: Options<PostCustomAnalyticsRemoveDashboardData, ThrowOnError>
): RequestResult<unknown, PostCustomAnalyticsRemoveDashboardErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostCustomAnalyticsRemoveDashboardErrors, ThrowOnError>({ url: '/custom-analytics/remove-dashboard', ...options })

export const getEmbeddings = <ThrowOnError extends boolean = false>(
    options?: Options<GetEmbeddingsData, ThrowOnError>
): RequestResult<GetEmbeddingsResponses, GetEmbeddingsErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetEmbeddingsResponses, GetEmbeddingsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/embeddings',
        ...options,
    })

export const postEmbeddings = <ThrowOnError extends boolean = false>(
    options?: Options<PostEmbeddingsData, ThrowOnError>
): RequestResult<PostEmbeddingsResponses, PostEmbeddingsErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostEmbeddingsResponses, PostEmbeddingsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/embeddings',
        ...options,
    })

/**
 * POST: Creates new interview questions for a screening round.
 */
export const postGenerateQuestions = <ThrowOnError extends boolean = false>(
    options?: Options<PostGenerateQuestionsData, ThrowOnError>
): RequestResult<unknown, PostGenerateQuestionsErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostGenerateQuestionsErrors, ThrowOnError>({ url: '/generateQuestions', ...options })

/**
 * PUT: Updates/regenerates existing interview questions using interview ID from path.
 */
export const putGenerateQuestionsId = <ThrowOnError extends boolean = false>(
    options: Options<PutGenerateQuestionsIdData, ThrowOnError>
): RequestResult<unknown, PutGenerateQuestionsIdErrors, ThrowOnError> =>
    (options.client ?? client).put<unknown, PutGenerateQuestionsIdErrors, ThrowOnError>({ url: '/generateQuestions/{id}', ...options })

export const getHiringManagers = <ThrowOnError extends boolean = false>(
    options?: Options<GetHiringManagersData, ThrowOnError>
): RequestResult<unknown, GetHiringManagersErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetHiringManagersErrors, ThrowOnError>({ url: '/hiring-managers', ...options })

export const postHiringManagers = <ThrowOnError extends boolean = false>(
    options?: Options<PostHiringManagersData, ThrowOnError>
): RequestResult<unknown, PostHiringManagersErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostHiringManagersErrors, ThrowOnError>({ url: '/hiring-managers', ...options })

/**
 * delete manager - removes Manager role from user
 */
export const deleteHiringManagersId = <ThrowOnError extends boolean = false>(
    options: Options<DeleteHiringManagersIdData, ThrowOnError>
): RequestResult<unknown, DeleteHiringManagersIdErrors, ThrowOnError> =>
    (options.client ?? client).delete<unknown, DeleteHiringManagersIdErrors, ThrowOnError>({ url: '/hiring-managers/{id}', ...options })

export const putHiringManagersId = <ThrowOnError extends boolean = false>(
    options: Options<PutHiringManagersIdData, ThrowOnError>
): RequestResult<unknown, PutHiringManagersIdErrors, ThrowOnError> =>
    (options.client ?? client).put<unknown, PutHiringManagersIdErrors, ThrowOnError>({ url: '/hiring-managers/{id}', ...options })

export const postInsightsBenettonApplicantsReport = <ThrowOnError extends boolean = false>(
    options?: Options<PostInsightsBenettonApplicantsReportData, ThrowOnError>
): RequestResult<unknown, PostInsightsBenettonApplicantsReportErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostInsightsBenettonApplicantsReportErrors, ThrowOnError>({
        url: '/insights/benetton-applicants-report',
        ...options,
    })

export const postInsightsCandidatesByRolesReport = <ThrowOnError extends boolean = false>(
    options?: Options<PostInsightsCandidatesByRolesReportData, ThrowOnError>
): RequestResult<unknown, PostInsightsCandidatesByRolesReportErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostInsightsCandidatesByRolesReportErrors, ThrowOnError>({
        url: '/insights/candidates-by-roles-report',
        ...options,
    })

export const postInsightsCandidatesByStatusReport = <ThrowOnError extends boolean = false>(
    options?: Options<PostInsightsCandidatesByStatusReportData, ThrowOnError>
): RequestResult<unknown, PostInsightsCandidatesByStatusReportErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostInsightsCandidatesByStatusReportErrors, ThrowOnError>({
        url: '/insights/candidates-by-status-report',
        ...options,
    })

export const postInsightsCustomCharts = <ThrowOnError extends boolean = false>(
    options?: Options<PostInsightsCustomChartsData, ThrowOnError>
): RequestResult<unknown, PostInsightsCustomChartsErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostInsightsCustomChartsErrors, ThrowOnError>({ url: '/insights/custom-charts', ...options })

export const postInsightsMonthlyDashboard = <ThrowOnError extends boolean = false>(
    options?: Options<PostInsightsMonthlyDashboardData, ThrowOnError>
): RequestResult<unknown, PostInsightsMonthlyDashboardErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostInsightsMonthlyDashboardErrors, ThrowOnError>({ url: '/insights/monthly-dashboard', ...options })

export const postInsightsOfferJoinedReport = <ThrowOnError extends boolean = false>(
    options?: Options<PostInsightsOfferJoinedReportData, ThrowOnError>
): RequestResult<unknown, PostInsightsOfferJoinedReportErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostInsightsOfferJoinedReportErrors, ThrowOnError>({ url: '/insights/offer-joined-report', ...options })

export const postInsightsOpenPositionsReport = <ThrowOnError extends boolean = false>(
    options?: Options<PostInsightsOpenPositionsReportData, ThrowOnError>
): RequestResult<unknown, PostInsightsOpenPositionsReportErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostInsightsOpenPositionsReportErrors, ThrowOnError>({ url: '/insights/open-positions-report', ...options })

export const postInsightsPositionsClosedReport = <ThrowOnError extends boolean = false>(
    options?: Options<PostInsightsPositionsClosedReportData, ThrowOnError>
): RequestResult<unknown, PostInsightsPositionsClosedReportErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostInsightsPositionsClosedReportErrors, ThrowOnError>({ url: '/insights/positions-closed-report', ...options })

export const postInsightsPositionsCreatedReport = <ThrowOnError extends boolean = false>(
    options?: Options<PostInsightsPositionsCreatedReportData, ThrowOnError>
): RequestResult<unknown, PostInsightsPositionsCreatedReportErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostInsightsPositionsCreatedReportErrors, ThrowOnError>({ url: '/insights/positions-created-report', ...options })

export const postInsightsPredefinedGraphs = <ThrowOnError extends boolean = false>(
    options?: Options<PostInsightsPredefinedGraphsData, ThrowOnError>
): RequestResult<unknown, PostInsightsPredefinedGraphsErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostInsightsPredefinedGraphsErrors, ThrowOnError>({ url: '/insights/predefined-graphs', ...options })

export const postInsightsPredefinedGraphsSave = <ThrowOnError extends boolean = false>(
    options?: Options<PostInsightsPredefinedGraphsSaveData, ThrowOnError>
): RequestResult<unknown, PostInsightsPredefinedGraphsSaveErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostInsightsPredefinedGraphsSaveErrors, ThrowOnError>({ url: '/insights/predefined-graphs/save', ...options })

/**
 * GET /api/integrations/google/authorize?companySlug=xxx
 */
export const getIntegrationsGoogleAuthorize = <ThrowOnError extends boolean = false>(
    options?: Options<GetIntegrationsGoogleAuthorizeData, ThrowOnError>
): RequestResult<unknown, GetIntegrationsGoogleAuthorizeErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetIntegrationsGoogleAuthorizeErrors, ThrowOnError>({ url: '/integrations/google/authorize', ...options })

/**
 * GET /api/integrations/google/callback?code=xxx&state=xxx
 */
export const getIntegrationsGoogleCallback = <ThrowOnError extends boolean = false>(
    options?: Options<GetIntegrationsGoogleCallbackData, ThrowOnError>
): RequestResult<unknown, GetIntegrationsGoogleCallbackErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetIntegrationsGoogleCallbackErrors, ThrowOnError>({ url: '/integrations/google/callback', ...options })

/**
 * GET /api/integrations/microsoft/authorize?companySlug=xxx
 */
export const getIntegrationsMicrosoftAuthorize = <ThrowOnError extends boolean = false>(
    options?: Options<GetIntegrationsMicrosoftAuthorizeData, ThrowOnError>
): RequestResult<unknown, GetIntegrationsMicrosoftAuthorizeErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetIntegrationsMicrosoftAuthorizeErrors, ThrowOnError>({ url: '/integrations/microsoft/authorize', ...options })

/**
 * GET /api/integrations/microsoft/callback?code=xxx&state=xxx
 */
export const getIntegrationsMicrosoftCallback = <ThrowOnError extends boolean = false>(
    options?: Options<GetIntegrationsMicrosoftCallbackData, ThrowOnError>
): RequestResult<unknown, GetIntegrationsMicrosoftCallbackErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetIntegrationsMicrosoftCallbackErrors, ThrowOnError>({ url: '/integrations/microsoft/callback', ...options })

export const postInternalStt = <ThrowOnError extends boolean = false>(
    options?: Options<PostInternalSttData, ThrowOnError>
): RequestResult<PostInternalSttResponses, PostInternalSttErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostInternalSttResponses, PostInternalSttErrors, ThrowOnError>({
        responseType: 'json',
        url: '/internal/stt',
        ...options,
    })

export const postInternalAnalyticsQuery = <ThrowOnError extends boolean = false>(
    options?: Options<PostInternalAnalyticsQueryData, ThrowOnError>
): RequestResult<PostInternalAnalyticsQueryResponses, PostInternalAnalyticsQueryErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostInternalAnalyticsQueryResponses, PostInternalAnalyticsQueryErrors, ThrowOnError>({
        responseType: 'json',
        url: '/internal/analytics/query',
        ...options,
    })

export const getInternalSttToken = <ThrowOnError extends boolean = false>(
    options?: Options<GetInternalSttTokenData, ThrowOnError>
): RequestResult<GetInternalSttTokenResponses, GetInternalSttTokenErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetInternalSttTokenResponses, GetInternalSttTokenErrors, ThrowOnError>({
        responseType: 'json',
        url: '/internal/stt/token',
        ...options,
    })

export const getInterviews = <ThrowOnError extends boolean = false>(
    options?: Options<GetInterviewsData, ThrowOnError>
): RequestResult<GetInterviewsResponses, GetInterviewsErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetInterviewsResponses, GetInterviewsErrors, ThrowOnError>({
        responseTransformer: getInterviewsResponseTransformer,
        responseType: 'json',
        url: '/interviews',
        ...options,
    })

export const postInterviews = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsData, ThrowOnError>
): RequestResult<PostInterviewsResponses, PostInterviewsErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostInterviewsResponses, PostInterviewsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/interviews',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

export const deleteInterviewsId = <ThrowOnError extends boolean = false>(
    options: Options<DeleteInterviewsIdData, ThrowOnError>
): RequestResult<DeleteInterviewsIdResponses, DeleteInterviewsIdErrors, ThrowOnError> =>
    (options.client ?? client).delete<DeleteInterviewsIdResponses, DeleteInterviewsIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/interviews/{id}',
        ...options,
    })

/**
 * GET API for fetching Interviews by id
 */
export const getInterviewsId = <ThrowOnError extends boolean = false>(
    options: Options<GetInterviewsIdData, ThrowOnError>
): RequestResult<GetInterviewsIdResponses, GetInterviewsIdErrors, ThrowOnError> =>
    (options.client ?? client).get<GetInterviewsIdResponses, GetInterviewsIdErrors, ThrowOnError>({
        responseTransformer: getInterviewsIdResponseTransformer,
        responseType: 'json',
        url: '/interviews/{id}',
        ...options,
    })

export const putInterviewsId = <ThrowOnError extends boolean = false>(
    options: Options<PutInterviewsIdData, ThrowOnError>
): RequestResult<PutInterviewsIdResponses, PutInterviewsIdErrors, ThrowOnError> =>
    (options.client ?? client).put<PutInterviewsIdResponses, PutInterviewsIdErrors, ThrowOnError>({
        responseTransformer: putInterviewsIdResponseTransformer,
        responseType: 'json',
        url: '/interviews/{id}',
        ...options,
    })

/**
 * GET API for fetching Interview by panelist
 */
export const getInterviewsFeedback = <ThrowOnError extends boolean = false>(
    options?: Options<GetInterviewsFeedbackData, ThrowOnError>
): RequestResult<unknown, GetInterviewsFeedbackErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetInterviewsFeedbackErrors, ThrowOnError>({ url: '/interviews/feedback', ...options })

export const putInterviewsFeedback = <ThrowOnError extends boolean = false>(
    options?: Options<PutInterviewsFeedbackData, ThrowOnError>
): RequestResult<unknown, PutInterviewsFeedbackErrors, ThrowOnError> =>
    (options?.client ?? client).put<unknown, PutInterviewsFeedbackErrors, ThrowOnError>({ url: '/interviews/feedback', ...options })

/**
 * POST handler for receiving AI-generated human interview questions from backend.
 */
export const postInterviewsHumanInterviewQuestions = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsHumanInterviewQuestionsData, ThrowOnError>
): RequestResult<unknown, PostInterviewsHumanInterviewQuestionsErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostInterviewsHumanInterviewQuestionsErrors, ThrowOnError>({
        url: '/interviews/humanInterviewQuestions',
        ...options,
    })

/**
 * DELETE handler to delete/cancel a ScreeningCall.
 */
export const deleteInterviewsScreeningCall = <ThrowOnError extends boolean = false>(
    options?: Options<DeleteInterviewsScreeningCallData, ThrowOnError>
): RequestResult<unknown, DeleteInterviewsScreeningCallErrors, ThrowOnError> =>
    (options?.client ?? client).delete<unknown, DeleteInterviewsScreeningCallErrors, ThrowOnError>({ url: '/interviews/screening-call', ...options })

/**
 * POST handler to create and schedule a ScreeningCall for a job application.
 */
export const postInterviewsScreeningCall = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsScreeningCallData, ThrowOnError>
): RequestResult<unknown, PostInterviewsScreeningCallErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostInterviewsScreeningCallErrors, ThrowOnError>({ url: '/interviews/screening-call', ...options })

/**
 * PUT handler to update a ScreeningCall (e.g. status, callEvents, recordingUrl).
 */
export const putInterviewsScreeningCall = <ThrowOnError extends boolean = false>(
    options?: Options<PutInterviewsScreeningCallData, ThrowOnError>
): RequestResult<unknown, PutInterviewsScreeningCallErrors, ThrowOnError> =>
    (options?.client ?? client).put<unknown, PutInterviewsScreeningCallErrors, ThrowOnError>({ url: '/interviews/screening-call', ...options })

/**
 * GET handler for fetching screening interview information.
 */
export const getInterviewsScreeningInterview = <ThrowOnError extends boolean = false>(
    options?: Options<GetInterviewsScreeningInterviewData, ThrowOnError>
): RequestResult<unknown, GetInterviewsScreeningInterviewErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetInterviewsScreeningInterviewErrors, ThrowOnError>({ url: '/interviews/screeningInterview', ...options })

/**
 * POST handler for bulk screening interview creation.
 */
export const postInterviewsScreeningInterview = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsScreeningInterviewData, ThrowOnError>
): RequestResult<unknown, PostInterviewsScreeningInterviewErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostInterviewsScreeningInterviewErrors, ThrowOnError>({ url: '/interviews/screeningInterview', ...options })

export const putInterviewsScreeningInterview = <ThrowOnError extends boolean = false>(
    options?: Options<PutInterviewsScreeningInterviewData, ThrowOnError>
): RequestResult<unknown, PutInterviewsScreeningInterviewErrors, ThrowOnError> =>
    (options?.client ?? client).put<unknown, PutInterviewsScreeningInterviewErrors, ThrowOnError>({ url: '/interviews/screeningInterview', ...options })

export const postInterviewsIdInterviewRound = <ThrowOnError extends boolean = false>(
    options: Options<PostInterviewsIdInterviewRoundData, ThrowOnError>
): RequestResult<PostInterviewsIdInterviewRoundResponses, PostInterviewsIdInterviewRoundErrors, ThrowOnError> =>
    (options.client ?? client).post<PostInterviewsIdInterviewRoundResponses, PostInterviewsIdInterviewRoundErrors, ThrowOnError>({
        responseTransformer: postInterviewsIdInterviewRoundResponseTransformer,
        responseType: 'json',
        url: '/interviews/{id}/interviewRound',
        ...options,
    })

export const putInterviewsIdInterviewRound = <ThrowOnError extends boolean = false>(
    options: Options<PutInterviewsIdInterviewRoundData, ThrowOnError>
): RequestResult<PutInterviewsIdInterviewRoundResponses, PutInterviewsIdInterviewRoundErrors, ThrowOnError> =>
    (options.client ?? client).put<PutInterviewsIdInterviewRoundResponses, PutInterviewsIdInterviewRoundErrors, ThrowOnError>({
        responseTransformer: putInterviewsIdInterviewRoundResponseTransformer,
        responseType: 'json',
        url: '/interviews/{id}/interviewRound',
        ...options,
    })

export const postInterviewsFeedbackGenerate = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsFeedbackGenerateData, ThrowOnError>
): RequestResult<unknown, PostInterviewsFeedbackGenerateErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostInterviewsFeedbackGenerateErrors, ThrowOnError>({ url: '/interviews/feedback/generate', ...options })

/**
 * Lightweight GET endpoint for polling transcript and summary availability.
 */
export const getInterviewsFeedbackTranscript = <ThrowOnError extends boolean = false>(
    options?: Options<GetInterviewsFeedbackTranscriptData, ThrowOnError>
): RequestResult<unknown, GetInterviewsFeedbackTranscriptErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetInterviewsFeedbackTranscriptErrors, ThrowOnError>({ url: '/interviews/feedback/transcript', ...options })

/**
 * POST /api/interviews/humanInterviewQuestions/trigger
 */
export const postInterviewsHumanInterviewQuestionsTrigger = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsHumanInterviewQuestionsTriggerData, ThrowOnError>
): RequestResult<unknown, PostInterviewsHumanInterviewQuestionsTriggerErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostInterviewsHumanInterviewQuestionsTriggerErrors, ThrowOnError>({
        url: '/interviews/humanInterviewQuestions/trigger',
        ...options,
    })

/**
 * POST handler to bulk create and schedule ScreeningCall records for multiple job applications.
 */
export const postInterviewsScreeningCallBulk = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsScreeningCallBulkData, ThrowOnError>
): RequestResult<unknown, PostInterviewsScreeningCallBulkErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostInterviewsScreeningCallBulkErrors, ThrowOnError>({ url: '/interviews/screening-call/bulk', ...options })

/**
 * POST /api/interviews/screening-call/endInterview
 */
export const postInterviewsScreeningCallEndInterview = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsScreeningCallEndInterviewData, ThrowOnError>
): RequestResult<PostInterviewsScreeningCallEndInterviewResponses, PostInterviewsScreeningCallEndInterviewErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostInterviewsScreeningCallEndInterviewResponses, PostInterviewsScreeningCallEndInterviewErrors, ThrowOnError>({
        responseType: 'json',
        url: '/interviews/screening-call/endInterview',
        ...options,
    })

/**
 * POST /api/interviews/screening-call/lifecycle
 */
export const postInterviewsScreeningCallLifecycle = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsScreeningCallLifecycleData, ThrowOnError>
): RequestResult<PostInterviewsScreeningCallLifecycleResponses, PostInterviewsScreeningCallLifecycleErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostInterviewsScreeningCallLifecycleResponses, PostInterviewsScreeningCallLifecycleErrors, ThrowOnError>({
        responseType: 'json',
        url: '/interviews/screening-call/lifecycle',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

/**
 * Browser hint closer (pagehide / Leave keepalive). Thin wrapper around shared finalize.
 */
export const postInterviewsScreeningWebrtcAbandon = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsScreeningWebrtcAbandonData, ThrowOnError>
): RequestResult<PostInterviewsScreeningWebrtcAbandonResponses, PostInterviewsScreeningWebrtcAbandonErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostInterviewsScreeningWebrtcAbandonResponses, PostInterviewsScreeningWebrtcAbandonErrors, ThrowOnError>({
        responseType: 'json',
        url: '/interviews/screening-webrtc/abandon',
        ...options,
    })

export const getInterviewsScreeningWebrtcBootstrap = <ThrowOnError extends boolean = false>(
    options?: Options<GetInterviewsScreeningWebrtcBootstrapData, ThrowOnError>
): RequestResult<GetInterviewsScreeningWebrtcBootstrapResponses, GetInterviewsScreeningWebrtcBootstrapErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetInterviewsScreeningWebrtcBootstrapResponses, GetInterviewsScreeningWebrtcBootstrapErrors, ThrowOnError>({
        responseType: 'json',
        url: '/interviews/screening-webrtc/bootstrap',
        ...options,
    })

/**
 * POST /api/interviews/screening-webrtc/lifecycle
 */
export const postInterviewsScreeningWebrtcLifecycle = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsScreeningWebrtcLifecycleData, ThrowOnError>
): RequestResult<PostInterviewsScreeningWebrtcLifecycleResponses, PostInterviewsScreeningWebrtcLifecycleErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostInterviewsScreeningWebrtcLifecycleResponses, PostInterviewsScreeningWebrtcLifecycleErrors, ThrowOnError>({
        responseType: 'json',
        url: '/interviews/screening-webrtc/lifecycle',
        ...options,
    })

export const getInterviewsScreeningWebrtcNetworkProbe = <ThrowOnError extends boolean = false>(
    options?: Options<GetInterviewsScreeningWebrtcNetworkProbeData, ThrowOnError>
): RequestResult<unknown, GetInterviewsScreeningWebrtcNetworkProbeErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetInterviewsScreeningWebrtcNetworkProbeErrors, ThrowOnError>({
        url: '/interviews/screening-webrtc/network-probe',
        ...options,
    })

export const headInterviewsScreeningWebrtcNetworkProbe = <ThrowOnError extends boolean = false>(
    options?: Options<HeadInterviewsScreeningWebrtcNetworkProbeData, ThrowOnError>
): RequestResult<unknown, HeadInterviewsScreeningWebrtcNetworkProbeErrors, ThrowOnError> =>
    (options?.client ?? client).head<unknown, HeadInterviewsScreeningWebrtcNetworkProbeErrors, ThrowOnError>({
        url: '/interviews/screening-webrtc/network-probe',
        ...options,
    })

export const putInterviewsScreeningWebrtcNetworkProbe = <ThrowOnError extends boolean = false>(
    options?: Options<PutInterviewsScreeningWebrtcNetworkProbeData, ThrowOnError>
): RequestResult<unknown, PutInterviewsScreeningWebrtcNetworkProbeErrors, ThrowOnError> =>
    (options?.client ?? client).put<unknown, PutInterviewsScreeningWebrtcNetworkProbeErrors, ThrowOnError>({
        url: '/interviews/screening-webrtc/network-probe',
        ...options,
    })

export const postInterviewsScreeningWebrtcOffer = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsScreeningWebrtcOfferData, ThrowOnError>
): RequestResult<PostInterviewsScreeningWebrtcOfferResponses, PostInterviewsScreeningWebrtcOfferErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostInterviewsScreeningWebrtcOfferResponses, PostInterviewsScreeningWebrtcOfferErrors, ThrowOnError>({
        responseType: 'json',
        url: '/interviews/screening-webrtc/offer',
        ...options,
    })

/**
 * SSE proxy for the ScreenAI /output endpoint.
 */
export const getInterviewsScreeningWebrtcOutput = <ThrowOnError extends boolean = false>(
    options?: Options<GetInterviewsScreeningWebrtcOutputData, ThrowOnError>
): RequestResult<GetInterviewsScreeningWebrtcOutputResponses, GetInterviewsScreeningWebrtcOutputErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetInterviewsScreeningWebrtcOutputResponses, GetInterviewsScreeningWebrtcOutputErrors, ThrowOnError>({
        responseType: 'json',
        url: '/interviews/screening-webrtc/output',
        ...options,
    })

export const postInterviewsScreeningWebrtcScoring = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsScreeningWebrtcScoringData, ThrowOnError>
): RequestResult<PostInterviewsScreeningWebrtcScoringResponses, PostInterviewsScreeningWebrtcScoringErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostInterviewsScreeningWebrtcScoringResponses, PostInterviewsScreeningWebrtcScoringErrors, ThrowOnError>({
        responseType: 'json',
        url: '/interviews/screening-webrtc/scoring',
        ...options,
    })

export const postInterviewsScreeningWebrtcSession = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsScreeningWebrtcSessionData, ThrowOnError>
): RequestResult<PostInterviewsScreeningWebrtcSessionResponses, PostInterviewsScreeningWebrtcSessionErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostInterviewsScreeningWebrtcSessionResponses, PostInterviewsScreeningWebrtcSessionErrors, ThrowOnError>({
        responseType: 'json',
        url: '/interviews/screening-webrtc/session',
        ...options,
    })

/**
 * Mint a short-lived candidate capability JWT for direct browser FastRTC
 */
export const postInterviewsScreeningWebrtcToken = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsScreeningWebrtcTokenData, ThrowOnError>
): RequestResult<PostInterviewsScreeningWebrtcTokenResponses, PostInterviewsScreeningWebrtcTokenErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostInterviewsScreeningWebrtcTokenResponses, PostInterviewsScreeningWebrtcTokenErrors, ThrowOnError>({
        responseType: 'json',
        url: '/interviews/screening-webrtc/token',
        ...options,
    })

/**
 * GET handler for fetching screening interview details needed for the candidate's browser
 */
export const getInterviewsScreeningInterviewCandidate = <ThrowOnError extends boolean = false>(
    options?: Options<GetInterviewsScreeningInterviewCandidateData, ThrowOnError>
): RequestResult<unknown, GetInterviewsScreeningInterviewCandidateErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetInterviewsScreeningInterviewCandidateErrors, ThrowOnError>({
        url: '/interviews/screeningInterview/candidate',
        ...options,
    })

/**
 * GET /api/interviews/screeningInterview/clientToken
 */
export const getInterviewsScreeningInterviewClientToken = <ThrowOnError extends boolean = false>(
    options?: Options<GetInterviewsScreeningInterviewClientTokenData, ThrowOnError>
): RequestResult<GetInterviewsScreeningInterviewClientTokenResponses, GetInterviewsScreeningInterviewClientTokenErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetInterviewsScreeningInterviewClientTokenResponses, GetInterviewsScreeningInterviewClientTokenErrors, ThrowOnError>({
        responseType: 'json',
        url: '/interviews/screeningInterview/clientToken',
        ...options,
    })

/**
 * POST /api/interviews/screeningInterview/clientToken
 */
export const postInterviewsScreeningInterviewClientToken = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsScreeningInterviewClientTokenData, ThrowOnError>
): RequestResult<PostInterviewsScreeningInterviewClientTokenResponses, PostInterviewsScreeningInterviewClientTokenErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostInterviewsScreeningInterviewClientTokenResponses, PostInterviewsScreeningInterviewClientTokenErrors, ThrowOnError>({
        responseType: 'json',
        url: '/interviews/screeningInterview/clientToken',
        ...options,
    })

export const postInterviewsScreeningInterviewDailyRecording = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsScreeningInterviewDailyRecordingData, ThrowOnError>
): RequestResult<unknown, PostInterviewsScreeningInterviewDailyRecordingErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostInterviewsScreeningInterviewDailyRecordingErrors, ThrowOnError>({
        url: '/interviews/screeningInterview/dailyRecording',
        ...options,
    })

/**
 * POST /api/interviews/screeningInterview/endInterview
 */
export const postInterviewsScreeningInterviewEndInterview = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsScreeningInterviewEndInterviewData, ThrowOnError>
): RequestResult<PostInterviewsScreeningInterviewEndInterviewResponses, PostInterviewsScreeningInterviewEndInterviewErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostInterviewsScreeningInterviewEndInterviewResponses, PostInterviewsScreeningInterviewEndInterviewErrors, ThrowOnError>({
        responseType: 'json',
        url: '/interviews/screeningInterview/endInterview',
        ...options,
    })

/**
 * POST /api/interviews/screeningInterview/events
 */
export const postInterviewsScreeningInterviewEvents = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsScreeningInterviewEventsData, ThrowOnError>
): RequestResult<PostInterviewsScreeningInterviewEventsResponses, PostInterviewsScreeningInterviewEventsErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostInterviewsScreeningInterviewEventsResponses, PostInterviewsScreeningInterviewEventsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/interviews/screeningInterview/events',
        ...options,
    })

export const postInterviewsScreeningInterviewFastrtcRecording = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsScreeningInterviewFastrtcRecordingData, ThrowOnError>
): RequestResult<unknown, PostInterviewsScreeningInterviewFastrtcRecordingErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostInterviewsScreeningInterviewFastrtcRecordingErrors, ThrowOnError>({
        url: '/interviews/screeningInterview/fastrtcRecording',
        ...options,
    })

/**
 * POST /api/interviews/screeningInterview/fetchDailyRecording
 */
export const postInterviewsScreeningInterviewFetchDailyRecording = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsScreeningInterviewFetchDailyRecordingData, ThrowOnError>
): RequestResult<unknown, PostInterviewsScreeningInterviewFetchDailyRecordingErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostInterviewsScreeningInterviewFetchDailyRecordingErrors, ThrowOnError>({
        url: '/interviews/screeningInterview/fetchDailyRecording',
        ...options,
    })

/**
 * POST handler for fixing liveness verification status based on screening configuration.
 */
export const postInterviewsScreeningInterviewFixLivenessStatus = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsScreeningInterviewFixLivenessStatusData, ThrowOnError>
): RequestResult<unknown, PostInterviewsScreeningInterviewFixLivenessStatusErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostInterviewsScreeningInterviewFixLivenessStatusErrors, ThrowOnError>({
        url: '/interviews/screeningInterview/fix-liveness-status',
        ...options,
    })

/**
 * GET /api/interviews/screeningInterview/iceServers
 */
export const getInterviewsScreeningInterviewIceServers = <ThrowOnError extends boolean = false>(
    options?: Options<GetInterviewsScreeningInterviewIceServersData, ThrowOnError>
): RequestResult<GetInterviewsScreeningInterviewIceServersResponses, GetInterviewsScreeningInterviewIceServersErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetInterviewsScreeningInterviewIceServersResponses, GetInterviewsScreeningInterviewIceServersErrors, ThrowOnError>({
        responseType: 'json',
        url: '/interviews/screeningInterview/iceServers',
        ...options,
    })

/**
 * GET /api/interviews/screeningInterview/proctoring
 */
export const getInterviewsScreeningInterviewProctoring = <ThrowOnError extends boolean = false>(
    options?: Options<GetInterviewsScreeningInterviewProctoringData, ThrowOnError>
): RequestResult<GetInterviewsScreeningInterviewProctoringResponses, GetInterviewsScreeningInterviewProctoringErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetInterviewsScreeningInterviewProctoringResponses, GetInterviewsScreeningInterviewProctoringErrors, ThrowOnError>({
        responseType: 'json',
        url: '/interviews/screeningInterview/proctoring',
        ...options,
    })

/**
 * POST /api/interviews/screeningInterview/proctoring
 */
export const postInterviewsScreeningInterviewProctoring = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsScreeningInterviewProctoringData, ThrowOnError>
): RequestResult<PostInterviewsScreeningInterviewProctoringResponses, PostInterviewsScreeningInterviewProctoringErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostInterviewsScreeningInterviewProctoringResponses, PostInterviewsScreeningInterviewProctoringErrors, ThrowOnError>({
        responseType: 'json',
        url: '/interviews/screeningInterview/proctoring',
        ...options,
    })

export const getInterviewsScreeningInterviewRemind = <ThrowOnError extends boolean = false>(
    options?: Options<GetInterviewsScreeningInterviewRemindData, ThrowOnError>
): RequestResult<GetInterviewsScreeningInterviewRemindResponses, GetInterviewsScreeningInterviewRemindErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetInterviewsScreeningInterviewRemindResponses, GetInterviewsScreeningInterviewRemindErrors, ThrowOnError>({
        responseType: 'json',
        url: '/interviews/screeningInterview/remind',
        ...options,
    })

/**
 * GET /api/interviews/screeningInterview/speechToken
 */
export const getInterviewsScreeningInterviewSpeechToken = <ThrowOnError extends boolean = false>(
    options?: Options<GetInterviewsScreeningInterviewSpeechTokenData, ThrowOnError>
): RequestResult<GetInterviewsScreeningInterviewSpeechTokenResponses, GetInterviewsScreeningInterviewSpeechTokenErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetInterviewsScreeningInterviewSpeechTokenResponses, GetInterviewsScreeningInterviewSpeechTokenErrors, ThrowOnError>({
        responseType: 'json',
        url: '/interviews/screeningInterview/speechToken',
        ...options,
    })

/**
 * POST handler for starting a screening interview.
 */
export const postInterviewsScreeningInterviewStart = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsScreeningInterviewStartData, ThrowOnError>
): RequestResult<unknown, PostInterviewsScreeningInterviewStartErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostInterviewsScreeningInterviewStartErrors, ThrowOnError>({
        url: '/interviews/screeningInterview/start',
        ...options,
    })

/**
 * POST /api/interviews/screeningInterview/transitionToStarted
 */
export const postInterviewsScreeningInterviewTransitionToStarted = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsScreeningInterviewTransitionToStartedData, ThrowOnError>
): RequestResult<PostInterviewsScreeningInterviewTransitionToStartedResponses, PostInterviewsScreeningInterviewTransitionToStartedErrors, ThrowOnError> =>
    (options?.client ?? client).post<
        PostInterviewsScreeningInterviewTransitionToStartedResponses,
        PostInterviewsScreeningInterviewTransitionToStartedErrors,
        ThrowOnError
    >({
        responseType: 'json',
        url: '/interviews/screeningInterview/transitionToStarted',
        ...options,
    })

export const deleteInterviewsIdInterviewRoundInterviewRoundId = <ThrowOnError extends boolean = false>(
    options: Options<DeleteInterviewsIdInterviewRoundInterviewRoundIdData, ThrowOnError>
): RequestResult<DeleteInterviewsIdInterviewRoundInterviewRoundIdResponses, DeleteInterviewsIdInterviewRoundInterviewRoundIdErrors, ThrowOnError> =>
    (options.client ?? client).delete<
        DeleteInterviewsIdInterviewRoundInterviewRoundIdResponses,
        DeleteInterviewsIdInterviewRoundInterviewRoundIdErrors,
        ThrowOnError
    >({
        responseTransformer: deleteInterviewsIdInterviewRoundInterviewRoundIdResponseTransformer,
        responseType: 'json',
        url: '/interviews/{id}/interviewRound/{interview_round_id}',
        ...options,
    })

export const putInterviewsIdInterviewRoundInterviewRoundId = <ThrowOnError extends boolean = false>(
    options: Options<PutInterviewsIdInterviewRoundInterviewRoundIdData, ThrowOnError>
): RequestResult<unknown, PutInterviewsIdInterviewRoundInterviewRoundIdErrors, ThrowOnError> =>
    (options.client ?? client).put<unknown, PutInterviewsIdInterviewRoundInterviewRoundIdErrors, ThrowOnError>({
        url: '/interviews/{id}/interviewRound/{interview_round_id}',
        ...options,
    })

/**
 * GET /api/interviews/screening-call/[id]/recording — short-lived signed URL for an AI phone screening call recording.
 *
 * Caller must belong to the call's company. 404 when the call has no recording.
 */
export const getInterviewsScreeningCallIdRecording = <ThrowOnError extends boolean = false>(
    options: Options<GetInterviewsScreeningCallIdRecordingData, ThrowOnError>
): RequestResult<GetInterviewsScreeningCallIdRecordingResponses, GetInterviewsScreeningCallIdRecordingErrors, ThrowOnError> =>
    (options.client ?? client).get<GetInterviewsScreeningCallIdRecordingResponses, GetInterviewsScreeningCallIdRecordingErrors, ThrowOnError>({
        responseType: 'json',
        url: '/interviews/screening-call/{id}/recording',
        ...options,
    })

export const postInterviewsScreeningWebrtcRecordingChunk = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsScreeningWebrtcRecordingChunkData, ThrowOnError>
): RequestResult<PostInterviewsScreeningWebrtcRecordingChunkResponses, PostInterviewsScreeningWebrtcRecordingChunkErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostInterviewsScreeningWebrtcRecordingChunkResponses, PostInterviewsScreeningWebrtcRecordingChunkErrors, ThrowOnError>({
        responseType: 'json',
        url: '/interviews/screening-webrtc/recording/chunk',
        ...options,
    })

/**
 * Post-flush recording compose. ScreenAI lifecycle (interview_completed / client_end /
 */
export const postInterviewsScreeningWebrtcRecordingFinalize = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsScreeningWebrtcRecordingFinalizeData, ThrowOnError>
): RequestResult<PostInterviewsScreeningWebrtcRecordingFinalizeResponses, PostInterviewsScreeningWebrtcRecordingFinalizeErrors, ThrowOnError> =>
    (options?.client ?? client).post<
        PostInterviewsScreeningWebrtcRecordingFinalizeResponses,
        PostInterviewsScreeningWebrtcRecordingFinalizeErrors,
        ThrowOnError
    >({
        responseType: 'json',
        url: '/interviews/screening-webrtc/recording/finalize',
        ...options,
    })

export const postInterviewsScreeningWebrtcRecordingInit = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsScreeningWebrtcRecordingInitData, ThrowOnError>
): RequestResult<PostInterviewsScreeningWebrtcRecordingInitResponses, PostInterviewsScreeningWebrtcRecordingInitErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostInterviewsScreeningWebrtcRecordingInitResponses, PostInterviewsScreeningWebrtcRecordingInitErrors, ThrowOnError>({
        responseType: 'json',
        url: '/interviews/screening-webrtc/recording/init',
        ...options,
    })

/**
 * Mint a signed PUT URL for one GCS compose part (or Azure unused path).
 */
export const postInterviewsScreeningWebrtcRecordingPartUrl = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsScreeningWebrtcRecordingPartUrlData, ThrowOnError>
): RequestResult<PostInterviewsScreeningWebrtcRecordingPartUrlResponses, PostInterviewsScreeningWebrtcRecordingPartUrlErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostInterviewsScreeningWebrtcRecordingPartUrlResponses, PostInterviewsScreeningWebrtcRecordingPartUrlErrors, ThrowOnError>(
        {
            responseType: 'json',
            url: '/interviews/screening-webrtc/recording/part-url',
            ...options,
        }
    )

export const postInterviewsScreeningWebrtcSessionLogAppend = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsScreeningWebrtcSessionLogAppendData, ThrowOnError>
): RequestResult<PostInterviewsScreeningWebrtcSessionLogAppendResponses, PostInterviewsScreeningWebrtcSessionLogAppendErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostInterviewsScreeningWebrtcSessionLogAppendResponses, PostInterviewsScreeningWebrtcSessionLogAppendErrors, ThrowOnError>(
        {
            responseType: 'json',
            url: '/interviews/screening-webrtc/session-log/append',
            ...options,
        }
    )

/**
 * Leave-path session-log finalize (Phase 1 dual-write). Prefer ScreenAI lifecycle.
 */
export const postInterviewsScreeningWebrtcSessionLogFinalize = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsScreeningWebrtcSessionLogFinalizeData, ThrowOnError>
): RequestResult<PostInterviewsScreeningWebrtcSessionLogFinalizeResponses, PostInterviewsScreeningWebrtcSessionLogFinalizeErrors, ThrowOnError> =>
    (options?.client ?? client).post<
        PostInterviewsScreeningWebrtcSessionLogFinalizeResponses,
        PostInterviewsScreeningWebrtcSessionLogFinalizeErrors,
        ThrowOnError
    >({
        responseType: 'json',
        url: '/interviews/screening-webrtc/session-log/finalize',
        ...options,
    })

/**
 * DELETE /api/interviews/screeningInterview/clientToken/[id]
 */
export const deleteInterviewsScreeningInterviewClientTokenId = <ThrowOnError extends boolean = false>(
    options: Options<DeleteInterviewsScreeningInterviewClientTokenIdData, ThrowOnError>
): RequestResult<DeleteInterviewsScreeningInterviewClientTokenIdResponses, DeleteInterviewsScreeningInterviewClientTokenIdErrors, ThrowOnError> =>
    (options.client ?? client).delete<
        DeleteInterviewsScreeningInterviewClientTokenIdResponses,
        DeleteInterviewsScreeningInterviewClientTokenIdErrors,
        ThrowOnError
    >({
        responseType: 'json',
        url: '/interviews/screeningInterview/clientToken/{id}',
        ...options,
    })

/**
 * DELETE /api/interviews/screeningInterview/identity-check/[id]
 */
export const deleteInterviewsScreeningInterviewIdentityCheckId = <ThrowOnError extends boolean = false>(
    options: Options<DeleteInterviewsScreeningInterviewIdentityCheckIdData, ThrowOnError>
): RequestResult<unknown, DeleteInterviewsScreeningInterviewIdentityCheckIdErrors, ThrowOnError> =>
    (options.client ?? client).delete<unknown, DeleteInterviewsScreeningInterviewIdentityCheckIdErrors, ThrowOnError>({
        url: '/interviews/screeningInterview/identity-check/{id}',
        ...options,
    })

/**
 * GET /api/interviews/screeningInterview/identity-check/[id]
 */
export const getInterviewsScreeningInterviewIdentityCheckId = <ThrowOnError extends boolean = false>(
    options: Options<GetInterviewsScreeningInterviewIdentityCheckIdData, ThrowOnError>
): RequestResult<unknown, GetInterviewsScreeningInterviewIdentityCheckIdErrors, ThrowOnError> =>
    (options.client ?? client).get<unknown, GetInterviewsScreeningInterviewIdentityCheckIdErrors, ThrowOnError>({
        url: '/interviews/screeningInterview/identity-check/{id}',
        ...options,
    })

/**
 * DELETE /api/interviews/screeningInterview/speechToken/[id]
 */
export const deleteInterviewsScreeningInterviewSpeechTokenId = <ThrowOnError extends boolean = false>(
    options: Options<DeleteInterviewsScreeningInterviewSpeechTokenIdData, ThrowOnError>
): RequestResult<DeleteInterviewsScreeningInterviewSpeechTokenIdResponses, DeleteInterviewsScreeningInterviewSpeechTokenIdErrors, ThrowOnError> =>
    (options.client ?? client).delete<
        DeleteInterviewsScreeningInterviewSpeechTokenIdResponses,
        DeleteInterviewsScreeningInterviewSpeechTokenIdErrors,
        ThrowOnError
    >({
        responseType: 'json',
        url: '/interviews/screeningInterview/speechToken/{id}',
        ...options,
    })

export const postInterviewsScreeningInterviewTtsEnsure = <ThrowOnError extends boolean = false>(
    options?: Options<PostInterviewsScreeningInterviewTtsEnsureData, ThrowOnError>
): RequestResult<unknown, PostInterviewsScreeningInterviewTtsEnsureErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostInterviewsScreeningInterviewTtsEnsureErrors, ThrowOnError>({
        url: '/interviews/screeningInterview/tts/ensure',
        ...options,
    })

export const patchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummary = <ThrowOnError extends boolean = false>(
    options: Options<PatchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryData, ThrowOnError>
): RequestResult<
    PatchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryResponses,
    PatchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryErrors,
    ThrowOnError
> =>
    (options.client ?? client).patch<
        PatchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryResponses,
        PatchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryErrors,
        ThrowOnError
    >({
        responseTransformer: patchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryResponseTransformer,
        responseType: 'json',
        url: '/interviews/{id}/interviewRound/{interview_round_id}/generate-summary',
        ...options,
    })

/**
 * POST /api/interviews/interviewRound/endInterview
 */
export const postInterviewsIdInterviewRoundInterviewRoundIdGenerateSummary = <ThrowOnError extends boolean = false>(
    options: Options<PostInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryData, ThrowOnError>
): RequestResult<unknown, PostInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryErrors, ThrowOnError> =>
    (options.client ?? client).post<unknown, PostInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryErrors, ThrowOnError>({
        url: '/interviews/{id}/interviewRound/{interview_round_id}/generate-summary',
        ...options,
    })

export const deleteInterviewsIdInterviewRoundInterviewRoundIdPanellist = <ThrowOnError extends boolean = false>(
    options: Options<DeleteInterviewsIdInterviewRoundInterviewRoundIdPanellistData, ThrowOnError>
): RequestResult<unknown, DeleteInterviewsIdInterviewRoundInterviewRoundIdPanellistErrors, ThrowOnError> =>
    (options.client ?? client).delete<unknown, DeleteInterviewsIdInterviewRoundInterviewRoundIdPanellistErrors, ThrowOnError>({
        url: '/interviews/{id}/interviewRound/{interview_round_id}/panellist',
        ...options,
    })

export const postInterviewsIdInterviewRoundInterviewRoundIdRatings = <ThrowOnError extends boolean = false>(
    options: Options<PostInterviewsIdInterviewRoundInterviewRoundIdRatingsData, ThrowOnError>
): RequestResult<unknown, PostInterviewsIdInterviewRoundInterviewRoundIdRatingsErrors, ThrowOnError> =>
    (options.client ?? client).post<unknown, PostInterviewsIdInterviewRoundInterviewRoundIdRatingsErrors, ThrowOnError>({
        url: '/interviews/{id}/interviewRound/{interview_round_id}/ratings',
        ...options,
    })

/**
 * POST /api/interviews/screening-call/[id]/recording/fetch — fetch a missing AI phone screening call recording from the provider.
 *
 * Looks the call's recording up at its telephony provider (Plivo / Twilio) and stores it like the provider's
 */
export const postInterviewsScreeningCallIdRecordingFetch = <ThrowOnError extends boolean = false>(
    options: Options<PostInterviewsScreeningCallIdRecordingFetchData, ThrowOnError>
): RequestResult<PostInterviewsScreeningCallIdRecordingFetchResponses, PostInterviewsScreeningCallIdRecordingFetchErrors, ThrowOnError> =>
    (options.client ?? client).post<PostInterviewsScreeningCallIdRecordingFetchResponses, PostInterviewsScreeningCallIdRecordingFetchErrors, ThrowOnError>({
        responseType: 'json',
        url: '/interviews/screening-call/{id}/recording/fetch',
        ...options,
    })

export const postInterviewsScreeningWebrtcSessionSessionIdConnect = <ThrowOnError extends boolean = false>(
    options: Options<PostInterviewsScreeningWebrtcSessionSessionIdConnectData, ThrowOnError>
): RequestResult<PostInterviewsScreeningWebrtcSessionSessionIdConnectResponses, PostInterviewsScreeningWebrtcSessionSessionIdConnectErrors, ThrowOnError> =>
    (options.client ?? client).post<
        PostInterviewsScreeningWebrtcSessionSessionIdConnectResponses,
        PostInterviewsScreeningWebrtcSessionSessionIdConnectErrors,
        ThrowOnError
    >({
        responseType: 'json',
        url: '/interviews/screening-webrtc/session/{sessionId}/connect',
        ...options,
    })

export const getJdAgentConversation = <ThrowOnError extends boolean = false>(
    options?: Options<GetJdAgentConversationData, ThrowOnError>
): RequestResult<GetJdAgentConversationResponses, GetJdAgentConversationErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetJdAgentConversationResponses, GetJdAgentConversationErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jd-agent/conversation',
        ...options,
    })

export const getJdAgentSpeechToken = <ThrowOnError extends boolean = false>(
    options?: Options<GetJdAgentSpeechTokenData, ThrowOnError>
): RequestResult<GetJdAgentSpeechTokenResponses, GetJdAgentSpeechTokenErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetJdAgentSpeechTokenResponses, GetJdAgentSpeechTokenErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jd-agent/speech-token',
        ...options,
    })

export const postJdAgentConversationSync = <ThrowOnError extends boolean = false>(
    options?: Options<PostJdAgentConversationSyncData, ThrowOnError>
): RequestResult<PostJdAgentConversationSyncResponses, PostJdAgentConversationSyncErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostJdAgentConversationSyncResponses, PostJdAgentConversationSyncErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jd-agent/conversation/sync',
        ...options,
    })

export const postJdAgentBackend = <ThrowOnError extends boolean = false>(
    options?: Options<PostJdAgentBackendData, ThrowOnError>
): RequestResult<PostJdAgentBackendResponses, PostJdAgentBackendErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostJdAgentBackendResponses, PostJdAgentBackendErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jd-agent-backend',
        ...options,
    })

export const postJdAgentBackendStream = <ThrowOnError extends boolean = false>(
    options?: Options<PostJdAgentBackendStreamData, ThrowOnError>
): RequestResult<PostJdAgentBackendStreamResponses, PostJdAgentBackendStreamErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostJdAgentBackendStreamResponses, PostJdAgentBackendStreamErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jd-agent-backend/stream',
        ...options,
    })

export const putJobAppForBackendId = <ThrowOnError extends boolean = false>(
    options: Options<PutJobAppForBackendIdData, ThrowOnError>
): RequestResult<PutJobAppForBackendIdResponses, PutJobAppForBackendIdErrors, ThrowOnError> =>
    (options.client ?? client).put<PutJobAppForBackendIdResponses, PutJobAppForBackendIdErrors, ThrowOnError>({
        responseTransformer: putJobAppForBackendIdResponseTransformer,
        responseType: 'json',
        url: '/jobAppForBackend/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

/**
 * TODO: Split this handler into smaller, well-named helper functions for maintainability
 *
 * List job applications — powers the per-job Applications grid and the referrals list. Handles special filtering for AI interview score/status. Free text goes in `filterModel.quickFilterValues`.
 */
export const getJobApplications = <ThrowOnError extends boolean = false>(
    options: Options<GetJobApplicationsData, ThrowOnError>
): RequestResult<GetJobApplicationsResponses, GetJobApplicationsErrors, ThrowOnError> =>
    (options.client ?? client).get<GetJobApplicationsResponses, GetJobApplicationsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jobApplications',
        ...options,
    })

export const patchJobApplications = <ThrowOnError extends boolean = false>(
    options?: Options<PatchJobApplicationsData, ThrowOnError>
): RequestResult<PatchJobApplicationsResponses, PatchJobApplicationsErrors, ThrowOnError> =>
    (options?.client ?? client).patch<PatchJobApplicationsResponses, PatchJobApplicationsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jobApplications',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

/**
 * Async handler for creating a new JobApplication(bulk)
 */
export const postJobApplications = <ThrowOnError extends boolean = false>(
    options?: Options<PostJobApplicationsData, ThrowOnError>
): RequestResult<PostJobApplicationsResponses, PostJobApplicationsErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostJobApplicationsResponses, PostJobApplicationsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jobApplications',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

/**
 * DELETE /api/jobApplications/{id}
 *
 * Deletes one job application, its JACD candidate-details subtree, and the resume blob when no other application or document references it. Notifies the processing backend and re-dispatches queued applications afterwards.
 */
export const deleteJobApplicationsId = <ThrowOnError extends boolean = false>(
    options: Options<DeleteJobApplicationsIdData, ThrowOnError>
): RequestResult<DeleteJobApplicationsIdResponses, DeleteJobApplicationsIdErrors, ThrowOnError> =>
    (options.client ?? client).delete<DeleteJobApplicationsIdResponses, DeleteJobApplicationsIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jobApplications/{id}',
        ...options,
    })

export const getJobApplicationsId = <ThrowOnError extends boolean = false>(
    options: Options<GetJobApplicationsIdData, ThrowOnError>
): RequestResult<GetJobApplicationsIdResponses, GetJobApplicationsIdErrors, ThrowOnError> =>
    (options.client ?? client).get<GetJobApplicationsIdResponses, GetJobApplicationsIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jobApplications/{id}',
        ...options,
    })

/**
 * / This is called for resubmitting the jobApplication for backend Processing again.
 */
export const postJobApplicationsId = <ThrowOnError extends boolean = false>(
    options: Options<PostJobApplicationsIdData, ThrowOnError>
): RequestResult<PostJobApplicationsIdResponses, PostJobApplicationsIdErrors, ThrowOnError> =>
    (options.client ?? client).post<PostJobApplicationsIdResponses, PostJobApplicationsIdErrors, ThrowOnError>({
        responseTransformer: postJobApplicationsIdResponseTransformer,
        responseType: 'json',
        url: '/jobApplications/{id}',
        ...options,
    })

export const putJobApplicationsId = <ThrowOnError extends boolean = false>(
    options: Options<PutJobApplicationsIdData, ThrowOnError>
): RequestResult<PutJobApplicationsIdResponses, PutJobApplicationsIdErrors, ThrowOnError> =>
    (options.client ?? client).put<PutJobApplicationsIdResponses, PutJobApplicationsIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jobApplications/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

export const putJobApplicationsApprove = <ThrowOnError extends boolean = false>(
    options?: Options<PutJobApplicationsApproveData, ThrowOnError>
): RequestResult<PutJobApplicationsApproveResponses, PutJobApplicationsApproveErrors, ThrowOnError> =>
    (options?.client ?? client).put<PutJobApplicationsApproveResponses, PutJobApplicationsApproveErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jobApplications/approve',
        ...options,
    })

export const postJobApplicationsBulkDelete = <ThrowOnError extends boolean = false>(
    options?: Options<PostJobApplicationsBulkDeleteData, ThrowOnError>
): RequestResult<PostJobApplicationsBulkDeleteResponses, PostJobApplicationsBulkDeleteErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostJobApplicationsBulkDeleteResponses, PostJobApplicationsBulkDeleteErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jobApplications/bulk-delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

/**
 * POST /api/jobApplications/bulk-reprocess
 */
export const postJobApplicationsBulkReprocess = <ThrowOnError extends boolean = false>(
    options?: Options<PostJobApplicationsBulkReprocessData, ThrowOnError>
): RequestResult<PostJobApplicationsBulkReprocessResponses, PostJobApplicationsBulkReprocessErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostJobApplicationsBulkReprocessResponses, PostJobApplicationsBulkReprocessErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jobApplications/bulk-reprocess',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

/**
 * GET /api/jobApplications/processing
 *
 * Resume-processing workspace rows for a job (unprocessed/failed subset) plus status counts across all its applications — powers the Add Candidates grid.
 */
export const getJobApplicationsProcessing = <ThrowOnError extends boolean = false>(
    options: Options<GetJobApplicationsProcessingData, ThrowOnError>
): RequestResult<GetJobApplicationsProcessingResponses, GetJobApplicationsProcessingErrors, ThrowOnError> =>
    (options.client ?? client).get<GetJobApplicationsProcessingResponses, GetJobApplicationsProcessingErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jobApplications/processing',
        ...options,
    })

export const getJobApplicationsStatus = <ThrowOnError extends boolean = false>(
    options?: Options<GetJobApplicationsStatusData, ThrowOnError>
): RequestResult<GetJobApplicationsStatusResponses, GetJobApplicationsStatusErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetJobApplicationsStatusResponses, GetJobApplicationsStatusErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jobApplications/status',
        ...options,
    })

export const patchJobApplicationsStatus = <ThrowOnError extends boolean = false>(
    options?: Options<PatchJobApplicationsStatusData, ThrowOnError>
): RequestResult<PatchJobApplicationsStatusResponses, PatchJobApplicationsStatusErrors, ThrowOnError> =>
    (options?.client ?? client).patch<PatchJobApplicationsStatusResponses, PatchJobApplicationsStatusErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jobApplications/status',
        ...options,
    })

export const getJobApplicationsIdApplicantHistory = <ThrowOnError extends boolean = false>(
    options: Options<GetJobApplicationsIdApplicantHistoryData, ThrowOnError>
): RequestResult<GetJobApplicationsIdApplicantHistoryResponses, GetJobApplicationsIdApplicantHistoryErrors, ThrowOnError> =>
    (options.client ?? client).get<GetJobApplicationsIdApplicantHistoryResponses, GetJobApplicationsIdApplicantHistoryErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jobApplications/{id}/applicantHistory',
        ...options,
    })

/**
 * POST /api/jobApplications/{id}/reprocess
 *
 * Re-queues one application for resume processing — holds resume credits (403 with an ApiError envelope when the plan limit is hit).
 */
export const postJobApplicationsIdReprocess = <ThrowOnError extends boolean = false>(
    options: Options<PostJobApplicationsIdReprocessData, ThrowOnError>
): RequestResult<PostJobApplicationsIdReprocessResponses, PostJobApplicationsIdReprocessErrors, ThrowOnError> =>
    (options.client ?? client).post<PostJobApplicationsIdReprocessResponses, PostJobApplicationsIdReprocessErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jobApplications/{id}/reprocess',
        ...options,
    })

export const getJobApprovers = <ThrowOnError extends boolean = false>(
    options?: Options<GetJobApproversData, ThrowOnError>
): RequestResult<GetJobApproversResponses, GetJobApproversErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetJobApproversResponses, GetJobApproversErrors, ThrowOnError>({
        responseTransformer: getJobApproversResponseTransformer,
        responseType: 'json',
        url: '/jobApprovers',
        ...options,
    })

export const postJobApprovers = <ThrowOnError extends boolean = false>(
    options?: Options<PostJobApproversData, ThrowOnError>
): RequestResult<PostJobApproversResponses, PostJobApproversErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostJobApproversResponses, PostJobApproversErrors, ThrowOnError>({
        responseTransformer: postJobApproversResponseTransformer,
        responseType: 'json',
        url: '/jobApprovers',
        ...options,
    })

export const getJobApproversApprove = <ThrowOnError extends boolean = false>(
    options?: Options<GetJobApproversApproveData, ThrowOnError>
): RequestResult<GetJobApproversApproveResponses, GetJobApproversApproveErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetJobApproversApproveResponses, GetJobApproversApproveErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jobApprovers/approve',
        ...options,
    })

export const putJobApproversApprove = <ThrowOnError extends boolean = false>(
    options?: Options<PutJobApproversApproveData, ThrowOnError>
): RequestResult<PutJobApproversApproveResponses, PutJobApproversApproveErrors, ThrowOnError> =>
    (options?.client ?? client).put<PutJobApproversApproveResponses, PutJobApproversApproveErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jobApprovers/approve',
        ...options,
    })

/**
 * POST /api/jobApprovers/bypass/[id]
 */
export const postJobApproversBypassId = <ThrowOnError extends boolean = false>(
    options: Options<PostJobApproversBypassIdData, ThrowOnError>
): RequestResult<unknown, PostJobApproversBypassIdErrors, ThrowOnError> =>
    (options.client ?? client).post<unknown, PostJobApproversBypassIdErrors, ThrowOnError>({ url: '/jobApprovers/bypass/{id}', ...options })

export const postJobApproversReminderId = <ThrowOnError extends boolean = false>(
    options: Options<PostJobApproversReminderIdData, ThrowOnError>
): RequestResult<PostJobApproversReminderIdResponses, PostJobApproversReminderIdErrors, ThrowOnError> =>
    (options.client ?? client).post<PostJobApproversReminderIdResponses, PostJobApproversReminderIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jobApprovers/reminder/{id}',
        ...options,
    })

/**
 * GET /api/jd
 *
 * List job descriptions for the session company. `companyId` in the query is accepted for compatibility but must match the session company.
 */
export const getJd = <ThrowOnError extends boolean = false>(
    options?: Options<GetJdData, ThrowOnError>
): RequestResult<GetJdResponses, GetJdErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetJdResponses, GetJdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jd',
        ...options,
    })

/**
 * POST /api/jd
 *
 * Create a job description for the session company. `companyId` in the body is accepted for compatibility but must match the session company.
 */
export const postJd = <ThrowOnError extends boolean = false>(
    options?: Options<PostJdData, ThrowOnError>
): RequestResult<PostJdResponses, PostJdErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostJdResponses, PostJdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jd',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

/**
 * DELETE /api/jd/{id}
 *
 * Delete a job description. Scoped to the session company; 409 while live job postings still reference it.
 */
export const deleteJdId = <ThrowOnError extends boolean = false>(
    options: Options<DeleteJdIdData, ThrowOnError>
): RequestResult<DeleteJdIdResponses, DeleteJdIdErrors, ThrowOnError> =>
    (options.client ?? client).delete<DeleteJdIdResponses, DeleteJdIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jd/{id}',
        ...options,
    })

/**
 * GET /api/jd/{id}
 *
 * Fetch a single job description. Public — powers guest create-jd links and the candidate-sharing page; never includes company data.
 */
export const getJdId = <ThrowOnError extends boolean = false>(
    options: Options<GetJdIdData, ThrowOnError>
): RequestResult<GetJdIdResponses, GetJdIdErrors, ThrowOnError> =>
    (options.client ?? client).get<GetJdIdResponses, GetJdIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jd/{id}',
        ...options,
    })

/**
 * PATCH /api/jd/{id}
 *
 * Update a job description. Scoped to the session company; a changed `content` re-syncs JD agent state and reprocesses live linked job postings.
 */
export const patchJdId = <ThrowOnError extends boolean = false>(
    options: Options<PatchJdIdData, ThrowOnError>
): RequestResult<PatchJdIdResponses, PatchJdIdErrors, ThrowOnError> =>
    (options.client ?? client).patch<PatchJdIdResponses, PatchJdIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jd/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

/**
 * GET /api/jd/extract-text
 *
 * Extract text from a JD document already in blob storage. `fileUrl` must be a storage object URL.
 */
export const getJdExtractText = <ThrowOnError extends boolean = false>(
    options: Options<GetJdExtractTextData, ThrowOnError>
): RequestResult<GetJdExtractTextResponses, GetJdExtractTextErrors, ThrowOnError> =>
    (options.client ?? client).get<GetJdExtractTextResponses, GetJdExtractTextErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jd/extract-text',
        ...options,
    })

/**
 * POST /api/jd/extract-text
 *
 * Extract text from an uploaded JD document (PDF, DOCX, or TXT up to 10 MB). The file signature must match the declared type.
 */
export const postJdExtractText = <ThrowOnError extends boolean = false>(
    options?: Options<PostJdExtractTextData, ThrowOnError>
): RequestResult<PostJdExtractTextResponses, PostJdExtractTextErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostJdExtractTextResponses, PostJdExtractTextErrors, ThrowOnError>({
        ...formDataBodySerializer,
        responseType: 'json',
        url: '/jd/extract-text',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers,
        },
    })

export const patchJobOpeningsId = <ThrowOnError extends boolean = false>(
    options: Options<PatchJobOpeningsIdData, ThrowOnError>
): RequestResult<unknown, PatchJobOpeningsIdErrors, ThrowOnError> =>
    (options.client ?? client).patch<unknown, PatchJobOpeningsIdErrors, ThrowOnError>({ url: '/jobOpenings/{id}', ...options })

/**
 * GET /api/jobs
 *
 * List job postings for the session company — powers the My Jobs grid. Free-text search goes in `filterModel.searchTerms` and is tokenized server-side.
 */
export const getJobs = <ThrowOnError extends boolean = false>(
    options?: Options<GetJobsData, ThrowOnError>
): RequestResult<GetJobsResponses, GetJobsErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetJobsResponses, GetJobsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jobs',
        ...options,
    })

/**
 * POST /api/jobs — create a new job posting
 */
export const postJobs = <ThrowOnError extends boolean = false>(
    options?: Options<PostJobsData, ThrowOnError>
): RequestResult<PostJobsResponses, PostJobsErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostJobsResponses, PostJobsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jobs',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

/**
 * DELETE /api/jobs/[id]
 */
export const deleteJobsId = <ThrowOnError extends boolean = false>(
    options: Options<DeleteJobsIdData, ThrowOnError>
): RequestResult<DeleteJobsIdResponses, DeleteJobsIdErrors, ThrowOnError> =>
    (options.client ?? client).delete<DeleteJobsIdResponses, DeleteJobsIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jobs/{id}',
        ...options,
    })

/**
 * GET /api/jobs/[id]
 */
export const getJobsId = <ThrowOnError extends boolean = false>(
    options: Options<GetJobsIdData, ThrowOnError>
): RequestResult<unknown, GetJobsIdErrors, ThrowOnError> =>
    (options.client ?? client).get<unknown, GetJobsIdErrors, ThrowOnError>({ url: '/jobs/{id}', ...options })

/**
 * PUT /api/jobs/[id]
 */
export const putJobsId = <ThrowOnError extends boolean = false>(
    options: Options<PutJobsIdData, ThrowOnError>
): RequestResult<PutJobsIdResponses, PutJobsIdErrors, ThrowOnError> =>
    (options.client ?? client).put<PutJobsIdResponses, PutJobsIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jobs/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

export const postJobsBulkDelete = <ThrowOnError extends boolean = false>(
    options?: Options<PostJobsBulkDeleteData, ThrowOnError>
): RequestResult<PostJobsBulkDeleteResponses, PostJobsBulkDeleteErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostJobsBulkDeleteResponses, PostJobsBulkDeleteErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jobs/bulk-delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

export const getJobsSearch = <ThrowOnError extends boolean = false>(
    options?: Options<GetJobsSearchData, ThrowOnError>
): RequestResult<GetJobsSearchResponses, GetJobsSearchErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetJobsSearchResponses, GetJobsSearchErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jobs/search',
        ...options,
    })

/**
 * GET /api/jobs/[id]/candidate-matching
 *
 * Hybrid vector + filter search of the talent pool for a job — powers the Talent Matching grid. Free text goes in `filterModel.quickFilterValues`.
 */
export const getJobsIdCandidateMatching = <ThrowOnError extends boolean = false>(
    options: Options<GetJobsIdCandidateMatchingData, ThrowOnError>
): RequestResult<GetJobsIdCandidateMatchingResponses, GetJobsIdCandidateMatchingErrors, ThrowOnError> =>
    (options.client ?? client).get<GetJobsIdCandidateMatchingResponses, GetJobsIdCandidateMatchingErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jobs/{id}/candidate-matching',
        ...options,
    })

/**
 * GET /api/jobs/[id]/locations
 */
export const getJobsIdLocations = <ThrowOnError extends boolean = false>(
    options: Options<GetJobsIdLocationsData, ThrowOnError>
): RequestResult<GetJobsIdLocationsResponses, GetJobsIdLocationsErrors, ThrowOnError> =>
    (options.client ?? client).get<GetJobsIdLocationsResponses, GetJobsIdLocationsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jobs/{id}/locations',
        ...options,
    })

/**
 * PATCH /api/jobs/[id]/status
 */
export const patchJobsIdStatus = <ThrowOnError extends boolean = false>(
    options: Options<PatchJobsIdStatusData, ThrowOnError>
): RequestResult<PatchJobsIdStatusResponses, PatchJobsIdStatusErrors, ThrowOnError> =>
    (options.client ?? client).patch<PatchJobsIdStatusResponses, PatchJobsIdStatusErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jobs/{id}/status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

export const deleteJobsChatbot = <ThrowOnError extends boolean = false>(
    options?: Options<DeleteJobsChatbotData, ThrowOnError>
): RequestResult<DeleteJobsChatbotResponses, DeleteJobsChatbotErrors, ThrowOnError> =>
    (options?.client ?? client).delete<DeleteJobsChatbotResponses, DeleteJobsChatbotErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jobsChatbot',
        ...options,
    })

export const getJobsChatbot = <ThrowOnError extends boolean = false>(
    options?: Options<GetJobsChatbotData, ThrowOnError>
): RequestResult<GetJobsChatbotResponses, GetJobsChatbotErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetJobsChatbotResponses, GetJobsChatbotErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jobsChatbot',
        ...options,
    })

export const postJobsChatbot = <ThrowOnError extends boolean = false>(
    options?: Options<PostJobsChatbotData, ThrowOnError>
): RequestResult<PostJobsChatbotResponses, PostJobsChatbotErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostJobsChatbotResponses, PostJobsChatbotErrors, ThrowOnError>({
        responseType: 'json',
        url: '/jobsChatbot',
        ...options,
    })

export const postMailboxMonitoring = <ThrowOnError extends boolean = false>(
    options?: Options<PostMailboxMonitoringData, ThrowOnError>
): RequestResult<unknown, PostMailboxMonitoringErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostMailboxMonitoringErrors, ThrowOnError>({ url: '/mailbox-monitoring', ...options })

export const postMailboxMonitoringProcess = <ThrowOnError extends boolean = false>(
    options?: Options<PostMailboxMonitoringProcessData, ThrowOnError>
): RequestResult<unknown, PostMailboxMonitoringProcessErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostMailboxMonitoringProcessErrors, ThrowOnError>({ url: '/mailbox-monitoring/process', ...options })

export const postMarleeCommand = <ThrowOnError extends boolean = false>(
    options?: Options<PostMarleeCommandData, ThrowOnError>
): RequestResult<PostMarleeCommandResponses, PostMarleeCommandErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostMarleeCommandResponses, PostMarleeCommandErrors, ThrowOnError>({
        responseType: 'json',
        url: '/marlee/command',
        ...options,
    })

export const postMarleeSession = <ThrowOnError extends boolean = false>(
    options?: Options<PostMarleeSessionData, ThrowOnError>
): RequestResult<PostMarleeSessionResponses, PostMarleeSessionErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostMarleeSessionResponses, PostMarleeSessionErrors, ThrowOnError>({
        responseType: 'json',
        url: '/marlee/session',
        ...options,
    })

export const deleteMarleeSessionSessionId = <ThrowOnError extends boolean = false>(
    options: Options<DeleteMarleeSessionSessionIdData, ThrowOnError>
): RequestResult<DeleteMarleeSessionSessionIdResponses, DeleteMarleeSessionSessionIdErrors, ThrowOnError> =>
    (options.client ?? client).delete<DeleteMarleeSessionSessionIdResponses, DeleteMarleeSessionSessionIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/marlee/session/{sessionId}',
        ...options,
    })

export const getMetrics = <ThrowOnError extends boolean = false>(
    options?: Options<GetMetricsData, ThrowOnError>
): RequestResult<GetMetricsResponses, GetMetricsErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetMetricsResponses, GetMetricsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/metrics',
        ...options,
    })

export const getMetricsStatusChange = <ThrowOnError extends boolean = false>(
    options?: Options<GetMetricsStatusChangeData, ThrowOnError>
): RequestResult<unknown, GetMetricsStatusChangeErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetMetricsStatusChangeErrors, ThrowOnError>({ url: '/metrics/statusChange', ...options })

export const postNaukriJob = <ThrowOnError extends boolean = false>(
    options?: Options<PostNaukriJobData, ThrowOnError>
): RequestResult<PostNaukriJobResponses, PostNaukriJobErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostNaukriJobResponses, PostNaukriJobErrors, ThrowOnError>({
        responseType: 'json',
        url: '/naukriJob',
        ...options,
    })

export const getNotes = <ThrowOnError extends boolean = false>(
    options?: Options<GetNotesData, ThrowOnError>
): RequestResult<unknown, GetNotesErrors, ThrowOnError> => (options?.client ?? client).get<unknown, GetNotesErrors, ThrowOnError>({ url: '/notes', ...options })

export const postNotes = <ThrowOnError extends boolean = false>(
    options?: Options<PostNotesData, ThrowOnError>
): RequestResult<unknown, PostNotesErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostNotesErrors, ThrowOnError>({ url: '/notes', ...options })

/**
 * Pinned for parity; fix separately.
 */
export const deleteNotesId = <ThrowOnError extends boolean = false>(
    options: Options<DeleteNotesIdData, ThrowOnError>
): RequestResult<unknown, DeleteNotesIdErrors, ThrowOnError> =>
    (options.client ?? client).delete<unknown, DeleteNotesIdErrors, ThrowOnError>({ url: '/notes/{id}', ...options })

export const putNotesId = <ThrowOnError extends boolean = false>(
    options: Options<PutNotesIdData, ThrowOnError>
): RequestResult<unknown, PutNotesIdErrors, ThrowOnError> =>
    (options.client ?? client).put<unknown, PutNotesIdErrors, ThrowOnError>({ url: '/notes/{id}', ...options })

export const getNotesByEmail = <ThrowOnError extends boolean = false>(
    options?: Options<GetNotesByEmailData, ThrowOnError>
): RequestResult<unknown, GetNotesByEmailErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetNotesByEmailErrors, ThrowOnError>({ url: '/notes/by-email', ...options })

export const getNotifications = <ThrowOnError extends boolean = false>(
    options?: Options<GetNotificationsData, ThrowOnError>
): RequestResult<GetNotificationsResponses, GetNotificationsErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetNotificationsResponses, GetNotificationsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/notifications',
        ...options,
    })

export const putNotifications = <ThrowOnError extends boolean = false>(
    options?: Options<PutNotificationsData, ThrowOnError>
): RequestResult<PutNotificationsResponses, PutNotificationsErrors, ThrowOnError> =>
    (options?.client ?? client).put<PutNotificationsResponses, PutNotificationsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/notifications',
        ...options,
    })

export const deleteNotificationsId = <ThrowOnError extends boolean = false>(
    options: Options<DeleteNotificationsIdData, ThrowOnError>
): RequestResult<DeleteNotificationsIdResponses, DeleteNotificationsIdErrors, ThrowOnError> =>
    (options.client ?? client).delete<DeleteNotificationsIdResponses, DeleteNotificationsIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/notifications/{id}',
        ...options,
    })

export const getOffers = <ThrowOnError extends boolean = false>(
    options?: Options<GetOffersData, ThrowOnError>
): RequestResult<GetOffersResponses, GetOffersErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetOffersResponses, GetOffersErrors, ThrowOnError>({
        responseTransformer: getOffersResponseTransformer,
        responseType: 'json',
        url: '/offers',
        ...options,
    })

export const postOffers = <ThrowOnError extends boolean = false>(
    options?: Options<PostOffersData, ThrowOnError>
): RequestResult<PostOffersResponses, PostOffersErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostOffersResponses, PostOffersErrors, ThrowOnError>({
        responseType: 'json',
        url: '/offers',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

export const putOffers = <ThrowOnError extends boolean = false>(
    options?: Options<PutOffersData, ThrowOnError>
): RequestResult<PutOffersResponses, PutOffersErrors, ThrowOnError> =>
    (options?.client ?? client).put<PutOffersResponses, PutOffersErrors, ThrowOnError>({
        responseTransformer: putOffersResponseTransformer,
        responseType: 'json',
        url: '/offers',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

export const putOffersAccept = <ThrowOnError extends boolean = false>(
    options?: Options<PutOffersAcceptData, ThrowOnError>
): RequestResult<PutOffersAcceptResponses, PutOffersAcceptErrors, ThrowOnError> =>
    (options?.client ?? client).put<PutOffersAcceptResponses, PutOffersAcceptErrors, ThrowOnError>({
        responseType: 'json',
        url: '/offers/accept',
        ...options,
    })

/**
 * GET: Fetch offer/application data by jobOfferSlug (public - for approval page)
 */
export const getOffersApprove = <ThrowOnError extends boolean = false>(
    options?: Options<GetOffersApproveData, ThrowOnError>
): RequestResult<GetOffersApproveResponses, GetOffersApproveErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetOffersApproveResponses, GetOffersApproveErrors, ThrowOnError>({
        responseTransformer: getOffersApproveResponseTransformer,
        responseType: 'json',
        url: '/offers/approve',
        ...options,
    })

export const putOffersApprove = <ThrowOnError extends boolean = false>(
    options?: Options<PutOffersApproveData, ThrowOnError>
): RequestResult<PutOffersApproveResponses, PutOffersApproveErrors, ThrowOnError> =>
    (options?.client ?? client).put<PutOffersApproveResponses, PutOffersApproveErrors, ThrowOnError>({
        responseType: 'json',
        url: '/offers/approve',
        ...options,
    })

export const putOffersDocuments = <ThrowOnError extends boolean = false>(
    options?: Options<PutOffersDocumentsData, ThrowOnError>
): RequestResult<PutOffersDocumentsResponses, PutOffersDocumentsErrors, ThrowOnError> =>
    (options?.client ?? client).put<PutOffersDocumentsResponses, PutOffersDocumentsErrors, ThrowOnError>({
        responseTransformer: putOffersDocumentsResponseTransformer,
        responseType: 'json',
        url: '/offers/documents',
        ...options,
    })

export const postOffersRemind = <ThrowOnError extends boolean = false>(
    options?: Options<PostOffersRemindData, ThrowOnError>
): RequestResult<PostOffersRemindResponses, PostOffersRemindErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostOffersRemindResponses, PostOffersRemindErrors, ThrowOnError>({
        responseType: 'json',
        url: '/offers/remind',
        ...options,
    })

export const postOffersRequestDocuments = <ThrowOnError extends boolean = false>(
    options?: Options<PostOffersRequestDocumentsData, ThrowOnError>
): RequestResult<PostOffersRequestDocumentsResponses, PostOffersRequestDocumentsErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostOffersRequestDocumentsResponses, PostOffersRequestDocumentsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/offers/request-documents',
        ...options,
    })

export const postOffersSend = <ThrowOnError extends boolean = false>(
    options?: Options<PostOffersSendData, ThrowOnError>
): RequestResult<PostOffersSendResponses, PostOffersSendErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostOffersSendResponses, PostOffersSendErrors, ThrowOnError>({
        responseType: 'json',
        url: '/offers/send',
        ...options,
    })

export const postOffersSendForApproval = <ThrowOnError extends boolean = false>(
    options?: Options<PostOffersSendForApprovalData, ThrowOnError>
): RequestResult<PostOffersSendForApprovalResponses, PostOffersSendForApprovalErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostOffersSendForApprovalResponses, PostOffersSendForApprovalErrors, ThrowOnError>({
        responseType: 'json',
        url: '/offers/send-for-approval',
        ...options,
    })

export const getOffersUploadDocumentsId = <ThrowOnError extends boolean = false>(
    options: Options<GetOffersUploadDocumentsIdData, ThrowOnError>
): RequestResult<GetOffersUploadDocumentsIdResponses, GetOffersUploadDocumentsIdErrors, ThrowOnError> =>
    (options.client ?? client).get<GetOffersUploadDocumentsIdResponses, GetOffersUploadDocumentsIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/offers/upload-documents/{id}',
        ...options,
    })

export const postOffersUploadDocumentsId = <ThrowOnError extends boolean = false>(
    options: Options<PostOffersUploadDocumentsIdData, ThrowOnError>
): RequestResult<PostOffersUploadDocumentsIdResponses, PostOffersUploadDocumentsIdErrors, ThrowOnError> =>
    (options.client ?? client).post<PostOffersUploadDocumentsIdResponses, PostOffersUploadDocumentsIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/offers/upload-documents/{id}',
        ...options,
    })

export const putOffersUploadDocumentsId = <ThrowOnError extends boolean = false>(
    options: Options<PutOffersUploadDocumentsIdData, ThrowOnError>
): RequestResult<PutOffersUploadDocumentsIdResponses, PutOffersUploadDocumentsIdErrors, ThrowOnError> =>
    (options.client ?? client).put<PutOffersUploadDocumentsIdResponses, PutOffersUploadDocumentsIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/offers/upload-documents/{id}',
        ...options,
    })

export const getOgApply = <ThrowOnError extends boolean = false>(
    options?: Options<GetOgApplyData, ThrowOnError>
): RequestResult<unknown, GetOgApplyErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetOgApplyErrors, ThrowOnError>({ url: '/og/apply', ...options })

export const getOgCompany = <ThrowOnError extends boolean = false>(
    options?: Options<GetOgCompanyData, ThrowOnError>
): RequestResult<unknown, GetOgCompanyErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetOgCompanyErrors, ThrowOnError>({ url: '/og/company', ...options })

export const getOgDefault = <ThrowOnError extends boolean = false>(
    options?: Options<GetOgDefaultData, ThrowOnError>
): RequestResult<unknown, GetOgDefaultErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetOgDefaultErrors, ThrowOnError>({ url: '/og/default', ...options })

/**
 * POST /api/onboarding/complete-checkout
 *
 * Complete paid signup provisioning from a Stripe Checkout session id.
 */
export const postOnboardingCompleteCheckout = <ThrowOnError extends boolean = false>(
    options?: Options<PostOnboardingCompleteCheckoutData, ThrowOnError>
): RequestResult<PostOnboardingCompleteCheckoutResponses, PostOnboardingCompleteCheckoutErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostOnboardingCompleteCheckoutResponses, PostOnboardingCompleteCheckoutErrors, ThrowOnError>({
        responseType: 'json',
        url: '/onboarding/complete-checkout',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

/**
 * POST /api/onboarding/complete-signup
 *
 * Verify OTP and create the Auth0 account for self-service signup.
 */
export const postOnboardingCompleteSignup = <ThrowOnError extends boolean = false>(
    options?: Options<PostOnboardingCompleteSignupData, ThrowOnError>
): RequestResult<PostOnboardingCompleteSignupResponses, PostOnboardingCompleteSignupErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostOnboardingCompleteSignupResponses, PostOnboardingCompleteSignupErrors, ThrowOnError>({
        responseType: 'json',
        url: '/onboarding/complete-signup',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

/**
 * PATCH /api/onboarding/org — set company name, slug, and logo on draft.
 *
 * Save organization details on the active signup draft.
 */
export const patchOnboardingOrg = <ThrowOnError extends boolean = false>(
    options?: Options<PatchOnboardingOrgData, ThrowOnError>
): RequestResult<PatchOnboardingOrgResponses, PatchOnboardingOrgErrors, ThrowOnError> =>
    (options?.client ?? client).patch<PatchOnboardingOrgResponses, PatchOnboardingOrgErrors, ThrowOnError>({
        responseType: 'json',
        url: '/onboarding/org',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

/**
 * GET /api/onboarding/plans — public active + public billing plans.
 *
 * List active public billing plans available for self-service signup.
 */
export const getOnboardingPlans = <ThrowOnError extends boolean = false>(
    options?: Options<GetOnboardingPlansData, ThrowOnError>
): RequestResult<GetOnboardingPlansResponses, GetOnboardingPlansErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetOnboardingPlansResponses, GetOnboardingPlansErrors, ThrowOnError>({
        responseType: 'json',
        url: '/onboarding/plans',
        ...options,
    })

/**
 * POST /api/onboarding/select-plan
 *
 * Select a public plan; freemium provisions immediately, paid starts Stripe Checkout.
 */
export const postOnboardingSelectPlan = <ThrowOnError extends boolean = false>(
    options?: Options<PostOnboardingSelectPlanData, ThrowOnError>
): RequestResult<PostOnboardingSelectPlanResponses, PostOnboardingSelectPlanErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostOnboardingSelectPlanResponses, PostOnboardingSelectPlanErrors, ThrowOnError>({
        responseType: 'json',
        url: '/onboarding/select-plan',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

/**
 * POST /api/onboarding/signup
 *
 * Start self-service signup and send an email verification code.
 */
export const postOnboardingSignup = <ThrowOnError extends boolean = false>(
    options?: Options<PostOnboardingSignupData, ThrowOnError>
): RequestResult<PostOnboardingSignupResponses, PostOnboardingSignupErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostOnboardingSignupResponses, PostOnboardingSignupErrors, ThrowOnError>({
        responseType: 'json',
        url: '/onboarding/signup',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

/**
 * GET /api/onboarding/status — current draft for the logged-in Auth0 user.
 *
 * Return the active signup draft for the authenticated user.
 */
export const getOnboardingStatus = <ThrowOnError extends boolean = false>(
    options?: Options<GetOnboardingStatusData, ThrowOnError>
): RequestResult<GetOnboardingStatusResponses, GetOnboardingStatusErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetOnboardingStatusResponses, GetOnboardingStatusErrors, ThrowOnError>({
        responseType: 'json',
        url: '/onboarding/status',
        ...options,
    })

/**
 * POST /api/onboarding/upload-logo
 *
 * Upload a company logo during onboarding (multipart form).
 */
export const postOnboardingUploadLogo = <ThrowOnError extends boolean = false>(
    options?: Options<PostOnboardingUploadLogoData, ThrowOnError>
): RequestResult<PostOnboardingUploadLogoResponses, PostOnboardingUploadLogoErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostOnboardingUploadLogoResponses, PostOnboardingUploadLogoErrors, ThrowOnError>({
        ...formDataBodySerializer,
        responseType: 'json',
        url: '/onboarding/upload-logo',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers,
        },
    })

/**
 * POST /api/onboarding/verify-code
 *
 * Verify the 6-digit signup email OTP for the active draft.
 */
export const postOnboardingVerifyCode = <ThrowOnError extends boolean = false>(
    options?: Options<PostOnboardingVerifyCodeData, ThrowOnError>
): RequestResult<PostOnboardingVerifyCodeResponses, PostOnboardingVerifyCodeErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostOnboardingVerifyCodeResponses, PostOnboardingVerifyCodeErrors, ThrowOnError>({
        responseType: 'json',
        url: '/onboarding/verify-code',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

/**
 * GET /api/onboarding/verify-status — return draft verification status from DB.
 *
 * Return email verification status for the active signup draft.
 */
export const getOnboardingVerifyStatus = <ThrowOnError extends boolean = false>(
    options?: Options<GetOnboardingVerifyStatusData, ThrowOnError>
): RequestResult<GetOnboardingVerifyStatusResponses, GetOnboardingVerifyStatusErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetOnboardingVerifyStatusResponses, GetOnboardingVerifyStatusErrors, ThrowOnError>({
        responseType: 'json',
        url: '/onboarding/verify-status',
        ...options,
    })

/**
 * POST /api/onboarding/verify-status — resend verification code email.
 *
 * Resend the signup email verification code.
 */
export const postOnboardingVerifyStatus = <ThrowOnError extends boolean = false>(
    options?: Options<PostOnboardingVerifyStatusData, ThrowOnError>
): RequestResult<PostOnboardingVerifyStatusResponses, PostOnboardingVerifyStatusErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostOnboardingVerifyStatusResponses, PostOnboardingVerifyStatusErrors, ThrowOnError>({
        responseType: 'json',
        url: '/onboarding/verify-status',
        ...options,
    })

export const postPermissions = <ThrowOnError extends boolean = false>(
    options?: Options<PostPermissionsData, ThrowOnError>
): RequestResult<PostPermissionsResponses, PostPermissionsErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostPermissionsResponses, PostPermissionsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/permissions',
        ...options,
    })

/**
 * GET /api/{companySlug}/public/career/departments
 *
 * List all departments for a company's public career page filters.
 */
export const getCompanySlugPublicCareerDepartments = <ThrowOnError extends boolean = false>(
    options: Options<GetCompanySlugPublicCareerDepartmentsData, ThrowOnError>
): RequestResult<GetCompanySlugPublicCareerDepartmentsResponses, GetCompanySlugPublicCareerDepartmentsErrors, ThrowOnError> =>
    (options.client ?? client).get<GetCompanySlugPublicCareerDepartmentsResponses, GetCompanySlugPublicCareerDepartmentsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/{companySlug}/public/career/departments',
        ...options,
    })

/**
 * GET /api/{companySlug}/public/career/jobs
 *
 * List externally visible jobs for a company's public career page. Supports pagination, filters, XML feed, and all=true for full export.
 */
export const getCompanySlugPublicCareerJobs = <ThrowOnError extends boolean = false>(
    options: Options<GetCompanySlugPublicCareerJobsData, ThrowOnError>
): RequestResult<GetCompanySlugPublicCareerJobsResponses, GetCompanySlugPublicCareerJobsErrors, ThrowOnError> =>
    (options.client ?? client).get<GetCompanySlugPublicCareerJobsResponses, GetCompanySlugPublicCareerJobsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/{companySlug}/public/career/jobs',
        ...options,
    })

/**
 * GET /api/{companySlug}/public/career/jobs/{id}
 *
 * Fetch a single public job for the apply flow. Job must belong to the company in the path.
 */
export const getCompanySlugPublicCareerJobsId = <ThrowOnError extends boolean = false>(
    options: Options<GetCompanySlugPublicCareerJobsIdData, ThrowOnError>
): RequestResult<GetCompanySlugPublicCareerJobsIdResponses, GetCompanySlugPublicCareerJobsIdErrors, ThrowOnError> =>
    (options.client ?? client).get<GetCompanySlugPublicCareerJobsIdResponses, GetCompanySlugPublicCareerJobsIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/{companySlug}/public/career/jobs/{id}',
        ...options,
    })

export const postReachOut = <ThrowOnError extends boolean = false>(
    options?: Options<PostReachOutData, ThrowOnError>
): RequestResult<unknown, PostReachOutErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostReachOutErrors, ThrowOnError>({ url: '/reach-out', ...options })

export const postReachOutSlotBooking = <ThrowOnError extends boolean = false>(
    options?: Options<PostReachOutSlotBookingData, ThrowOnError>
): RequestResult<unknown, PostReachOutSlotBookingErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostReachOutSlotBookingErrors, ThrowOnError>({ url: '/reach-out/slot-booking', ...options })

/**
 * GET /api/recordings/[recordingId]
 */
export const getRecordingsRecordingId = <ThrowOnError extends boolean = false>(
    options: Options<GetRecordingsRecordingIdData, ThrowOnError>
): RequestResult<unknown, GetRecordingsRecordingIdErrors, ThrowOnError> =>
    (options.client ?? client).get<unknown, GetRecordingsRecordingIdErrors, ThrowOnError>({ url: '/recordings/{recordingId}', ...options })

/**
 * POST handler for creating a Face Liveness Session (Phase 2).
 */
export const postRekognitionCreateSession = <ThrowOnError extends boolean = false>(
    options?: Options<PostRekognitionCreateSessionData, ThrowOnError>
): RequestResult<unknown, PostRekognitionCreateSessionErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostRekognitionCreateSessionErrors, ThrowOnError>({ url: '/rekognition/create-session', ...options })

/**
 * GET handler for retrieving Face Liveness Session Results (Phase 2).
 */
export const getRekognitionGetResultsSessionId = <ThrowOnError extends boolean = false>(
    options: Options<GetRekognitionGetResultsSessionIdData, ThrowOnError>
): RequestResult<unknown, GetRekognitionGetResultsSessionIdErrors, ThrowOnError> =>
    (options.client ?? client).get<unknown, GetRekognitionGetResultsSessionIdErrors, ThrowOnError>({ url: '/rekognition/get-results/{sessionId}', ...options })

export const postReportsExecute = <ThrowOnError extends boolean = false>(
    options?: Options<PostReportsExecuteData, ThrowOnError>
): RequestResult<PostReportsExecuteResponses, PostReportsExecuteErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostReportsExecuteResponses, PostReportsExecuteErrors, ThrowOnError>({
        responseType: 'json',
        url: '/reports/execute',
        ...options,
    })

export const getReportsTaTracker = <ThrowOnError extends boolean = false>(
    options?: Options<GetReportsTaTrackerData, ThrowOnError>
): RequestResult<unknown, GetReportsTaTrackerErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetReportsTaTrackerErrors, ThrowOnError>({ url: '/reports/ta-tracker', ...options })

export const getReportsConfigCompanyId = <ThrowOnError extends boolean = false>(
    options: Options<GetReportsConfigCompanyIdData, ThrowOnError>
): RequestResult<GetReportsConfigCompanyIdResponses, GetReportsConfigCompanyIdErrors, ThrowOnError> =>
    (options.client ?? client).get<GetReportsConfigCompanyIdResponses, GetReportsConfigCompanyIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/reports/config/{companyId}',
        ...options,
    })

export const postReportsConfigCompanyId = <ThrowOnError extends boolean = false>(
    options: Options<PostReportsConfigCompanyIdData, ThrowOnError>
): RequestResult<PostReportsConfigCompanyIdResponses, PostReportsConfigCompanyIdErrors, ThrowOnError> =>
    (options.client ?? client).post<PostReportsConfigCompanyIdResponses, PostReportsConfigCompanyIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/reports/config/{companyId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    })

/**
 * POST /api/screening-report/pdf — generate AI screening report PDF.
 */
export const postScreeningReportPdf = <ThrowOnError extends boolean = false>(
    options?: Options<PostScreeningReportPdfData, ThrowOnError>
): RequestResult<PostScreeningReportPdfResponses, PostScreeningReportPdfErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostScreeningReportPdfResponses, PostScreeningReportPdfErrors, ThrowOnError>({
        responseType: 'json',
        url: '/screening-report/pdf',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    })

export const postSendEmail = <ThrowOnError extends boolean = false>(
    options?: Options<PostSendEmailData, ThrowOnError>
): RequestResult<unknown, PostSendEmailErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostSendEmailErrors, ThrowOnError>({ url: '/send-email', ...options })

export const getSettingsCommunicationTemplates = <ThrowOnError extends boolean = false>(
    options?: Options<GetSettingsCommunicationTemplatesData, ThrowOnError>
): RequestResult<GetSettingsCommunicationTemplatesResponses, GetSettingsCommunicationTemplatesErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetSettingsCommunicationTemplatesResponses, GetSettingsCommunicationTemplatesErrors, ThrowOnError>({
        responseType: 'json',
        url: '/settings/communication-templates',
        ...options,
    })

export const postSettingsCommunicationTemplates = <ThrowOnError extends boolean = false>(
    options?: Options<PostSettingsCommunicationTemplatesData, ThrowOnError>
): RequestResult<PostSettingsCommunicationTemplatesResponses, PostSettingsCommunicationTemplatesErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostSettingsCommunicationTemplatesResponses, PostSettingsCommunicationTemplatesErrors, ThrowOnError>({
        responseTransformer: postSettingsCommunicationTemplatesResponseTransformer,
        responseType: 'json',
        url: '/settings/communication-templates',
        ...options,
    })

export const deleteSettingsCommunicationTemplatesId = <ThrowOnError extends boolean = false>(
    options: Options<DeleteSettingsCommunicationTemplatesIdData, ThrowOnError>
): RequestResult<DeleteSettingsCommunicationTemplatesIdResponses, DeleteSettingsCommunicationTemplatesIdErrors, ThrowOnError> =>
    (options.client ?? client).delete<DeleteSettingsCommunicationTemplatesIdResponses, DeleteSettingsCommunicationTemplatesIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/settings/communication-templates/{id}',
        ...options,
    })

export const getSettingsCommunicationTemplatesId = <ThrowOnError extends boolean = false>(
    options: Options<GetSettingsCommunicationTemplatesIdData, ThrowOnError>
): RequestResult<GetSettingsCommunicationTemplatesIdResponses, GetSettingsCommunicationTemplatesIdErrors, ThrowOnError> =>
    (options.client ?? client).get<GetSettingsCommunicationTemplatesIdResponses, GetSettingsCommunicationTemplatesIdErrors, ThrowOnError>({
        responseTransformer: getSettingsCommunicationTemplatesIdResponseTransformer,
        responseType: 'json',
        url: '/settings/communication-templates/{id}',
        ...options,
    })

export const putSettingsCommunicationTemplatesId = <ThrowOnError extends boolean = false>(
    options: Options<PutSettingsCommunicationTemplatesIdData, ThrowOnError>
): RequestResult<PutSettingsCommunicationTemplatesIdResponses, PutSettingsCommunicationTemplatesIdErrors, ThrowOnError> =>
    (options.client ?? client).put<PutSettingsCommunicationTemplatesIdResponses, PutSettingsCommunicationTemplatesIdErrors, ThrowOnError>({
        responseTransformer: putSettingsCommunicationTemplatesIdResponseTransformer,
        responseType: 'json',
        url: '/settings/communication-templates/{id}',
        ...options,
    })

export const postSettingsCommunicationTemplatesActivateDefault = <ThrowOnError extends boolean = false>(
    options?: Options<PostSettingsCommunicationTemplatesActivateDefaultData, ThrowOnError>
): RequestResult<PostSettingsCommunicationTemplatesActivateDefaultResponses, PostSettingsCommunicationTemplatesActivateDefaultErrors, ThrowOnError> =>
    (options?.client ?? client).post<
        PostSettingsCommunicationTemplatesActivateDefaultResponses,
        PostSettingsCommunicationTemplatesActivateDefaultErrors,
        ThrowOnError
    >({
        responseType: 'json',
        url: '/settings/communication-templates/activate-default',
        ...options,
    })

export const postSettingsCommunicationTemplatesPreview = <ThrowOnError extends boolean = false>(
    options?: Options<PostSettingsCommunicationTemplatesPreviewData, ThrowOnError>
): RequestResult<PostSettingsCommunicationTemplatesPreviewResponses, PostSettingsCommunicationTemplatesPreviewErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostSettingsCommunicationTemplatesPreviewResponses, PostSettingsCommunicationTemplatesPreviewErrors, ThrowOnError>({
        responseType: 'json',
        url: '/settings/communication-templates/preview',
        ...options,
    })

/**
 * Test API endpoint to send SSE_TEST_EVENT to all connected users
 */
export const getSseTest = <ThrowOnError extends boolean = false>(
    options?: Options<GetSseTestData, ThrowOnError>
): RequestResult<GetSseTestResponses, GetSseTestErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetSseTestResponses, GetSseTestErrors, ThrowOnError>({
        responseType: 'json',
        url: '/sse-test',
        ...options,
    })

/**
 * SSE route handler for real-time notifications
 */
export const getSseV2 = <ThrowOnError extends boolean = false>(
    options?: Options<GetSseV2Data, ThrowOnError>
): RequestResult<unknown, GetSseV2Errors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetSseV2Errors, ThrowOnError>({ url: '/sse-v2', ...options })

/**
 * GET /api/storage/access — mint a signed read URL for an existing storage object.
 *
 * Pass `fileUrl` (canonical object URL) to receive a short-lived signed access URL for inline reading. Uses the active storage provider (Azure or GCS). TTL follows provider defaults / env.
 */
export const getStorageAccess = <ThrowOnError extends boolean = false>(
    options: Options<GetStorageAccessData, ThrowOnError>
): RequestResult<GetStorageAccessResponses, GetStorageAccessErrors, ThrowOnError> =>
    (options.client ?? client).get<GetStorageAccessResponses, GetStorageAccessErrors, ThrowOnError>({
        responseType: 'json',
        url: '/storage/access',
        ...options,
    })

/**
 * GET /api/storage/upload — mint signed upload credentials for browser/server PUT.
 *
 * Pass `containerName` + `blobName` (optional `contentType`) to receive `uploadUrl` + `fileUrl`. Uses the active storage provider (Azure or GCS). TTL follows provider defaults / env.
 */
export const getStorageUpload = <ThrowOnError extends boolean = false>(
    options: Options<GetStorageUploadData, ThrowOnError>
): RequestResult<GetStorageUploadResponses, GetStorageUploadErrors, ThrowOnError> =>
    (options.client ?? client).get<GetStorageUploadResponses, GetStorageUploadErrors, ThrowOnError>({
        responseType: 'json',
        url: '/storage/upload',
        ...options,
    })

export const postTemporalCandidate = <ThrowOnError extends boolean = false>(
    options?: Options<PostTemporalCandidateData, ThrowOnError>
): RequestResult<unknown, PostTemporalCandidateErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostTemporalCandidateErrors, ThrowOnError>({ url: '/temporal/candidate', ...options })

export const getTemporalCheatDetectionConfig = <ThrowOnError extends boolean = false>(
    options?: Options<GetTemporalCheatDetectionConfigData, ThrowOnError>
): RequestResult<unknown, GetTemporalCheatDetectionConfigErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetTemporalCheatDetectionConfigErrors, ThrowOnError>({ url: '/temporal/cheat-detection-config', ...options })

export const postTemporalCommunicationStatus = <ThrowOnError extends boolean = false>(
    options?: Options<PostTemporalCommunicationStatusData, ThrowOnError>
): RequestResult<unknown, PostTemporalCommunicationStatusErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostTemporalCommunicationStatusErrors, ThrowOnError>({ url: '/temporal/communication-status', ...options })

/**
 * GET /api/temporal/hi_questions?job_application_id={id}
 */
export const getTemporalHiQuestions = <ThrowOnError extends boolean = false>(
    options?: Options<GetTemporalHiQuestionsData, ThrowOnError>
): RequestResult<GetTemporalHiQuestionsResponses, GetTemporalHiQuestionsErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetTemporalHiQuestionsResponses, GetTemporalHiQuestionsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/temporal/hi_questions',
        ...options,
    })

/**
 * GET /api/temporal/integrations?companyId=123&type=whatsapp[&integrationId=…]
 */
export const getTemporalIntegrations = <ThrowOnError extends boolean = false>(
    options?: Options<GetTemporalIntegrationsData, ThrowOnError>
): RequestResult<GetTemporalIntegrationsResponses, GetTemporalIntegrationsErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetTemporalIntegrationsResponses, GetTemporalIntegrationsErrors, ThrowOnError>({
        responseTransformer: getTemporalIntegrationsResponseTransformer,
        responseType: 'json',
        url: '/temporal/integrations',
        ...options,
    })

/**
 * GET /api/temporal/screening-call?id={screening_call_id}
 */
export const getTemporalScreeningCall = <ThrowOnError extends boolean = false>(
    options?: Options<GetTemporalScreeningCallData, ThrowOnError>
): RequestResult<GetTemporalScreeningCallResponses, GetTemporalScreeningCallErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetTemporalScreeningCallResponses, GetTemporalScreeningCallErrors, ThrowOnError>({
        responseTransformer: getTemporalScreeningCallResponseTransformer,
        responseType: 'json',
        url: '/temporal/screening-call',
        ...options,
    })

/**
 * PUT /api/temporal/screening-call
 */
export const putTemporalScreeningCall = <ThrowOnError extends boolean = false>(
    options?: Options<PutTemporalScreeningCallData, ThrowOnError>
): RequestResult<PutTemporalScreeningCallResponses, PutTemporalScreeningCallErrors, ThrowOnError> =>
    (options?.client ?? client).put<PutTemporalScreeningCallResponses, PutTemporalScreeningCallErrors, ThrowOnError>({
        responseTransformer: putTemporalScreeningCallResponseTransformer,
        responseType: 'json',
        url: '/temporal/screening-call',
        ...options,
    })

/**
 * GET /api/temporal/screening-interview?id={screening_interview_id}
 */
export const getTemporalScreeningInterview = <ThrowOnError extends boolean = false>(
    options?: Options<GetTemporalScreeningInterviewData, ThrowOnError>
): RequestResult<GetTemporalScreeningInterviewResponses, GetTemporalScreeningInterviewErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetTemporalScreeningInterviewResponses, GetTemporalScreeningInterviewErrors, ThrowOnError>({
        responseType: 'json',
        url: '/temporal/screening-interview',
        ...options,
    })

/**
 * POST /api/temporal/workshorts
 */
export const postTemporalWorkshorts = <ThrowOnError extends boolean = false>(
    options?: Options<PostTemporalWorkshortsData, ThrowOnError>
): RequestResult<PostTemporalWorkshortsResponses, PostTemporalWorkshortsErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostTemporalWorkshortsResponses, PostTemporalWorkshortsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/temporal/workshorts',
        ...options,
    })

export const getTemporalJobApplicationsId = <ThrowOnError extends boolean = false>(
    options: Options<GetTemporalJobApplicationsIdData, ThrowOnError>
): RequestResult<GetTemporalJobApplicationsIdResponses, GetTemporalJobApplicationsIdErrors, ThrowOnError> =>
    (options.client ?? client).get<GetTemporalJobApplicationsIdResponses, GetTemporalJobApplicationsIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/temporal/jobApplications/{id}',
        ...options,
    })

export const putTemporalJobApplicationsId = <ThrowOnError extends boolean = false>(
    options: Options<PutTemporalJobApplicationsIdData, ThrowOnError>
): RequestResult<PutTemporalJobApplicationsIdResponses, PutTemporalJobApplicationsIdErrors, ThrowOnError> =>
    (options.client ?? client).put<PutTemporalJobApplicationsIdResponses, PutTemporalJobApplicationsIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/temporal/jobApplications/{id}',
        ...options,
    })

export const getTemporalJobApplicationsStatus = <ThrowOnError extends boolean = false>(
    options?: Options<GetTemporalJobApplicationsStatusData, ThrowOnError>
): RequestResult<GetTemporalJobApplicationsStatusResponses, GetTemporalJobApplicationsStatusErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetTemporalJobApplicationsStatusResponses, GetTemporalJobApplicationsStatusErrors, ThrowOnError>({
        responseType: 'json',
        url: '/temporal/jobApplications/status',
        ...options,
    })

export const getTemporalJobsId = <ThrowOnError extends boolean = false>(
    options: Options<GetTemporalJobsIdData, ThrowOnError>
): RequestResult<GetTemporalJobsIdResponses, GetTemporalJobsIdErrors, ThrowOnError> =>
    (options.client ?? client).get<GetTemporalJobsIdResponses, GetTemporalJobsIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/temporal/jobs/{id}',
        ...options,
    })

/**
 * POST /api/temporal/screening-call/objective-evaluations — talent-ai stores its verdicts on a phone screening's objective questions.
 *
 * M2M (Bearer). Replaces `ScreeningCall.objectiveEvaluations` (idempotent, latest wins). A phone attempt id (`attempt-{callId}-{n}-…`) that is not the call's current attempt returns 200 with `ignored: true`; any other id (e.g. a scoring workflow id) is stored. 404 when the call doesn't exist.
 */
export const postTemporalScreeningCallObjectiveEvaluations = <ThrowOnError extends boolean = false>(
    options?: Options<PostTemporalScreeningCallObjectiveEvaluationsData, ThrowOnError>
): RequestResult<PostTemporalScreeningCallObjectiveEvaluationsResponses, PostTemporalScreeningCallObjectiveEvaluationsErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostTemporalScreeningCallObjectiveEvaluationsResponses, PostTemporalScreeningCallObjectiveEvaluationsErrors, ThrowOnError>(
        {
            responseType: 'json',
            url: '/temporal/screening-call/objective-evaluations',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
            },
        }
    )

/**
 * GET API for fetching user data and initializing user-department relationships
 */
export const getUserData = <ThrowOnError extends boolean = false>(
    options?: Options<GetUserDataData, ThrowOnError>
): RequestResult<unknown, GetUserDataErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetUserDataErrors, ThrowOnError>({ url: '/user-data', ...options })

/**
 * Handles Azure Event Grid validation requests
 */
export const getWebhooksAzureEmail = <ThrowOnError extends boolean = false>(
    options?: Options<GetWebhooksAzureEmailData, ThrowOnError>
): RequestResult<unknown, GetWebhooksAzureEmailErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetWebhooksAzureEmailErrors, ThrowOnError>({ url: '/webhooks/azure-email', ...options })

/**
 * Handles Azure Communication Services email delivery events
 */
export const postWebhooksAzureEmail = <ThrowOnError extends boolean = false>(
    options?: Options<PostWebhooksAzureEmailData, ThrowOnError>
): RequestResult<unknown, PostWebhooksAzureEmailErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostWebhooksAzureEmailErrors, ThrowOnError>({ url: '/webhooks/azure-email', ...options })

/**
 * Handles webhook events from Daily.co
 */
export const postWebhooksDaily = <ThrowOnError extends boolean = false>(
    options?: Options<PostWebhooksDailyData, ThrowOnError>
): RequestResult<unknown, PostWebhooksDailyErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostWebhooksDailyErrors, ThrowOnError>({ url: '/webhooks/daily', ...options })

/**
 * Microsoft Graph validation can come as GET with ?validationToken=...
 */
export const getWebhooksGraph = <ThrowOnError extends boolean = false>(
    options?: Options<GetWebhooksGraphData, ThrowOnError>
): RequestResult<GetWebhooksGraphResponses, GetWebhooksGraphErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetWebhooksGraphResponses, GetWebhooksGraphErrors, ThrowOnError>({
        responseType: 'json',
        url: '/webhooks/graph',
        ...options,
    })

export const postWebhooksGraph = <ThrowOnError extends boolean = false>(
    options?: Options<PostWebhooksGraphData, ThrowOnError>
): RequestResult<PostWebhooksGraphResponses, PostWebhooksGraphErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostWebhooksGraphResponses, PostWebhooksGraphErrors, ThrowOnError>({
        responseType: 'json',
        url: '/webhooks/graph',
        ...options,
    })

export const getWebhooksPlivoWhatsapp = <ThrowOnError extends boolean = false>(
    options?: Options<GetWebhooksPlivoWhatsappData, ThrowOnError>
): RequestResult<unknown, GetWebhooksPlivoWhatsappErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetWebhooksPlivoWhatsappErrors, ThrowOnError>({ url: '/webhooks/plivo-whatsapp', ...options })

/**
 * POST /api/webhooks/plivo-whatsapp
 */
export const postWebhooksPlivoWhatsapp = <ThrowOnError extends boolean = false>(
    options?: Options<PostWebhooksPlivoWhatsappData, ThrowOnError>
): RequestResult<unknown, PostWebhooksPlivoWhatsappErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostWebhooksPlivoWhatsappErrors, ThrowOnError>({ url: '/webhooks/plivo-whatsapp', ...options })

/**
 * Handles Resend email delivery events
 */
export const postWebhooksResendEmail = <ThrowOnError extends boolean = false>(
    options?: Options<PostWebhooksResendEmailData, ThrowOnError>
): RequestResult<unknown, PostWebhooksResendEmailErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostWebhooksResendEmailErrors, ThrowOnError>({ url: '/webhooks/resend-email', ...options })

/**
 * POST /api/webhooks/stripe
 */
export const postWebhooksStripe = <ThrowOnError extends boolean = false>(
    options?: Options<PostWebhooksStripeData, ThrowOnError>
): RequestResult<PostWebhooksStripeResponses, PostWebhooksStripeErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostWebhooksStripeResponses, PostWebhooksStripeErrors, ThrowOnError>({
        responseType: 'json',
        url: '/webhooks/stripe',
        ...options,
    })

export const getWebhooksTwilioWhatsapp = <ThrowOnError extends boolean = false>(
    options?: Options<GetWebhooksTwilioWhatsappData, ThrowOnError>
): RequestResult<unknown, GetWebhooksTwilioWhatsappErrors, ThrowOnError> =>
    (options?.client ?? client).get<unknown, GetWebhooksTwilioWhatsappErrors, ThrowOnError>({ url: '/webhooks/twilio-whatsapp', ...options })

export const postWebhooksTwilioWhatsapp = <ThrowOnError extends boolean = false>(
    options?: Options<PostWebhooksTwilioWhatsappData, ThrowOnError>
): RequestResult<unknown, PostWebhooksTwilioWhatsappErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostWebhooksTwilioWhatsappErrors, ThrowOnError>({ url: '/webhooks/twilio-whatsapp', ...options })

/**
 * Microsoft Graph validation can come as GET with ?validationToken=...
 */
export const getWebhooksGraphTranscript = <ThrowOnError extends boolean = false>(
    options?: Options<GetWebhooksGraphTranscriptData, ThrowOnError>
): RequestResult<GetWebhooksGraphTranscriptResponses, GetWebhooksGraphTranscriptErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetWebhooksGraphTranscriptResponses, GetWebhooksGraphTranscriptErrors, ThrowOnError>({
        responseType: 'json',
        url: '/webhooks/graph/transcript',
        ...options,
    })

export const postWebhooksGraphTranscript = <ThrowOnError extends boolean = false>(
    options?: Options<PostWebhooksGraphTranscriptData, ThrowOnError>
): RequestResult<PostWebhooksGraphTranscriptResponses, PostWebhooksGraphTranscriptErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostWebhooksGraphTranscriptResponses, PostWebhooksGraphTranscriptErrors, ThrowOnError>({
        responseType: 'json',
        url: '/webhooks/graph/transcript',
        ...options,
    })

/**
 * POST /api/webhooks/plivo/recording
 */
export const postWebhooksPlivoRecording = <ThrowOnError extends boolean = false>(
    options?: Options<PostWebhooksPlivoRecordingData, ThrowOnError>
): RequestResult<PostWebhooksPlivoRecordingResponses, PostWebhooksPlivoRecordingErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostWebhooksPlivoRecordingResponses, PostWebhooksPlivoRecordingErrors, ThrowOnError>({
        responseType: 'json',
        url: '/webhooks/plivo/recording',
        ...options,
    })

/**
 * GET /api/webhooks/plivo/voice — liveness check for the Plivo voice webhook.
 */
export const getWebhooksPlivoVoice = <ThrowOnError extends boolean = false>(
    options?: Options<GetWebhooksPlivoVoiceData, ThrowOnError>
): RequestResult<GetWebhooksPlivoVoiceResponses, GetWebhooksPlivoVoiceErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetWebhooksPlivoVoiceResponses, GetWebhooksPlivoVoiceErrors, ThrowOnError>({
        responseType: 'json',
        url: '/webhooks/plivo/voice',
        ...options,
    })

/**
 * POST /api/webhooks/plivo/voice
 */
export const postWebhooksPlivoVoice = <ThrowOnError extends boolean = false>(
    options?: Options<PostWebhooksPlivoVoiceData, ThrowOnError>
): RequestResult<PostWebhooksPlivoVoiceResponses, PostWebhooksPlivoVoiceErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostWebhooksPlivoVoiceResponses, PostWebhooksPlivoVoiceErrors, ThrowOnError>({
        responseType: 'json',
        url: '/webhooks/plivo/voice',
        ...options,
    })

/**
 * POST /api/webhooks/twilio/recording
 */
export const postWebhooksTwilioRecording = <ThrowOnError extends boolean = false>(
    options?: Options<PostWebhooksTwilioRecordingData, ThrowOnError>
): RequestResult<PostWebhooksTwilioRecordingResponses, PostWebhooksTwilioRecordingErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostWebhooksTwilioRecordingResponses, PostWebhooksTwilioRecordingErrors, ThrowOnError>({
        responseType: 'json',
        url: '/webhooks/twilio/recording',
        ...options,
    })

/**
 * POST /api/webhooks/twilio/voice
 */
export const postWebhooksTwilioVoice = <ThrowOnError extends boolean = false>(
    options?: Options<PostWebhooksTwilioVoiceData, ThrowOnError>
): RequestResult<PostWebhooksTwilioVoiceResponses, PostWebhooksTwilioVoiceErrors, ThrowOnError> =>
    (options?.client ?? client).post<PostWebhooksTwilioVoiceResponses, PostWebhooksTwilioVoiceErrors, ThrowOnError>({
        responseType: 'json',
        url: '/webhooks/twilio/voice',
        ...options,
    })

/**
 * Aggregated screening JWKS — public keys for Talent Web and Talent AI
 */
export const getWellKnownScreeningJwks = <ThrowOnError extends boolean = false>(
    options?: Options<GetWellKnownScreeningJwksData, ThrowOnError>
): RequestResult<GetWellKnownScreeningJwksResponses, GetWellKnownScreeningJwksErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetWellKnownScreeningJwksResponses, GetWellKnownScreeningJwksErrors, ThrowOnError>({
        responseType: 'json',
        url: '/well-known/screening-jwks',
        ...options,
    })

/**
 * GET call which is initiated by a recruiter to send a job to an applicant. This creates the initial whatsapphistory record.
 */
export const getWhatsapp = <ThrowOnError extends boolean = false>(
    options?: Options<GetWhatsappData, ThrowOnError>
): RequestResult<GetWhatsappResponses, GetWhatsappErrors, ThrowOnError> =>
    (options?.client ?? client).get<GetWhatsappResponses, GetWhatsappErrors, ThrowOnError>({
        responseType: 'json',
        url: '/whatsapp',
        ...options,
    })

/**
 * POST call typically triggered by the user replying to the whatsapp message. This will go through a workflow and create an application if applicable.
 */
export const postWhatsapp = <ThrowOnError extends boolean = false>(
    options?: Options<PostWhatsappData, ThrowOnError>
): RequestResult<unknown, PostWhatsappErrors, ThrowOnError> =>
    (options?.client ?? client).post<unknown, PostWhatsappErrors, ThrowOnError>({ url: '/whatsapp', ...options })

/**
 * GET call which is initiated by a recruiter to send a job to an applicant. This creates the initial whatsapphistory record.
 */
export const getWhatsappCompanySlug = <ThrowOnError extends boolean = false>(
    options: Options<GetWhatsappCompanySlugData, ThrowOnError>
): RequestResult<GetWhatsappCompanySlugResponses, GetWhatsappCompanySlugErrors, ThrowOnError> =>
    (options.client ?? client).get<GetWhatsappCompanySlugResponses, GetWhatsappCompanySlugErrors, ThrowOnError>({
        responseType: 'json',
        url: '/whatsapp/{companySlug}',
        ...options,
    })

/**
 * POST call typically triggered by the user replying to the whatsapp message. This will go through a workflow and create an application if applicable.
 */
export const postWhatsappCompanySlug = <ThrowOnError extends boolean = false>(
    options: Options<PostWhatsappCompanySlugData, ThrowOnError>
): RequestResult<unknown, PostWhatsappCompanySlugErrors, ThrowOnError> =>
    (options.client ?? client).post<unknown, PostWhatsappCompanySlugErrors, ThrowOnError>({ url: '/whatsapp/{companySlug}', ...options })
